/* eslint-disable */
/* AUTO GENERATED BY 'yarn i18n' COMMAND */

export const LF = {
    AMICFleetCard: "AMICFleetCard",
    AboveTwentySixYears: "AboveTwentySixYears",
    AcceptedForPosting: "AcceptedForPosting",
    AcceptedRegulationsAboutRentingInPoland: "AcceptedRegulationsAboutRentingInPoland",
    AccessPermissions: "AccessPermissions",
    AccessToAuditArea: "AccessToAuditArea",
    AccessToDeleteDrivers: "AccessToDeleteDrivers",
    AccessToExportSettlements: "AccessToExportSettlements",
    AccessToImportPayoffs: "AccessToImportPayoffs",
    AccessToImportSettlements: "AccessToImportSettlements",
    AccessToMarkPaymentsAsFinished: "AccessToMarkPaymentsAsFinished",
    AccessToMassSettlementDelete: "AccessToMassSettlementDelete",
    AccessToMassSettlementsEmailSend: "AccessToMassSettlementsEmailSend",
    AccessToModifyPetrolGross: "AccessToModifyPetrolGross",
    AccessToModifySettlementsApplicationsData: "AccessToModifySettlementsApplicationsData",
    AccessToSetSettlementsManualEdit: "AccessToSetSettlementsManualEdit",
    AccountCommission: "AccountCommission",
    Activate: "Activate",
    Active: "Active",
    ActiveAndNotWorkingFromFourDays: "ActiveAndNotWorkingFromFourDays",
    ActiveAndNotWorkingUpToThreeDays: "ActiveAndNotWorkingUpToThreeDays",
    ActiveBusy: "ActiveBusy",
    ActiveDate: "ActiveDate",
    ActiveFree: "ActiveFree",
    ActiveInSII: "ActiveInSII",
    ActivePayoutCurrentMonth: "ActivePayoutCurrentMonth",
    ActivePayoutCurrentMonthTagDescription: "ActivePayoutCurrentMonthTagDescription",
    ActivePayoutPreviousMonth: "ActivePayoutPreviousMonth",
    ActivePayoutPreviousMonthTagDescription: "ActivePayoutPreviousMonthTagDescription",
    ActiveStatusDescription: "ActiveStatusDescription",
    ActiveTagDescription: "ActiveTagDescription",
    Actives: "Actives",
    ActivityStatus: "ActivityStatus",
    Actual: "Actual",
    ActualIncome: "ActualIncome",
    Add: "Add",
    AddAdvancePaymentPayoff: "AddAdvancePaymentPayoff",
    AddApplication: "AddApplication",
    AddApplicationAccount: "AddApplicationAccount",
    AddArticle: "AddArticle",
    AddAtLeastOnePhotoBeforeContinue: "AddAtLeastOnePhotoBeforeContinue",
    AddCampaign: "AddCampaign",
    AddCashFlow: "AddCashFlow",
    AddCondition: "AddCondition",
    AddCourse: "AddCourse",
    AddDayOffPayoff: "AddDayOffPayoff",
    AddDefect: "AddDefect",
    AddDriver: "AddDriver",
    AddFile: "AddFile",
    AddGroup: "AddGroup",
    AddIcon: "AddIcon",
    AddIncident: "AddIncident",
    AddIncidentOfTypeItsNotAllowedFromVehicleForm: "AddIncidentOfTypeItsNotAllowedFromVehicleForm",
    AddInviteProgram: "AddInviteProgram",
    AddNewIconSchema: "AddNewIconSchema",
    AddPayoff: "AddPayoff",
    AddPhoto: "AddPhoto",
    AddPhotoOfDefect: "AddPhotoOfDefect",
    AddReasonForStatusTagTitle: "AddReasonForStatusTagTitle",
    AddReferral: "AddReferral",
    AddRewardPackage: "AddRewardPackage",
    AddSettlement: "AddSettlement",
    AddSiiPayoffs: "AddSiiPayoffs",
    AddTaxOffice: "AddTaxOffice",
    AddTaxOfficeDescription: "AddTaxOfficeDescription",
    AddToMyDriverList: "AddToMyDriverList",
    AddToMyDriverListDescription: "AddToMyDriverListDescription",
    AddToNote: "AddToNote",
    AddToStatisticsAsBezproblemTransportCommission: "AddToStatisticsAsBezproblemTransportCommission",
    AddToStatisticsAsRavapiTransportCommission: "AddToStatisticsAsRavapiTransportCommission",
    AddVehicle: "AddVehicle",
    AddVehicleConditionPhoto: "AddVehicleConditionPhoto",
    AddYourOwn: "AddYourOwn",
    AddedOneDriverToUserDriverListSuccessfully: "AddedOneDriverToUserDriverListSuccessfully",
    AddedToUserDriverListSuccessfully: "AddedToUserDriverListSuccessfully",
    AddingVehiclePhotos: "AddingVehiclePhotos",
    Addition: "Addition",
    Additional: "Additional",
    AdditionalDate: "AdditionalDate",
    AdditionalFiltersSection: "AdditionalFiltersSection",
    AdditionalInformations: "AdditionalInformations",
    AdditionalTownFees: "AdditionalTownFees",
    AdditionalWaitingTimeForStudentCard: "AdditionalWaitingTimeForStudentCard",
    AdditionallySpecifyWhetherAPaymentLinkShouldBeAttachedToTheRequestMail: "AdditionallySpecifyWhetherAPaymentLinkShouldBeAttachedToTheRequestMail",
    AdditionsList: "AdditionsList",
    AdditionsNumberAndAmount: "AdditionsNumberAndAmount",
    Address: "Address",
    AdjustColumns: "AdjustColumns",
    AdjustCommissions: "AdjustCommissions",
    Administrator: "Administrator",
    AdvanceAndTransportFeeCannotBeBothSelected: "AdvanceAndTransportFeeCannotBeBothSelected",
    AdvancePaymentBank: "AdvancePaymentBank",
    AdvancePaymentCash: "AdvancePaymentCash",
    AdvancePaymentLimitAmount: "AdvancePaymentLimitAmount",
    AdvancePaymentTransfer: "AdvancePaymentTransfer",
    AdvancePaymentType: "AdvancePaymentType",
    AdvancePayoffPaymentType: "AdvancePayoffPaymentType",
    Advances: "Advances",
    AfterReportCreated: "AfterReportCreated",
    AfterSelectSaveButtonSystemAutomaticallyUpdateDriverSubject: "AfterSelectSaveButtonSystemAutomaticallyUpdateDriverSubject",
    Age: "Age",
    AiAssistantConfigurationNotFound: "AiAssistantConfigurationNotFound",
    AiAssistantEnabled: "AiAssistantEnabled",
    AiAssistantSettings: "AiAssistantSettings",
    AiClassificationConfidenceThreshold: "AiClassificationConfidenceThreshold",
    AiConfigurationTab: "AiConfigurationTab",
    AiDialogsPerDriverPerDay: "AiDialogsPerDriverPerDay",
    AiDialogsPerDriverPerHour: "AiDialogsPerDriverPerHour",
    AiIsDriverDataAccessEnabled: "AiIsDriverDataAccessEnabled",
    AiIsEnabled: "AiIsEnabled",
    AiKnowledgeArticle: "AiKnowledgeArticle",
    AiKnowledgeArticleCategory: "AiKnowledgeArticleCategory",
    AiKnowledgeArticleColumn: "AiKnowledgeArticleColumn",
    AiKnowledgeArticleContent: "AiKnowledgeArticleContent",
    AiKnowledgeArticleDescription: "AiKnowledgeArticleDescription",
    AiKnowledgeArticleKeywords: "AiKnowledgeArticleKeywords",
    AiKnowledgeArticleNotFound: "AiKnowledgeArticleNotFound",
    AiKnowledgeArticleTitle: "AiKnowledgeArticleTitle",
    AiKnowledgeBaseTab: "AiKnowledgeBaseTab",
    AiKnowledgeFragmentNotPrepared: "AiKnowledgeFragmentNotPrepared",
    AiKnowledgeFragmentParagraphChanged: "AiKnowledgeFragmentParagraphChanged",
    AiKnowledgeObservationAlreadyCovered: "AiKnowledgeObservationAlreadyCovered",
    AiKnowledgeObservationApproved: "AiKnowledgeObservationApproved",
    AiKnowledgeObservationCollecting: "AiKnowledgeObservationCollecting",
    AiKnowledgeObservationExpired: "AiKnowledgeObservationExpired",
    AiKnowledgeObservationProposed: "AiKnowledgeObservationProposed",
    AiKnowledgeObservationRejected: "AiKnowledgeObservationRejected",
    AiKnowledgeObservationText: "AiKnowledgeObservationText",
    AiKnowledgeProposalApproved: "AiKnowledgeProposalApproved",
    AiKnowledgeProposalApprovedWithChanges: "AiKnowledgeProposalApprovedWithChanges",
    AiKnowledgeProposalChangeAppend: "AiKnowledgeProposalChangeAppend",
    AiKnowledgeProposalChangeDescription: "AiKnowledgeProposalChangeDescription",
    AiKnowledgeProposalChangeInsertAfter: "AiKnowledgeProposalChangeInsertAfter",
    AiKnowledgeProposalChangeKeywords: "AiKnowledgeProposalChangeKeywords",
    AiKnowledgeProposalChangeReplace: "AiKnowledgeProposalChangeReplace",
    AiKnowledgeProposalJustification: "AiKnowledgeProposalJustification",
    AiKnowledgeProposalNotFound: "AiKnowledgeProposalNotFound",
    AiKnowledgeProposalNotPending: "AiKnowledgeProposalNotPending",
    AiKnowledgeProposalParagraphChanged: "AiKnowledgeProposalParagraphChanged",
    AiKnowledgeProposalPending: "AiKnowledgeProposalPending",
    AiKnowledgeProposalRejected: "AiKnowledgeProposalRejected",
    AiKnowledgeProposalsTab: "AiKnowledgeProposalsTab",
    AiKnowledgeRuleAlreadyInArticle: "AiKnowledgeRuleAlreadyInArticle",
    AiKnowledgeSuggestionsUnavailable: "AiKnowledgeSuggestionsUnavailable",
    AiMaxClarificationAttempts: "AiMaxClarificationAttempts",
    AiMaxOutputTokens: "AiMaxOutputTokens",
    AiModel: "AiModel",
    AiMonthlyBudget: "AiMonthlyBudget",
    All: "All",
    AllBulbsWorkingQuestion: "AllBulbsWorkingQuestion",
    AllDrivers: "AllDrivers",
    AllDriversDescription: "AllDriversDescription",
    AllDriversIn: "AllDriversIn",
    AllOrNothing: "AllOrNothing",
    AllOverdueReportsAreSent: "AllOverdueReportsAreSent",
    AllSettlementsMustBeApproved: "AllSettlementsMustBeApproved",
    AllVehiclesMustBeOnDayOffPromotionAndCannotBeOwnedByDriver: "AllVehiclesMustBeOnDayOffPromotionAndCannotBeOwnedByDriver",
    AllWaitingSettlementsWasApproved: "AllWaitingSettlementsWasApproved",
    AllowFullSocialInsurance: "AllowFullSocialInsurance",
    AllowMinimalSocialInsurance: "AllowMinimalSocialInsurance",
    AllowOtherSocialInsurance: "AllowOtherSocialInsurance",
    AmountOfDriversInSystem: "AmountOfDriversInSystem",
    And: "And",
    Annuitant: "Annuitant",
    AnnuitantCard: "AnnuitantCard",
    AnyVehicle: "AnyVehicle",
    Appeal: "Appeal",
    Application: "Application",
    ApplicationAccount: "ApplicationAccount",
    ApplicationAccountAccess: "ApplicationAccountAccess",
    ApplicationAccountCreate: "ApplicationAccountCreate",
    ApplicationAccountDelete: "ApplicationAccountDelete",
    ApplicationAccountDeleteMessage: "ApplicationAccountDeleteMessage",
    ApplicationAccountDriverPaymentTypeAssigned: "ApplicationAccountDriverPaymentTypeAssigned",
    ApplicationAccountEdit: "ApplicationAccountEdit",
    ApplicationAccountNameOrPhoneNumber: "ApplicationAccountNameOrPhoneNumber",
    ApplicationAccountNotFound: "ApplicationAccountNotFound",
    ApplicationAccountPaymentTypeIsNotDailySkipping: "ApplicationAccountPaymentTypeIsNotDailySkipping",
    ApplicationAccountPaymentTypeIsNotWeeklySkipping: "ApplicationAccountPaymentTypeIsNotWeeklySkipping",
    ApplicationAccountPaymentTypeMessage: "ApplicationAccountPaymentTypeMessage",
    ApplicationAccounts: "ApplicationAccounts",
    ApplicationAccountsRented: "ApplicationAccountsRented",
    ApplicationAccountsReturned: "ApplicationAccountsReturned",
    ApplicationAccountsStatisticAlert: "ApplicationAccountsStatisticAlert",
    ApplicationCommissionGross: "ApplicationCommissionGross",
    ApplicationNumber: "ApplicationNumber",
    ApplicationSumTotal: "ApplicationSumTotal",
    ApplicationType: "ApplicationType",
    Applications: "Applications",
    ApplicationsData: "ApplicationsData",
    ApplicationsDataSettlementFormDescription: "ApplicationsDataSettlementFormDescription",
    ApplicationsExitQuota: "ApplicationsExitQuota",
    ApplicationsMinuses: "ApplicationsMinuses",
    ApplicationsNetBonuses: "ApplicationsNetBonuses",
    ApplicationsQuotaGross: "ApplicationsQuotaGross",
    AppliesToDay: "AppliesToDay",
    AppliesToDriver: "AppliesToDriver",
    AppliesToVehicle: "AppliesToVehicle",
    Apply: "Apply",
    ApplyAdvanceFromQuota: "ApplyAdvanceFromQuota",
    ApplyFilters: "ApplyFilters",
    ApplyFiltersReportListDescription: "ApplyFiltersReportListDescription",
    AppointmentTime: "AppointmentTime",
    Approve: "Approve",
    ApproveCollectVehicle: "ApproveCollectVehicle",
    ApproveReservation: "ApproveReservation",
    ApproveSelected: "ApproveSelected",
    Approved: "Approved",
    ApprovedBy: "ApprovedBy",
    ApprovedDate: "ApprovedDate",
    ApprovedSettlementListDescription: "ApprovedSettlementListDescription",
    ApproximatedTaxPerMonth: "ApproximatedTaxPerMonth",
    AreAccountsActiveInSelectedApps: "AreAccountsActiveInSelectedApps",
    AreAlreadyAssignedToVehicle: "AreAlreadyAssignedToVehicle",
    AreYouSureToDisableManualEdit: "AreYouSureToDisableManualEdit",
    AreYouSureYouWantToConfirmContactWithDriver: "AreYouSureYouWantToConfirmContactWithDriver",
    AreaFieldHasInvalidValue: "AreaFieldHasInvalidValue",
    Areas: "Areas",
    ArrangementsChange: "ArrangementsChange",
    ArticleDetails: "ArticleDetails",
    ArticleGroup: "ArticleGroup",
    ArticleGroupDoesNotExist: "ArticleGroupDoesNotExist",
    ArticleNotFound: "ArticleNotFound",
    ArticleTitle: "ArticleTitle",
    Articles: "Articles",
    AsMuchAsPossible: "AsMuchAsPossible",
    AsksFor: "AsksFor",
    Assets: "Assets",
    AssetsStatisticAlert: "AssetsStatisticAlert",
    AssetsTotal: "AssetsTotal",
    AssignDriversPaymentType: "AssignDriversPaymentType",
    AssignPaymentTypeToAllDriversApplicationAccounts: "AssignPaymentTypeToAllDriversApplicationAccounts",
    AssignedAt: "AssignedAt",
    AssignedDriver: "AssignedDriver",
    AssignedTo: "AssignedTo",
    AssignedVehicle: "AssignedVehicle",
    AssistantBudgetReservePercent: "AssistantBudgetReservePercent",
    AtLeastOneLowercase: "AtLeastOneLowercase",
    AtLeastOneNumber: "AtLeastOneNumber",
    AtLeastOneSpecialCharacter: "AtLeastOneSpecialCharacter",
    AtLeastOneUppercase: "AtLeastOneUppercase",
    AtLeastPolishMessageShouldBeFilled: "AtLeastPolishMessageShouldBeFilled",
    AttachmentSend: "AttachmentSend",
    Attention: "Attention",
    AttentionRequired: "AttentionRequired",
    AttentionRequiredSettlementFormDescription: "AttentionRequiredSettlementFormDescription",
    Audit: "Audit",
    AuthorizationErrorDescription: "AuthorizationErrorDescription",
    AuthorizationStatement: "AuthorizationStatement",
    AutoAssignTaxOfficeDrivers: "AutoAssignTaxOfficeDrivers",
    AutoAssignTaxOfficeDriversMailTypeInfo: "AutoAssignTaxOfficeDriversMailTypeInfo",
    AutoSettlements: "AutoSettlements",
    AutomaticTag: "AutomaticTag",
    AutomaticTags: "AutomaticTags",
    AutomaticTagsInclude: "AutomaticTagsInclude",
    AutomaticTagsShortDescription: "AutomaticTagsShortDescription",
    Available: "Available",
    AvailableCash: "AvailableCash",
    AvailableColumns: "AvailableColumns",
    AvailableDocumentsToSign: "AvailableDocumentsToSign",
    AvailableFilters: "AvailableFilters",
    AvailableValues: "AvailableValues",
    AverageAmountToWithdraw: "AverageAmountToWithdraw",
    AverageDriversEarningsWithPayoffs: "AverageDriversEarningsWithPayoffs",
    AverageDriversEarningsWithPayoffsTooltip: "AverageDriversEarningsWithPayoffsTooltip",
    AverageDriversEarningsWithoutPayoffs: "AverageDriversEarningsWithoutPayoffs",
    AverageDriversEarningsWithoutPayoffsTooltip: "AverageDriversEarningsWithoutPayoffsTooltip",
    AverageDriversScore: "AverageDriversScore",
    AverageDriversWorkingTime: "AverageDriversWorkingTime",
    AverageDriversWorkingTimeTooltip: "AverageDriversWorkingTimeTooltip",
    B2BContract: "B2BContract",
    B2BFloviContract: "B2BFloviContract",
    B2BPaymentCanOnlyBeCreatedInPolandWorkingCountry: "B2BPaymentCanOnlyBeCreatedInPolandWorkingCountry",
    B2BTagDescription: "B2BTagDescription",
    Back: "Back",
    BackSeatHint: "BackSeatHint",
    BackToTerytSearchLabel: "BackToTerytSearchLabel",
    Bag: "Bag",
    BailffStatusDescription: "BailffStatusDescription",
    Bailiff: "Bailiff",
    BailiffStatus: "BailiffStatus",
    BailiffTagDescription: "BailiffTagDescription",
    Balance: "Balance",
    BalanceAfterCashFlowAdded: "BalanceAfterCashFlowAdded",
    BalanceAfterCashFlowModified: "BalanceAfterCashFlowModified",
    BalanceAfterOperation: "BalanceAfterOperation",
    BalanceWithDeposits: "BalanceWithDeposits",
    Bank: "Bank",
    BankAccountNumber: "BankAccountNumber",
    BankAccountNumberFormatIsWrong: "BankAccountNumberFormatIsWrong",
    BankAccountNumberSkipped: "BankAccountNumberSkipped",
    Banned: "Banned",
    BannedPermanentny: "BannedPermanentny",
    BannedTemporarily: "BannedTemporarily",
    BannedTo: "BannedTo",
    BannedWithoutDate: "BannedWithoutDate",
    BaseAdvanceQuota: "BaseAdvanceQuota",
    BaseQuota: "BaseQuota",
    BaseQuotaPayoffDescription: "BaseQuotaPayoffDescription",
    BaseQuotaQuickPayoffDescription: "BaseQuotaQuickPayoffDescription",
    Basic: "Basic",
    BasicData: "BasicData",
    BasicDataReportFormDescription: "BasicDataReportFormDescription",
    BasicDataSettlementFormDescription: "BasicDataSettlementFormDescription",
    BasicInformation: "BasicInformation",
    BatteryCapacity: "BatteryCapacity",
    Begin: "Begin",
    BeginDateAlreadyExists: "BeginDateAlreadyExists",
    BeginDateCannotBeInPast: "BeginDateCannotBeInPast",
    BeginDateMustBeMonday: "BeginDateMustBeMonday",
    Beginning: "Beginning",
    Bezproblem: "Bezproblem",
    BezproblemCommission: "BezproblemCommission",
    BezproblemCommissionShort: "BezproblemCommissionShort",
    BezproblemDiscountedCommission: "BezproblemDiscountedCommission",
    BezproblemSharedCommission: "BezproblemSharedCommission",
    BezproblemTransportCommission: "BezproblemTransportCommission",
    BezproblemTransportCommissionShort: "BezproblemTransportCommissionShort",
    BicycleBackHint: "BicycleBackHint",
    BicycleFrontHint: "BicycleFrontHint",
    BigPayout: "BigPayout",
    Bike: "Bike",
    BikeAdvertising: "BikeAdvertising",
    BikeEquipmentSelectValid: "BikeEquipmentSelectValid",
    BikeReceivingProtocol: "BikeReceivingProtocol",
    BikeService: "BikeService",
    BikeTransferProtocol: "BikeTransferProtocol",
    Bikes: "Bikes",
    BikesInMaintain: "BikesInMaintain",
    BikesInUse: "BikesInUse",
    BikesInWorkshop: "BikesInWorkshop",
    BikesNotUsed: "BikesNotUsed",
    BikesRented: "BikesRented",
    BikesReturned: "BikesReturned",
    BikesWorking: "BikesWorking",
    BilledAmount: "BilledAmount",
    BilledAmountSum: "BilledAmountSum",
    BillingDetails: "BillingDetails",
    BirthCountry: "BirthCountry",
    BirthDate: "BirthDate",
    BirthPlace: "BirthPlace",
    BirthdayWishes: "BirthdayWishes",
    Blik: "Blik",
    BlikPhoneNumber: "BlikPhoneNumber",
    BlockPayoffAutomaticallyBasedOnHrTags: "BlockPayoffAutomaticallyBasedOnHrTags",
    Blocked: "Blocked",
    BlockingDriverPaymentDialogQuestion: "BlockingDriverPaymentDialogQuestion",
    BlockingDriverPayments: "BlockingDriverPayments",
    BlockingTagsInclude: "BlockingTagsInclude",
    BlockingTagsShortDescription: "BlockingTagsShortDescription",
    BlueCityAdvertising: "BlueCityAdvertising",
    BodyCondition: "BodyCondition",
    Bolt: "Bolt",
    BoltFood: "BoltFood",
    BoltFoodContract: "BoltFoodContract",
    BoltFoodWeeklyTipsImport: "BoltFoodWeeklyTipsImport",
    BoltTaxiLamp: "BoltTaxiLamp",
    Bonus: "Bonus",
    BonusBaseQuota: "BonusBaseQuota",
    BonusCampaignCourses: "BonusCampaignCourses",
    BonusCampaignOrganisations: "BonusCampaignOrganisations",
    BonusCampaignVehicles: "BonusCampaignVehicles",
    BonusCampaigns: "BonusCampaigns",
    BonusDate: "BonusDate",
    BonusForPayments: "BonusForPayments",
    BonusFromConfirmedPaymentHasAlreadyBeenSettledPartiallyOrTotally: "BonusFromConfirmedPaymentHasAlreadyBeenSettledPartiallyOrTotally",
    BonusGross: "BonusGross",
    BonusQuota: "BonusQuota",
    BonusVatRate: "BonusVatRate",
    Borrow: "Borrow",
    Borrower: "Borrower",
    Brand: "Brand",
    BreakFluidLevelQuestion: "BreakFluidLevelQuestion",
    BreakPadsConditionQuestion: "BreakPadsConditionQuestion",
    BuildingNumber: "BuildingNumber",
    BuildingNumberLooksInvalid: "BuildingNumberLooksInvalid",
    BundleCanContainOnlyOneCsvFile: "BundleCanContainOnlyOneCsvFile",
    BundleMustHaveAtLeastOnePdfFile: "BundleMustHaveAtLeastOnePdfFile",
    Busy: "Busy",
    Calculate: "Calculate",
    CalculateServiceFee: "CalculateServiceFee",
    Calculation: "Calculation",
    CampaignCreate: "CampaignCreate",
    CampaignEndDate: "CampaignEndDate",
    CampaignNotFound: "CampaignNotFound",
    CampaignSmsMessageAlert0: "CampaignSmsMessageAlert0",
    CampaignStartDay: "CampaignStartDay",
    Campaigns: "Campaigns",
    CanAddOnlinePaymentInvoice: "CanAddOnlinePaymentInvoice",
    CanAddOrRemoveDriverDayoff: "CanAddOrRemoveDriverDayoff",
    CanApproveCollidingSettlements: "CanApproveCollidingSettlements",
    CanApproveDriverCreatedSettlements: "CanApproveDriverCreatedSettlements",
    CanApproveSettlements: "CanApproveSettlements",
    CanApproveSmsCampaigns: "CanApproveSmsCampaigns",
    CanAssignDigitalPromissoryNoteInReceivingVehicle: "CanAssignDigitalPromissoryNoteInReceivingVehicle",
    CanAssignStandardDigitalDocumentOnChangeVehicleDriver: "CanAssignStandardDigitalDocumentOnChangeVehicleDriver",
    CanCancelPayoff: "CanCancelPayoff",
    CanChangeDriverDisableRequestStatus: "CanChangeDriverDisableRequestStatus",
    CanChangeMobileApplicationDriverFileVisibility: "CanChangeMobileApplicationDriverFileVisibility",
    CanChangeStudentValidationStatus: "CanChangeStudentValidationStatus",
    CanChangeVehicleComissions: "CanChangeVehicleComissions",
    CanChangeVehicleDiscountedCommissions: "CanChangeVehicleDiscountedCommissions",
    CanChangeVehicleIsIncludedInDayOff: "CanChangeVehicleIsIncludedInDayOff",
    CanClaimSupportTicket: "CanClaimSupportTicket",
    CanCloseSupportTicket: "CanCloseSupportTicket",
    CanConfirmDriverDocumentsWithoutUploadingFile: "CanConfirmDriverDocumentsWithoutUploadingFile",
    CanCreateInvoice: "CanCreateInvoice",
    CanDeleteInviteProgram: "CanDeleteInviteProgram",
    CanDeleteInviteProgramDraft: "CanDeleteInviteProgramDraft",
    CanDeletePayoff: "CanDeletePayoff",
    CanDeleteReferral: "CanDeleteReferral",
    CanDeleteSupportTicket: "CanDeleteSupportTicket",
    CanEditDriverContractStartDate: "CanEditDriverContractStartDate",
    CanEditPayoffOnlinePayment: "CanEditPayoffOnlinePayment",
    CanEditReferral: "CanEditReferral",
    CanExportDriversToCsv: "CanExportDriversToCsv",
    CanExportEquipmentReturnRequest: "CanExportEquipmentReturnRequest",
    CanExportPaymentsSummaryForTax: "CanExportPaymentsSummaryForTax",
    CanExportPayoffs: "CanExportPayoffs",
    CanExportProofOfIncome: "CanExportProofOfIncome",
    CanExportRequestForPayment: "CanExportRequestForPayment",
    CanExportSettlementsReport: "CanExportSettlementsReport",
    CanExportTakenCashFromSettlements: "CanExportTakenCashFromSettlements",
    CanExportUserWithdrawSummary: "CanExportUserWithdrawSummary",
    CanExportVehiclePaidRent: "CanExportVehiclePaidRent",
    CanExportWorkLog: "CanExportWorkLog",
    CanForceRavapiPaymentsTitle: "CanForceRavapiPaymentsTitle",
    CanHoldoffSettlementPayoff: "CanHoldoffSettlementPayoff",
    CanIncludeSettlementInExport: "CanIncludeSettlementInExport",
    CanManageAiKnowledgeBase: "CanManageAiKnowledgeBase",
    CanManageBonusCampaigns: "CanManageBonusCampaigns",
    CanManageMailRules: "CanManageMailRules",
    CanManageVehicleCashback: "CanManageVehicleCashback",
    CanManageVehicleDocuments: "CanManageVehicleDocuments",
    CanManualEditDriverSubject: "CanManualEditDriverSubject",
    CanMassAddSiiPayoffs: "CanMassAddSiiPayoffs",
    CanMassAdjustSettlementCommissions: "CanMassAdjustSettlementCommissions",
    CanMassCancelSiiPayoffs: "CanMassCancelSiiPayoffs",
    CanMassDeletePayoffs: "CanMassDeletePayoffs",
    CanMassDeleteSupportTickets: "CanMassDeleteSupportTickets",
    CanMassRemoveDriversFromSII: "CanMassRemoveDriversFromSII",
    CanMassReportDriversToSII: "CanMassReportDriversToSII",
    CanMassSetVehiclesCommission: "CanMassSetVehiclesCommission",
    CanMoveSettlementBackToWaiting: "CanMoveSettlementBackToWaiting",
    CanPublishInviteProgram: "CanPublishInviteProgram",
    CanRemoveBlockingWithdrawDriverStatusTags: "CanRemoveBlockingWithdrawDriverStatusTags",
    CanRemoveDriverContactForm: "CanRemoveDriverContactForm",
    CanRemoveOnlinePayments: "CanRemoveOnlinePayments",
    CanRemovePayUPayoffs: "CanRemovePayUPayoffs",
    CanRemoveReferralPayoffs: "CanRemoveReferralPayoffs",
    CanSendDriverDataToFlovi: "CanSendDriverDataToFlovi",
    CanSendInvoiceToKSeF: "CanSendInvoiceToKSeF",
    CanSendOnlinePaymentRequestToDebtors: "CanSendOnlinePaymentRequestToDebtors",
    CanSettleDriverViaOnlinePayments: "CanSettleDriverViaOnlinePayments",
    CanTakeOverSupportTicket: "CanTakeOverSupportTicket",
    Cancel: "Cancel",
    CancelReason: "CancelReason",
    CancelReservation: "CancelReservation",
    CancelSiiPayoffs: "CancelSiiPayoffs",
    Canceled: "Canceled",
    CanceledCharges: "CanceledCharges",
    CanceledQuota: "CanceledQuota",
    CancelledByDriver: "CancelledByDriver",
    CancelledByUser: "CancelledByUser",
    CannotAddThisEventTypeOnSelectedField: "CannotAddThisEventTypeOnSelectedField",
    CannotApproveSettlementWithoutDriver: "CannotApproveSettlementWithoutDriver",
    CannotAssignVehicleRelatedToStolenIncident: "CannotAssignVehicleRelatedToStolenIncident",
    CannotChangeDriverOnTheftOrWorkshopVehicle: "CannotChangeDriverOnTheftOrWorkshopVehicle",
    CannotChangeHrStatus: "CannotChangeHrStatus",
    CannotDeleteInstallmentSchemaWithExistingPayoffs: "CannotDeleteInstallmentSchemaWithExistingPayoffs",
    CannotImportDailyStuart: "CannotImportDailyStuart",
    CantChangePaymentStatusFromWaitingToExecuted: "CantChangePaymentStatusFromWaitingToExecuted",
    Caption: "Caption",
    Car: "Car",
    CarAdvertising: "CarAdvertising",
    CarAndScooter: "CarAndScooter",
    CarBackSeat: "CarBackSeat",
    CarDashboardHint: "CarDashboardHint",
    CarFirstAidKit: "CarFirstAidKit",
    CarLeftFront: "CarLeftFront",
    CarLeftFrontHint: "CarLeftFrontHint",
    CarLeftRear: "CarLeftRear",
    CarLeftRearHint: "CarLeftRearHint",
    CarRightFront: "CarRightFront",
    CarRightFrontHint: "CarRightFrontHint",
    CarRightRear: "CarRightRear",
    CarRightRearHint: "CarRightRearHint",
    CarSharing: "CarSharing",
    CarSharingEnded: "CarSharingEnded",
    CarSharingStarted: "CarSharingStarted",
    Card: "Card",
    CardNeeded: "CardNeeded",
    CardNeededTagDescription: "CardNeededTagDescription",
    CardNumber: "CardNumber",
    CardNumberLastFourDigits: "CardNumberLastFourDigits",
    CardType: "CardType",
    Cars: "Cars",
    CarsInMaintain: "CarsInMaintain",
    CarsInUse: "CarsInUse",
    CarsInWorkshop: "CarsInWorkshop",
    CarsNotUsed: "CarsNotUsed",
    CarsRented: "CarsRented",
    CarsReturned: "CarsReturned",
    CarsWorking: "CarsWorking",
    Cash: "Cash",
    CashActual: "CashActual",
    CashBalance: "CashBalance",
    CashFieldToSettlePayoff: "CashFieldToSettlePayoff",
    CashFlow: "CashFlow",
    CashFlowCreate: "CashFlowCreate",
    CashFlowDelete: "CashFlowDelete",
    CashFlowDeleteMessage: "CashFlowDeleteMessage",
    CashFlowEdit: "CashFlowEdit",
    CashFlowNotFound: "CashFlowNotFound",
    CashFlowReportDifferenceQuotaAlert: "CashFlowReportDifferenceQuotaAlert",
    CashFlowReportOverdue: "CashFlowReportOverdue",
    CashFlowSource: "CashFlowSource",
    CashFlowValue: "CashFlowValue",
    CashFlows: "CashFlows",
    CashFlowsReports: "CashFlowsReports",
    CashPayment: "CashPayment",
    CashRegisterConfirmationMailTitle: "CashRegisterConfirmationMailTitle",
    CashRegisterDisbursement: "CashRegisterDisbursement",
    CashRegisterReceipt: "CashRegisterReceipt",
    Cashback: "Cashback",
    CashbackAmount: "CashbackAmount",
    CashbackAmountAndRequiredDaysMustBeBothFilledOrBothEmpty: "CashbackAmountAndRequiredDaysMustBeBothFilledOrBothEmpty",
    CashbackEnableRequiresAmountAndRequiredDays: "CashbackEnableRequiresAmountAndRequiredDays",
    CashbackEnabled: "CashbackEnabled",
    CashbackEvaluationWindowDays: "CashbackEvaluationWindowDays",
    CashbackMaxDebtLimit: "CashbackMaxDebtLimit",
    CashbackRequiredDays: "CashbackRequiredDays",
    CashbackSetPartialFailure: "CashbackSetPartialFailure",
    CashbackSetSuccess: "CashbackSetSuccess",
    CashbackUpdateRequiresAtLeastOneField: "CashbackUpdateRequiresAtLeastOneField",
    Cashs: "Cashs",
    Category: "Category",
    CepikDriverAlertMissingDrivingLicense: "CepikDriverAlertMissingDrivingLicense",
    CepikDriverAlertToBeVerified: "CepikDriverAlertToBeVerified",
    CepikDriverAlertVerificationRejected: "CepikDriverAlertVerificationRejected",
    CepikVerification: "CepikVerification",
    CertificateOfNoCriminalRecord: "CertificateOfNoCriminalRecord",
    ChangeApplicationAccountsPaymentType: "ChangeApplicationAccountsPaymentType",
    ChangeConfirmation: "ChangeConfirmation",
    ChangeDisableTaxQualificationMechanismAlert: "ChangeDisableTaxQualificationMechanismAlert",
    ChangeDriver: "ChangeDriver",
    ChangeDriverDialogTutorial: "ChangeDriverDialogTutorial",
    ChangeDriverDrivingLicenseVerificationAlert: "ChangeDriverDrivingLicenseVerificationAlert",
    ChangeDriversPaymentType: "ChangeDriversPaymentType",
    ChangePassword: "ChangePassword",
    ChangePaymentStatus: "ChangePaymentStatus",
    ChangePaymentType: "ChangePaymentType",
    ChangeTo0: "ChangeTo0",
    ChangesComparedToCurrent: "ChangesComparedToCurrent",
    ChangesDetected: "ChangesDetected",
    ChangesOnForm: "ChangesOnForm",
    ChangesPreview: "ChangesPreview",
    ChangingDriverIsNotAllowedOnInstallmentPayoff: "ChangingDriverIsNotAllowedOnInstallmentPayoff",
    ChangingPaymentStatus: "ChangingPaymentStatus",
    ChangingPayoffPositiveNegativeNotAllowed: "ChangingPayoffPositiveNegativeNotAllowed",
    Charge: "Charge",
    ChargeBaseQuota: "ChargeBaseQuota",
    ChargeDate: "ChargeDate",
    ChargeForRentalWithoutAppSettlement: "ChargeForRentalWithoutAppSettlement",
    ChargeForRentalWithoutAppSettlementAmount: "ChargeForRentalWithoutAppSettlementAmount",
    ChargeForVehicle: "ChargeForVehicle",
    ChargedBattery: "ChargedBattery",
    ChargingCable240V400V: "ChargingCable240V400V",
    ChartAccountCommissions: "ChartAccountCommissions",
    ChartApplicationSums: "ChartApplicationSums",
    ChartApprovedDriversDebtCounts: "ChartApprovedDriversDebtCounts",
    ChartApprovedSettlementsDebtSums: "ChartApprovedSettlementsDebtSums",
    ChartBezproblemCommissions: "ChartBezproblemCommissions",
    ChartBezproblemTransportCommissions: "ChartBezproblemTransportCommissions",
    ChartRavapiCommissions: "ChartRavapiCommissions",
    ChartRavapiTransportCommissions: "ChartRavapiTransportCommissions",
    ChartRegisteredDrivers: "ChartRegisteredDrivers",
    ChartResidentCardCommissions: "ChartResidentCardCommissions",
    ChartSettlementPayoffSums: "ChartSettlementPayoffSums",
    ChartSettlementsDailyDriverPaymentTypes: "ChartSettlementsDailyDriverPaymentTypes",
    ChartSettlementsWeeklyDriverPaymentTypes: "ChartSettlementsWeeklyDriverPaymentTypes",
    ChartToWithdrawSettlementExecuted: "ChartToWithdrawSettlementExecuted",
    ChatAttachmentRetentionDays: "ChatAttachmentRetentionDays",
    ChatHistory: "ChatHistory",
    CheckDifferentOrganisation: "CheckDifferentOrganisation",
    CheckPaymentStatus: "CheckPaymentStatus",
    Chip: "Chip",
    ChooseOrganisationToShowData: "ChooseOrganisationToShowData",
    Citizenship: "Citizenship",
    CitizenshipCodeInvalid: "CitizenshipCodeInvalid",
    CityNotFoundFallbackLabel: "CityNotFoundFallbackLabel",
    ClaimTicket: "ClaimTicket",
    ClarificationStreak: "ClarificationStreak",
    ClassificationConfidenceThreshold: "ClassificationConfidenceThreshold",
    Clean: "Clean",
    CleaningFileFromEmptyRecords: "CleaningFileFromEmptyRecords",
    ClearFilters: "ClearFilters",
    ClientSignature: "ClientSignature",
    Close: "Close",
    CloseComment: "CloseComment",
    CloseReason: "CloseReason",
    CloseTicket: "CloseTicket",
    CloseTicketConfirmTitle: "CloseTicketConfirmTitle",
    Code: "Code",
    CollectCash: "CollectCash",
    CollectVehicle: "CollectVehicle",
    Collection: "Collection",
    CollectionOperator: "CollectionOperator",
    Columns: "Columns",
    Comment: "Comment",
    CommisionPercentSplitDescription: "CommisionPercentSplitDescription",
    CommissionAdjustment: "CommissionAdjustment",
    CommissionAdjustmentMessage: "CommissionAdjustmentMessage",
    CommissionBaseApplicationTotal: "CommissionBaseApplicationTotal",
    CommissionBaseField: "CommissionBaseField",
    CommissionBaseSum: "CommissionBaseSum",
    CommissionCalculationMethod: "CommissionCalculationMethod",
    CommissionCalculationType: "CommissionCalculationType",
    CommissionCannotBeLowerThan: "CommissionCannotBeLowerThan",
    CommissionFleetCarSplit: "CommissionFleetCarSplit",
    CommissionMode: "CommissionMode",
    CommissionModePercent: "CommissionModePercent",
    CommissionModeQuota: "CommissionModeQuota",
    CommissionPercentSplit: "CommissionPercentSplit",
    CommissionPercentSplitAssignedSum: "CommissionPercentSplitAssignedSum",
    CommissionType: "CommissionType",
    Commissions: "Commissions",
    CommonPaymentType: "CommonPaymentType",
    CommonlyUsed: "CommonlyUsed",
    Commune: "Commune",
    CommuneCode: "CommuneCode",
    Company: "Company",
    CompanyBankAccountNumberForB2B: "CompanyBankAccountNumberForB2B",
    CompanySetup: "CompanySetup",
    CompanyVehicles: "CompanyVehicles",
    ComparingToPreviousSettlementsDataWouldBeZeroSkipping: "ComparingToPreviousSettlementsDataWouldBeZeroSkipping",
    CompletingFormDate: "CompletingFormDate",
    Condition: "Condition",
    ConditionJoiner: "ConditionJoiner",
    ConditionRentedVehicleSummary: "ConditionRentedVehicleSummary",
    ConditionType: "ConditionType",
    ConditionWorkedDaysSummary: "ConditionWorkedDaysSummary",
    Conditions: "Conditions",
    ConditionsAllMustBeMet: "ConditionsAllMustBeMet",
    ConditionsSelect: "ConditionsSelect",
    Confirm: "Confirm",
    ConfirmHideFromMobileApp: "ConfirmHideFromMobileApp",
    ConfirmLanguageChange: "ConfirmLanguageChange",
    ConfirmMakingTheContact: "ConfirmMakingTheContact",
    ConfirmMakingTheContactDialog: "ConfirmMakingTheContactDialog",
    ConfirmShowInMobileApp: "ConfirmShowInMobileApp",
    ConfirmationData: "ConfirmationData",
    ConfirmationDayOffForDay: "ConfirmationDayOffForDay",
    Consents: "Consents",
    ContactDate: "ContactDate",
    ContactDoesNotExists: "ContactDoesNotExists",
    ContactForDriverHasBeenMade: "ContactForDriverHasBeenMade",
    ContactHasNotBeenMade: "ContactHasNotBeenMade",
    ContactHasNotBeenMadeDescription: "ContactHasNotBeenMadeDescription",
    ContactList: "ContactList",
    Content: "Content",
    ContractOfEmployment: "ContractOfEmployment",
    ContractOfMandate: "ContractOfMandate",
    ContractOfMandateCourier: "ContractOfMandateCourier",
    ContractOfMandateDriver: "ContractOfMandateDriver",
    ContractOfMandateFlovi: "ContractOfMandateFlovi",
    ContractOfMandateOtherEmployer: "ContractOfMandateOtherEmployer",
    ContractOfMandateOtherEmployerToVerify: "ContractOfMandateOtherEmployerToVerify",
    ContractStartDate: "ContractStartDate",
    ContractStartDateOutOfRange: "ContractStartDateOutOfRange",
    ContractSubject: "ContractSubject",
    ContractorStatement: "ContractorStatement",
    ContractualPenalties: "ContractualPenalties",
    ConversationWithClient: "ConversationWithClient",
    CoolantLevel: "CoolantLevel",
    CoolantLevelQuestion: "CoolantLevelQuestion",
    CooperationEnd: "CooperationEnd",
    CooperationEndDate: "CooperationEndDate",
    CopiedToClipboard: "CopiedToClipboard",
    Copy: "Copy",
    CopyFailed: "CopyFailed",
    CopyToClipboard: "CopyToClipboard",
    Correspondence: "Correspondence",
    CouldNotHaveSpecialCharacters: "CouldNotHaveSpecialCharacters",
    Country: "Country",
    County: "County",
    Courier: "Courier",
    CourierInstructions: "CourierInstructions",
    CourierInvoiceServiceType: "CourierInvoiceServiceType",
    CourseTheSameQuantityAndAmountExists: "CourseTheSameQuantityAndAmountExists",
    Courses: "Courses",
    Crack: "Crack",
    CreateAndAddPaymentUrl: "CreateAndAddPaymentUrl",
    CreateCampaignFromCopy: "CreateCampaignFromCopy",
    CreateCashFlowReport: "CreateCashFlowReport",
    CreateInvoice: "CreateInvoice",
    CreateSettlement: "CreateSettlement",
    CreateSettlementAfterPayoffImportSelectedStartingProcess: "CreateSettlementAfterPayoffImportSelectedStartingProcess",
    CreateSettlementsForDriversFromPayoffs: "CreateSettlementsForDriversFromPayoffs",
    CreateSmsCampaign: "CreateSmsCampaign",
    CreatedBy: "CreatedBy",
    CreatedDate: "CreatedDate",
    CreatingDocument: "CreatingDocument",
    CreatingHrTag: "CreatingHrTag",
    CreatingPayoffsSummary: "CreatingPayoffsSummary",
    Creation: "Creation",
    CsvContainsNoHeaders: "CsvContainsNoHeaders",
    CsvHeadersCorrect: "CsvHeadersCorrect",
    CsvInvalidDecimalFormat: "CsvInvalidDecimalFormat",
    CsvMissingColumn: "CsvMissingColumn",
    CsvRecordErrorMessage: "CsvRecordErrorMessage",
    CsvStructureHasNotBeenDefinedForThisApplication: "CsvStructureHasNotBeenDefinedForThisApplication",
    Current: "Current",
    CurrentBalance: "CurrentBalance",
    CurrentBalanceWithoutFuturePayoffs: "CurrentBalanceWithoutFuturePayoffs",
    CurrentCost: "CurrentCost",
    CurrentDriverExistsInFloviSystem: "CurrentDriverExistsInFloviSystem",
    CurrentDriversOfNewVehicle: "CurrentDriversOfNewVehicle",
    CurrentDriversOfPreviousVehicle: "CurrentDriversOfPreviousVehicle",
    CurrentInvoicesIndex: "CurrentInvoicesIndex",
    CurrentMonthUsage: "CurrentMonthUsage",
    CurrentRent: "CurrentRent",
    CurrentResult: "CurrentResult",
    CurrentVehicle: "CurrentVehicle",
    Custom: "Custom",
    CustomReason: "CustomReason",
    CustomSiiRate: "CustomSiiRate",
    CustomStickers: "CustomStickers",
    Czech: "Czech",
    Czechia: "Czechia",
    CzechiaBankAccountNumber: "CzechiaBankAccountNumber",
    CzechiaCompanyBankAccountNumber: "CzechiaCompanyBankAccountNumber",
    CzechiaCompanyBankCode: "CzechiaCompanyBankCode",
    CzechiaCompanyBankName: "CzechiaCompanyBankName",
    Daily: "Daily",
    DailyDrivers: "DailyDrivers",
    DailyPayoutsAccess: "DailyPayoutsAccess",
    DailyPayoutsNotAvailableForOrganisation: "DailyPayoutsNotAvailableForOrganisation",
    DailySettlementCustomCommissionCannotBeLesssThanZero: "DailySettlementCustomCommissionCannotBeLesssThanZero",
    DailySettlements: "DailySettlements",
    DailySettlementsCustomCommission: "DailySettlementsCustomCommission",
    DailySettlementsQuantity: "DailySettlementsQuantity",
    Damage: "Damage",
    Dashboard: "Dashboard",
    DashboardAndPhoneHolderAndShifters: "DashboardAndPhoneHolderAndShifters",
    DataForAssignedDrivers: "DataForAssignedDrivers",
    DataScope: "DataScope",
    DataWouldBeAutomaticlyFilledAfterDriverSelect: "DataWouldBeAutomaticlyFilledAfterDriverSelect",
    Date: "Date",
    DateCannotOccurMoreThanOnce: "DateCannotOccurMoreThanOnce",
    DateFilterSettlementListDescription: "DateFilterSettlementListDescription",
    DateFiltersReportListDescription: "DateFiltersReportListDescription",
    DateFormatMustBeInShortDateFormat: "DateFormatMustBeInShortDateFormat",
    DateIsNotMonday: "DateIsNotMonday",
    DateIsWrong: "DateIsWrong",
    DateOfFirstUnpaidPayoff: "DateOfFirstUnpaidPayoff",
    DateOfIssueOfDrivingLicence: "DateOfIssueOfDrivingLicence",
    DateOfLastUnpaidPayoff: "DateOfLastUnpaidPayoff",
    DateRangeForEvents: "DateRangeForEvents",
    DatesRange: "DatesRange",
    DayOfRemoveFromSSI: "DayOfRemoveFromSSI",
    DayOfRemoveFromSSIRequired: "DayOfRemoveFromSSIRequired",
    DayOfReportToSSI: "DayOfReportToSSI",
    DayOfReportToSSIRequired: "DayOfReportToSSIRequired",
    DayOff: "DayOff",
    DayOffGivenFor: "DayOffGivenFor",
    DayOffIncluded: "DayOffIncluded",
    DayOffPromotionMustBeFullyPaidOutToReducePayoffThatWasCreatedFrom: "DayOffPromotionMustBeFullyPaidOutToReducePayoffThatWasCreatedFrom",
    Days: "Days",
    DaysUntilIsContactedForDebtReset: "DaysUntilIsContactedForDebtReset",
    Deactivate: "Deactivate",
    Debt: "Debt",
    DebtLimit: "DebtLimit",
    DebtNotes: "DebtNotes",
    Debtor: "Debtor",
    DebtorStatusDescription: "DebtorStatusDescription",
    Debtors: "Debtors",
    DebtorsDescription: "DebtorsDescription",
    DeclarationLackOfSII: "DeclarationLackOfSII",
    Default: "Default",
    Defer: "Defer",
    DefineExecutionDate: "DefineExecutionDate",
    DefiningDriverSubject: "DefiningDriverSubject",
    Delete: "Delete",
    DeleteApplication: "DeleteApplication",
    DeleteArticleConfirmContent: "DeleteArticleConfirmContent",
    DeleteArticleConfirmTitle: "DeleteArticleConfirmTitle",
    DeleteCondition: "DeleteCondition",
    DeleteDocumentAlert: "DeleteDocumentAlert",
    DeleteDriverDescription: "DeleteDriverDescription",
    DeleteEvent: "DeleteEvent",
    DeleteGroup: "DeleteGroup",
    DeleteHrTagAlert: "DeleteHrTagAlert",
    DeleteIcon: "DeleteIcon",
    DeleteIconAlert: "DeleteIconAlert",
    DeleteIconSchemaAlert: "DeleteIconSchemaAlert",
    DeleteRecordConfirmation: "DeleteRecordConfirmation",
    DeleteResourceAlert: "DeleteResourceAlert",
    DeleteSelected: "DeleteSelected",
    DeleteTicket: "DeleteTicket",
    DeleteTicketConfirmContent: "DeleteTicketConfirmContent",
    DeleteTicketConfirmTitle: "DeleteTicketConfirmTitle",
    DeleteVehicleDocumentAlert: "DeleteVehicleDocumentAlert",
    Deleted: "Deleted",
    DeletedSettlements: "DeletedSettlements",
    Deletion: "Deletion",
    Delivered: "Delivered",
    Dent: "Dent",
    Deposit: "Deposit",
    DepositCannotBePaidByDriver: "DepositCannotBePaidByDriver",
    DepositCashActual: "DepositCashActual",
    Deposits: "Deposits",
    DepositsInBank: "DepositsInBank",
    DepositsInCash: "DepositsInCash",
    DepositsSum: "DepositsSum",
    Description: "Description",
    DestinationCountryForDigitalDocuments: "DestinationCountryForDigitalDocuments",
    Details: "Details",
    DetectedChanges: "DetectedChanges",
    DialogsPerDriverPerDay: "DialogsPerDriverPerDay",
    DialogsPerDriverPerHour: "DialogsPerDriverPerHour",
    DifferentProblem: "DifferentProblem",
    DigitalContract: "DigitalContract",
    DigitalSignature: "DigitalSignature",
    DigitalSignatureDevice: "DigitalSignatureDevice",
    Dirty: "Dirty",
    DisabilityCertificate: "DisabilityCertificate",
    DisabilityLevel: "DisabilityLevel",
    DisabilityLevelLegacyText: "DisabilityLevelLegacyText",
    DisabilityLevelLight: "DisabilityLevelLight",
    DisabilityLevelModerate: "DisabilityLevelModerate",
    DisabilityLevelSignificant: "DisabilityLevelSignificant",
    DisabilityLevelUnderSixteen: "DisabilityLevelUnderSixteen",
    DisableIsIncludedInPromotionDayOff: "DisableIsIncludedInPromotionDayOff",
    DisableMobileApplicationRequestStatus: "DisableMobileApplicationRequestStatus",
    DisableMobileApplicationRequestStatusActionApprove: "DisableMobileApplicationRequestStatusActionApprove",
    DisableMobileApplicationRequestStatusActionRestore: "DisableMobileApplicationRequestStatusActionRestore",
    DisableMobileApplicationRequestStatusActionStart: "DisableMobileApplicationRequestStatusActionStart",
    DisableMobileApplicationRequestStatusChangeWillSendEmail: "DisableMobileApplicationRequestStatusChangeWillSendEmail",
    DisableMobileApplicationRequestStatusFinished: "DisableMobileApplicationRequestStatusFinished",
    DisableMobileApplicationRequestStatusPending: "DisableMobileApplicationRequestStatusPending",
    DisableMobileApplicationRequestStatusRestoreConfirm: "DisableMobileApplicationRequestStatusRestoreConfirm",
    DisableMobileApplicationSection: "DisableMobileApplicationSection",
    DisableTaxQualificationMechanism: "DisableTaxQualificationMechanism",
    DiscardDraft: "DiscardDraft",
    DiscountedCommissionZeroValueAlert: "DiscountedCommissionZeroValueAlert",
    DisregardInEmailReason: "DisregardInEmailReason",
    DisregardInEmailsWithListOfDebtors: "DisregardInEmailsWithListOfDebtors",
    DoYouWantIssueInvoice: "DoYouWantIssueInvoice",
    DoYouWantToChangePaymentStatusTo: "DoYouWantToChangePaymentStatusTo",
    Document: "Document",
    DocumentAlreadyConfirmed: "DocumentAlreadyConfirmed",
    DocumentDoesNotExist: "DocumentDoesNotExist",
    DocumentFormIsCompletedIncorrectly: "DocumentFormIsCompletedIncorrectly",
    DocumentIsNotSigned: "DocumentIsNotSigned",
    DocumentOrganisation: "DocumentOrganisation",
    DocumentRejectionReasonDataMismatch: "DocumentRejectionReasonDataMismatch",
    DocumentRejectionReasonExpired: "DocumentRejectionReasonExpired",
    DocumentRejectionReasonIncompleteScan: "DocumentRejectionReasonIncompleteScan",
    DocumentRejectionReasonOther: "DocumentRejectionReasonOther",
    DocumentRejectionReasonUnreadable: "DocumentRejectionReasonUnreadable",
    DocumentRejectionReasonWrongDocument: "DocumentRejectionReasonWrongDocument",
    DocumentRowNotFound: "DocumentRowNotFound",
    DocumentSettings: "DocumentSettings",
    DocumentType: "DocumentType",
    DocumentTypeNotAllowed: "DocumentTypeNotAllowed",
    DocumentVerificationStatusConfirmed: "DocumentVerificationStatusConfirmed",
    DocumentVerificationStatusRejected: "DocumentVerificationStatusRejected",
    DocumentVerificationStatusUnverified: "DocumentVerificationStatusUnverified",
    DocumentWasCompletedIncorrectly: "DocumentWasCompletedIncorrectly",
    Documents: "Documents",
    DocumentsAndFiles: "DocumentsAndFiles",
    DocumentsAndFilesSettlementFormDescription: "DocumentsAndFilesSettlementFormDescription",
    DocumentsSubmission: "DocumentsSubmission",
    DocumentsToVerify: "DocumentsToVerify",
    Dolnoslaskie: "Dolnoslaskie",
    DontHavePermissionToApproveDriverCreatedSettlements: "DontHavePermissionToApproveDriverCreatedSettlements",
    DontHavePermissionToChangeSettlementPaymentStatus: "DontHavePermissionToChangeSettlementPaymentStatus",
    DontHavePermissionToCreatePositiveInstallmentSchema: "DontHavePermissionToCreatePositiveInstallmentSchema",
    DontHavePermissionToCreatePositivePayoff: "DontHavePermissionToCreatePositivePayoff",
    DontHavePermissionToSignDigitalDocuments: "DontHavePermissionToSignDigitalDocuments",
    DontIncludeInEmailAboutRentVehicleWhenCepikValidationIsRejected: "DontIncludeInEmailAboutRentVehicleWhenCepikValidationIsRejected",
    DontSignDocumentsPlural: "DontSignDocumentsPlural",
    DontSignDocumentsSingular: "DontSignDocumentsSingular",
    DoubleDatesFormatMustBeInShortDateFormat: "DoubleDatesFormatMustBeInShortDateFormat",
    Download: "Download",
    DownloadSelectedInvoices: "DownloadSelectedInvoices",
    DownloadSummary: "DownloadSummary",
    DownloadTaxOffice: "DownloadTaxOffice",
    DownloadingFiles: "DownloadingFiles",
    DraftFoundAlert: "DraftFoundAlert",
    Driver: "Driver",
    DriverAccount: "DriverAccount",
    DriverAndQuota: "DriverAndQuota",
    DriverAndVehicleComeFromOtherOrganisation: "DriverAndVehicleComeFromOtherOrganisation",
    DriverCannotBeDuplicated: "DriverCannotBeDuplicated",
    DriverConditionRentedVehicle: "DriverConditionRentedVehicle",
    DriverConditionWorkedDays: "DriverConditionWorkedDays",
    DriverContactFormList: "DriverContactFormList",
    DriverCreate: "DriverCreate",
    DriverData: "DriverData",
    DriverDataSettlementFormDescription: "DriverDataSettlementFormDescription",
    DriverDayOffPromotionAccess: "DriverDayOffPromotionAccess",
    DriverDeclaredRentOnlySkipping: "DriverDeclaredRentOnlySkipping",
    DriverDelete: "DriverDelete",
    DriverDeleteMessage: "DriverDeleteMessage",
    DriverDoesNotExistInSII: "DriverDoesNotExistInSII",
    DriverDoesNotFulFillRequirementsToCreateInvoice: "DriverDoesNotFulFillRequirementsToCreateInvoice",
    DriverDoesNotHaveDefinedNip: "DriverDoesNotHaveDefinedNip",
    DriverDoesNotMeetConditionsForDayOff: "DriverDoesNotMeetConditionsForDayOff",
    DriverDoesntHaveActivePaymentsInSelectedDates: "DriverDoesntHaveActivePaymentsInSelectedDates",
    DriverEarningSalaryStatus: "DriverEarningSalaryStatus",
    DriverEarnings: "DriverEarnings",
    DriverEarningsTip: "DriverEarningsTip",
    DriverEdit: "DriverEdit",
    DriverFullName: "DriverFullName",
    DriverHasBlockedWithdrawWithReason: "DriverHasBlockedWithdrawWithReason",
    DriverHasNoAssignVehicle: "DriverHasNoAssignVehicle",
    DriverHasNoOrganisation: "DriverHasNoOrganisation",
    DriverHasToBeProvided: "DriverHasToBeProvided",
    DriverHrTagDescription: "DriverHrTagDescription",
    DriverHrTags: "DriverHrTags",
    DriverIncomeNOk: "DriverIncomeNOk",
    DriverIncomeOk: "DriverIncomeOk",
    DriverIncomeStatus: "DriverIncomeStatus",
    DriverIsFromDifferentOrganisationThanYours: "DriverIsFromDifferentOrganisationThanYours",
    DriverIsRelatedToStolenIncident: "DriverIsRelatedToStolenIncident",
    DriverIsRelatedWithTheftOrWorkshopVehicle: "DriverIsRelatedWithTheftOrWorkshopVehicle",
    DriverLicenceBack: "DriverLicenceBack",
    DriverLicenceFront: "DriverLicenceFront",
    DriverMustBePresentDuringContractOfMandateVerification: "DriverMustBePresentDuringContractOfMandateVerification",
    DriverMustHavePayoffFor7thDayOfRental: "DriverMustHavePayoffFor7thDayOfRental",
    DriverNotFound: "DriverNotFound",
    DriverNotFoundSkipping: "DriverNotFoundSkipping",
    DriverNotWork: "DriverNotWork",
    DriverOrganisationDoesNotHaveEnabledOnlinePayments: "DriverOrganisationDoesNotHaveEnabledOnlinePayments",
    DriverOrganisationDoesNotSettleDailyPayoutsOnceWeek: "DriverOrganisationDoesNotSettleDailyPayoutsOnceWeek",
    DriverPaymentStatus: "DriverPaymentStatus",
    DriverPaymentTypeChangeMessage: "DriverPaymentTypeChangeMessage",
    DriverPaymentTypeIsNotDailySkipping: "DriverPaymentTypeIsNotDailySkipping",
    DriverPaymentTypeIsNotWeeklySkipping: "DriverPaymentTypeIsNotWeeklySkipping",
    DriverPayoffDescription: "DriverPayoffDescription",
    DriverPayoffsDelete: "DriverPayoffsDelete",
    DriverPayoffsDeleteMessage: "DriverPayoffsDeleteMessage",
    DriverPdfFileName: "DriverPdfFileName",
    DriverPreferences: "DriverPreferences",
    DriverPreview: "DriverPreview",
    DriverRegisterDiscoverySource: "DriverRegisterDiscoverySource",
    DriverSalaryStatusBonusDescription: "DriverSalaryStatusBonusDescription",
    DriverSalaryStatusIntro: "DriverSalaryStatusIntro",
    DriverSalaryStatusMinusDescription: "DriverSalaryStatusMinusDescription",
    DriverSeat: "DriverSeat",
    DriverSeatHint: "DriverSeatHint",
    DriverSelectDescription: "DriverSelectDescription",
    DriverSettlement: "DriverSettlement",
    DriverSettlements: "DriverSettlements",
    DriverStatus: "DriverStatus",
    DriverStatusTagDescription: "DriverStatusTagDescription",
    DriverStatusTags: "DriverStatusTags",
    DriverSubject: "DriverSubject",
    DriverSubjectConfirmationDataAlert: "DriverSubjectConfirmationDataAlert",
    DriverSubjectDisableManualEditConfirm: "DriverSubjectDisableManualEditConfirm",
    DriverSubjectDoesNotMatchWithGus: "DriverSubjectDoesNotMatchWithGus",
    DriverSubjectDrifferentDataAlert: "DriverSubjectDrifferentDataAlert",
    DriverSubjectIsManualEditAlert: "DriverSubjectIsManualEditAlert",
    DriverSubjectIsNotActive: "DriverSubjectIsNotActive",
    DriverSubjectMissingDataAlert: "DriverSubjectMissingDataAlert",
    DriverSubjectNoData: "DriverSubjectNoData",
    DriverSummaryPenaltiesExport: "DriverSummaryPenaltiesExport",
    DriverSummaryPenaltiesExportDesc: "DriverSummaryPenaltiesExportDesc",
    DriverTags: "DriverTags",
    DriverVerification: "DriverVerification",
    Drivers: "Drivers",
    DriversEarnings: "DriversEarnings",
    DriversHistory: "DriversHistory",
    DriversInOffice: "DriversInOffice",
    DriversInOfficeReportFormDescription: "DriversInOfficeReportFormDescription",
    DriversPartnership: "DriversPartnership",
    DriversPaymentMethodsStatus: "DriversPaymentMethodsStatus",
    DriversPaymentsMethods: "DriversPaymentsMethods",
    DriversRentSelect: "DriversRentSelect",
    DriversVehicles: "DriversVehicles",
    DriversXLSXFileName: "DriversXLSXFileName",
    DrivingLicense: "DrivingLicense",
    DrivingLicenseNumber: "DrivingLicenseNumber",
    DrivingLicensePreviewNotAvailable: "DrivingLicensePreviewNotAvailable",
    DrivingLicenseReadFailed: "DrivingLicenseReadFailed",
    DrivingLicenseVerification: "DrivingLicenseVerification",
    DropFilesOrClick: "DropFilesOrClick",
    Duplicate: "Duplicate",
    DuplicateAccount: "DuplicateAccount",
    DuplicateAlert: "DuplicateAlert",
    DuplicateStatusDescription: "DuplicateStatusDescription",
    DuplicateTagShortDescription: "DuplicateTagShortDescription",
    DuplicateTags: "DuplicateTags",
    EBike: "EBike",
    EBikeBackHint: "EBikeBackHint",
    EBikeBike: "EBikeBike",
    EBikeFrontHint: "EBikeFrontHint",
    EBikeHandlebarHint: "EBikeHandlebarHint",
    EBikeKeysHint: "EBikeKeysHint",
    EBikeLeftSideHint: "EBikeLeftSideHint",
    EBikeMileageScreenHint: "EBikeMileageScreenHint",
    EBikeRearBikeWheelWithChainHint: "EBikeRearBikeWheelWithChainHint",
    EBikeRearTireHint: "EBikeRearTireHint",
    EBikeRightSideHint: "EBikeRightSideHint",
    EBikes: "EBikes",
    EBikesInMaintain: "EBikesInMaintain",
    EBikesInUse: "EBikesInUse",
    EBikesInWorkshop: "EBikesInWorkshop",
    EBikesNotUsed: "EBikesNotUsed",
    EBikesRented: "EBikesRented",
    EBikesReturned: "EBikesReturned",
    EBikesWorking: "EBikesWorking",
    Earlier: "Earlier",
    EarningStatement: "EarningStatement",
    Earnings: "Earnings",
    Edit: "Edit",
    EditArticle: "EditArticle",
    EditCampaign: "EditCampaign",
    EditInviteProgram: "EditInviteProgram",
    EditMailRules: "EditMailRules",
    EditReason: "EditReason",
    EditReferral: "EditReferral",
    EditReport: "EditReport",
    EditReportDescription: "EditReportDescription",
    EditingDocument: "EditingDocument",
    EditingHrTag: "EditingHrTag",
    Edition: "Edition",
    EmailAddress: "EmailAddress",
    EmailAddressHasWrongFormat: "EmailAddressHasWrongFormat",
    EmailAddressIsAlreadyTaken: "EmailAddressIsAlreadyTaken",
    EmailNotSent: "EmailNotSent",
    EmailSent: "EmailSent",
    Emails: "Emails",
    EmailsSent: "EmailsSent",
    EmailsWillBeSent: "EmailsWillBeSent",
    EmailsWithSettlements: "EmailsWithSettlements",
    EmergencyReceive: "EmergencyReceive",
    EmployeeRateType: "EmployeeRateType",
    EmployeeSignature: "EmployeeSignature",
    Employment: "Employment",
    EmploymentType: "EmploymentType",
    EmploymentTypeChangeIsPossibleOnlyOncePerMonth: "EmploymentTypeChangeIsPossibleOnlyOncePerMonth",
    Empty: "Empty",
    EmptyKnowledgeBaseHint: "EmptyKnowledgeBaseHint",
    End: "End",
    EndDateOfLiabilityInsurance: "EndDateOfLiabilityInsurance",
    EndReservation: "EndReservation",
    EndVehicleRent: "EndVehicleRent",
    EndVehicleShare: "EndVehicleShare",
    Ending: "Ending",
    English: "English",
    Enter: "Enter",
    EnterCashFlowReports: "EnterCashFlowReports",
    EnterCashFlows: "EnterCashFlows",
    EnterOrganisationReports: "EnterOrganisationReports",
    EnterSettlement: "EnterSettlement",
    EnterSettlements: "EnterSettlements",
    Equipment: "Equipment",
    EquipmentLacks: "EquipmentLacks",
    Erase: "Erase",
    Error: "Error",
    ErrorAccessingBackCamera: "ErrorAccessingBackCamera",
    ErrorAccessingFrontCamera: "ErrorAccessingFrontCamera",
    ErrorOccurWhileUploadingFiles: "ErrorOccurWhileUploadingFiles",
    EstimatedCampaignCost: "EstimatedCampaignCost",
    EstimatedCost: "EstimatedCost",
    EventHasClosed: "EventHasClosed",
    ExcludeApplicationsFromCommissions: "ExcludeApplicationsFromCommissions",
    ExcludeFromDigitalDocumentsQueueCleanup: "ExcludeFromDigitalDocumentsQueueCleanup",
    ExcludeFromExport: "ExcludeFromExport",
    ExcludeFromKSeFNotifications: "ExcludeFromKSeFNotifications",
    ExcludeFromMissingDriverFilesAfterRegistrationNotification: "ExcludeFromMissingDriverFilesAfterRegistrationNotification",
    ExecutionDate: "ExecutionDate",
    ExistingIcons: "ExistingIcons",
    ExistingSchemas: "ExistingSchemas",
    ExpectedAstekCommission: "ExpectedAstekCommission",
    ExpectedCommissionCalculationType: "ExpectedCommissionCalculationType",
    ExpectedRavapiCommission: "ExpectedRavapiCommission",
    Export: "Export",
    Export0ToCsv: "Export0ToCsv",
    ExportActionsDescription: "ExportActionsDescription",
    ExportAll: "ExportAll",
    ExportByOrganisations: "ExportByOrganisations",
    ExportBySelectedVehicles: "ExportBySelectedVehicles",
    ExportConfirmationQuestion0: "ExportConfirmationQuestion0",
    ExportDate: "ExportDate",
    ExportDebtorsForPenaltiesSummaryToCsv: "ExportDebtorsForPenaltiesSummaryToCsv",
    ExportDriversToCsv: "ExportDriversToCsv",
    ExportDriversWithSelectedHrStatus: "ExportDriversWithSelectedHrStatus",
    ExportHistory: "ExportHistory",
    ExportPayoffs: "ExportPayoffs",
    ExportPayoffsDesc: "ExportPayoffsDesc",
    ExportRequestForPayment: "ExportRequestForPayment",
    ExportSettlementsFormDate: "ExportSettlementsFormDate",
    ExportSettlementsReport: "ExportSettlementsReport",
    ExportSettlementsReportDesc: "ExportSettlementsReportDesc",
    ExportSettlementsToAbo: "ExportSettlementsToAbo",
    ExportSettlementsToCsv: "ExportSettlementsToCsv",
    ExportTagCsvFile: "ExportTagCsvFile",
    ExportTagHistory: "ExportTagHistory",
    ExportTakenCash: "ExportTakenCash",
    ExportTakenCashDesc: "ExportTakenCashDesc",
    ExportToPdf: "ExportToPdf",
    ExportToPdfEquipmentReturnRequest: "ExportToPdfEquipmentReturnRequest",
    ExportToPdfProofOfIncome: "ExportToPdfProofOfIncome",
    ExportType: "ExportType",
    ExportUserWithdrawSummary: "ExportUserWithdrawSummary",
    ExportUserWithdrawSummaryList: "ExportUserWithdrawSummaryList",
    ExportVehicleEarnTo0: "ExportVehicleEarnTo0",
    ExportVehiclePaidRent: "ExportVehiclePaidRent",
    ExportVehiclePaidRentDesc: "ExportVehiclePaidRentDesc",
    ExportWithdrawSummary: "ExportWithdrawSummary",
    ExportWithdrawSummaryDesc: "ExportWithdrawSummaryDesc",
    ExportWithdrawSummaryForEmployee: "ExportWithdrawSummaryForEmployee",
    ExportWorkLog: "ExportWorkLog",
    ExportWorkLogDesc: "ExportWorkLogDesc",
    Exports: "Exports",
    ExternalDebt: "ExternalDebt",
    ExternalService: "ExternalService",
    ExternalWage: "ExternalWage",
    Failed: "Failed",
    FamilyName: "FamilyName",
    FeesAndCommissions: "FeesAndCommissions",
    FeesAndCommissionsSettlementFormDescription: "FeesAndCommissionsSettlementFormDescription",
    FenderPresence: "FenderPresence",
    Field: "Field",
    FieldAllowsToFilterVehicleLogByOrganisation: "FieldAllowsToFilterVehicleLogByOrganisation",
    FieldAllowsToMoveAroundVehicleLogByDateRange: "FieldAllowsToMoveAroundVehicleLogByDateRange",
    FieldAllowsToSearchItemsByVehicleName: "FieldAllowsToSearchItemsByVehicleName",
    FieldStructure: "FieldStructure",
    FieldStructureIconDescription: "FieldStructureIconDescription",
    FieldStructureIncidentIconDescription: "FieldStructureIncidentIconDescription",
    FieldStructureIncidentTypeDescription: "FieldStructureIncidentTypeDescription",
    FieldsToBeCompleted: "FieldsToBeCompleted",
    File: "File",
    FileCannotBeBiggerThan50MB: "FileCannotBeBiggerThan50MB",
    FileContentNotAvailable: "FileContentNotAvailable",
    FileDelete: "FileDelete",
    FileDeleteMessage: "FileDeleteMessage",
    FileDoesNotBelongToDriver: "FileDoesNotBelongToDriver",
    FileFormatNotAllowed: "FileFormatNotAllowed",
    FileImport: "FileImport",
    FileIsRequired: "FileIsRequired",
    FileLoadedCorrectly: "FileLoadedCorrectly",
    FileName: "FileName",
    FileNotFound: "FileNotFound",
    FileNotValid: "FileNotValid",
    FileTooLarge: "FileTooLarge",
    FileType: "FileType",
    FileTypeAlreadyUploaded: "FileTypeAlreadyUploaded",
    FileTypeCannotBeUploadedByDriver: "FileTypeCannotBeUploadedByDriver",
    FileTypeNotAllowedForProfile: "FileTypeNotAllowedForProfile",
    FileUploadedByDriver: "FileUploadedByDriver",
    Files: "Files",
    FilesInstallmentsDescription: "FilesInstallmentsDescription",
    FilesToProcess: "FilesToProcess",
    Fill: "Fill",
    FillEmptyFields: "FillEmptyFields",
    FillReceiveProtocol: "FillReceiveProtocol",
    FillReceiveProtocolAlert: "FillReceiveProtocolAlert",
    FillReport: "FillReport",
    FillWithAi: "FillWithAi",
    Filter: "Filter",
    FilterValues: "FilterValues",
    Finished: "Finished",
    FinishedSettlementListDescription: "FinishedSettlementListDescription",
    FireExtinguisher: "FireExtinguisher",
    FirstInstallmentDate: "FirstInstallmentDate",
    FirstInstallmentDateCannotBeLowerThanTomorrow: "FirstInstallmentDateCannotBeLowerThanTomorrow",
    FirstInstallmentDateDescription: "FirstInstallmentDateDescription",
    FirstName: "FirstName",
    FirstNameAndOrLastName: "FirstNameAndOrLastName",
    FirstNameLastNameSampleCell: "FirstNameLastNameSampleCell",
    FixedQuota: "FixedQuota",
    Flashlights: "Flashlights",
    FlatNumber: "FlatNumber",
    FoldingLock: "FoldingLock",
    FollowUpQuestions: "FollowUpQuestions",
    FoodContainerLeaseAgreement: "FoodContainerLeaseAgreement",
    FoodImportIsInProgress: "FoodImportIsInProgress",
    ForActivateSelectPayoff: "ForActivateSelectPayoff",
    ForDate: "ForDate",
    ForFuturePayment: "ForFuturePayment",
    ForFuturePaymentForTransport: "ForFuturePaymentForTransport",
    ForFuturePaymentPayoffCannotBePaidByDriver: "ForFuturePaymentPayoffCannotBePaidByDriver",
    ForSelectedRecordDataWillBeUpdatedIrreversiblyDoYouWantToContinue: "ForSelectedRecordDataWillBeUpdatedIrreversiblyDoYouWantToContinue",
    ForToday: "ForToday",
    ForVerification: "ForVerification",
    ForYear: "ForYear",
    ForceAll: "ForceAll",
    ForceAlwaysIndividualInvoice: "ForceAlwaysIndividualInvoice",
    ForceRavapiPaymentsTitle: "ForceRavapiPaymentsTitle",
    ForceStatus: "ForceStatus",
    ForcedRavapiPaymentsTitle: "ForcedRavapiPaymentsTitle",
    Form: "Form",
    FormDoesNotExist: "FormDoesNotExist",
    FormHasBeenModified: "FormHasBeenModified",
    FormInitiated: "FormInitiated",
    FormStatus: "FormStatus",
    FragmentNotPlacedHint: "FragmentNotPlacedHint",
    Frame: "Frame",
    Fraud: "Fraud",
    FreeField: "FreeField",
    FreeNow: "FreeNow",
    Friday: "Friday",
    FriendReferral: "FriendReferral",
    From: "From",
    FromRent: "FromRent",
    Front: "Front",
    FrontBumper: "FrontBumper",
    FrontFender: "FrontFender",
    FrontLeftDoor: "FrontLeftDoor",
    FrontLeftFender: "FrontLeftFender",
    FrontLeftWheel: "FrontLeftWheel",
    FrontRightDoor: "FrontRightDoor",
    FrontRightFender: "FrontRightFender",
    FrontRightWheel: "FrontRightWheel",
    FrontWheel: "FrontWheel",
    FrontWindshield: "FrontWindshield",
    FuelCard: "FuelCard",
    FuelCards: "FuelCards",
    FuelLevel: "FuelLevel",
    Full: "Full",
    FullName: "FullName",
    FullTimeEmploymentTypeSiiLimitCannotBeLessThanOneEightSiiLimit: "FullTimeEmploymentTypeSiiLimitCannotBeLessThanOneEightSiiLimit",
    FullTimeJob: "FullTimeJob",
    Funding: "Funding",
    FundingType: "FundingType",
    GaveConsentToSendPit11ByEmail: "GaveConsentToSendPit11ByEmail",
    General: "General",
    GeneralInformation: "GeneralInformation",
    GeneralPhotos: "GeneralPhotos",
    GeneralProtocol: "GeneralProtocol",
    GenerateCRD: "GenerateCRD",
    GenerateCRDMessage: "GenerateCRDMessage",
    GenerateGeneralProtocol: "GenerateGeneralProtocol",
    GeneratePostOfficeBook: "GeneratePostOfficeBook",
    GenerateSummary: "GenerateSummary",
    GeneratingSummaryForTaxSettlement: "GeneratingSummaryForTaxSettlement",
    GetRandomDriverEmailResult: "GetRandomDriverEmailResult",
    GetsEmailsAboutSettlementsRequireAttention: "GetsEmailsAboutSettlementsRequireAttention",
    GivenResource: "GivenResource",
    Gloves: "Gloves",
    GoToReservations: "GoToReservations",
    GoogleSearch: "GoogleSearch",
    GrantedDate: "GrantedDate",
    GreaterThan: "GreaterThan",
    GrossAmount: "GrossAmount",
    GroupType: "GroupType",
    Groups: "Groups",
    GuaranteedRate: "GuaranteedRate",
    GuaranteedRateOrPerentageOfTheCityResultIsRequired: "GuaranteedRateOrPerentageOfTheCityResultIsRequired",
    GusDataStatus: "GusDataStatus",
    GusServiceIsCurrentlyUnavailablePleaseTryAgainLater: "GusServiceIsCurrentlyUnavailablePleaseTryAgainLater",
    HR: "HR",
    HadABirthdayThisYear: "HadABirthdayThisYear",
    HadPayout: "HadPayout",
    HadPayoutTagDescription: "HadPayoutTagDescription",
    HalfTimeJob: "HalfTimeJob",
    HandingOver: "HandingOver",
    HasBeenDeferred: "HasBeenDeferred",
    HasBeenSend: "HasBeenSend",
    HasBeenSendReportListDescription: "HasBeenSendReportListDescription",
    HasBeenSettled: "HasBeenSettled",
    HasBeenSettledSettlementFormAlert: "HasBeenSettledSettlementFormAlert",
    HasContactBeenMade: "HasContactBeenMade",
    HasDisabilityCertificate: "HasDisabilityCertificate",
    HasMobileApplication: "HasMobileApplication",
    HasMobileApplicationStatusDescription: "HasMobileApplicationStatusDescription",
    HasNoIconYouAreLookingFor: "HasNoIconYouAreLookingFor",
    HasOwnTransport: "HasOwnTransport",
    HaveAcceesToSmsCampaigns: "HaveAcceesToSmsCampaigns",
    HaveAccessToAiKnowledgeBase: "HaveAccessToAiKnowledgeBase",
    HaveAccessToDigitalDocumentsManageArea: "HaveAccessToDigitalDocumentsManageArea",
    HaveAccessToDigitalSignatureDocuments: "HaveAccessToDigitalSignatureDocuments",
    HaveAccessToExportDebtorsForPenaltySummary: "HaveAccessToExportDebtorsForPenaltySummary",
    HaveAccessToExportsArea: "HaveAccessToExportsArea",
    HaveAccessToInvitePrograms: "HaveAccessToInvitePrograms",
    HaveAccessToMailArea: "HaveAccessToMailArea",
    HaveAccessToOnlinePayments: "HaveAccessToOnlinePayments",
    HaveAccessToPayUPayments: "HaveAccessToPayUPayments",
    HaveAccessToReferral: "HaveAccessToReferral",
    HaveAccessToReportArea: "HaveAccessToReportArea",
    HaveAccessToVehicleRentDigitalDocuments: "HaveAccessToVehicleRentDigitalDocuments",
    HaveFullAccessToEditSmsCampaigns: "HaveFullAccessToEditSmsCampaigns",
    HealthInsurance: "HealthInsurance",
    Helmet: "Helmet",
    HiddenInMobileApp: "HiddenInMobileApp",
    HideFromMobileApp: "HideFromMobileApp",
    HidePaid: "HidePaid",
    HighPriority: "HighPriority",
    HighestPriority: "HighestPriority",
    Hood: "Hood",
    Hour: "Hour",
    HoverMouseOnIconToSeeTooltip: "HoverMouseOnIconToSeeTooltip",
    HowDoesHeKnowAboutUs: "HowDoesHeKnowAboutUs",
    HowMuchYouEarnPerInvited: "HowMuchYouEarnPerInvited",
    HowVehicleSharingModeWorks: "HowVehicleSharingModeWorks",
    HrFlowSaveWarningContractOtherEmployer: "HrFlowSaveWarningContractOtherEmployer",
    HrFlowSaveWarningQuestion: "HrFlowSaveWarningQuestion",
    HrFlowSaveWarningTitle: "HrFlowSaveWarningTitle",
    HrFlowSaveWarningWaitingSettlements: "HrFlowSaveWarningWaitingSettlements",
    HrFlowSaveWarningWorkPermit: "HrFlowSaveWarningWorkPermit",
    HrNotes: "HrNotes",
    HrStatus: "HrStatus",
    HrStatusMessage: "HrStatusMessage",
    HrTag: "HrTag",
    HrTagNotFound: "HrTagNotFound",
    HrTagSettings: "HrTagSettings",
    HrTags: "HrTags",
    IStudyAtSchool: "IStudyAtSchool",
    IStudyAtUniversity: "IStudyAtUniversity",
    IWantToProvideMyOwnIndex: "IWantToProvideMyOwnIndex",
    IWantToTypeCustomTax: "IWantToTypeCustomTax",
    Icon: "Icon",
    IconColor: "IconColor",
    IconManagement: "IconManagement",
    IconMissing: "IconMissing",
    IconName: "IconName",
    IconSchema: "IconSchema",
    IconSchemaDelete: "IconSchemaDelete",
    IconSchemaList: "IconSchemaList",
    IconScope: "IconScope",
    IconText: "IconText",
    IdBack: "IdBack",
    IdCardAsPledge: "IdCardAsPledge",
    IdCardAuthority: "IdCardAuthority",
    IdFront: "IdFront",
    IdNumber: "IdNumber",
    IdentifierNumber: "IdentifierNumber",
    IfProblemRecurs: "IfProblemRecurs",
    Import: "Import",
    ImportFinished: "ImportFinished",
    ImportFinishedCheckLogs: "ImportFinishedCheckLogs",
    ImportFood: "ImportFood",
    ImportLogs: "ImportLogs",
    ImportName: "ImportName",
    ImportNeedMoreTime: "ImportNeedMoreTime",
    ImportPayoffs: "ImportPayoffs",
    ImportPayoffsTitle: "ImportPayoffsTitle",
    ImportSettlements: "ImportSettlements",
    Imported: "Imported",
    ImportedWithDriver: "ImportedWithDriver",
    ImportedWithoutDriverWithApplicationAccount: "ImportedWithoutDriverWithApplicationAccount",
    ImportedWithoutDriverWithoutApplicationAccount: "ImportedWithoutDriverWithoutApplicationAccount",
    InBank: "InBank",
    InMobileApp: "InMobileApp",
    InSupportTicket: "InSupportTicket",
    InWorkshop: "InWorkshop",
    Inactive: "Inactive",
    InactiveInSII: "InactiveInSII",
    InactiveSchemas: "InactiveSchemas",
    InactiveStatusDescription: "InactiveStatusDescription",
    Incident: "Incident",
    IncidentCreate: "IncidentCreate",
    IncidentDate: "IncidentDate",
    IncidentDateCannotBeThanEventFromVehicleLog: "IncidentDateCannotBeThanEventFromVehicleLog",
    IncidentDateCannotBeThanOtherIncidentDate: "IncidentDateCannotBeThanOtherIncidentDate",
    IncidentDateMustBeEqualWithSelectedCellDate: "IncidentDateMustBeEqualWithSelectedCellDate",
    IncidentDelete: "IncidentDelete",
    IncidentDeleteMessage: "IncidentDeleteMessage",
    IncidentDescription: "IncidentDescription",
    IncidentEdit: "IncidentEdit",
    IncidentIconDetailsMouseOverDescription: "IncidentIconDetailsMouseOverDescription",
    IncidentIconDetailsTitle: "IncidentIconDetailsTitle",
    IncidentIconDetailsVisibilityDescription: "IncidentIconDetailsVisibilityDescription",
    IncidentIsUnavailableFromForm: "IncidentIsUnavailableFromForm",
    IncidentType: "IncidentType",
    IncidentTypeBackToFleet: "IncidentTypeBackToFleet",
    IncidentTypeConvey: "IncidentTypeConvey",
    IncidentTypeCrash: "IncidentTypeCrash",
    IncidentTypeFailure: "IncidentTypeFailure",
    IncidentTypeFee: "IncidentTypeFee",
    IncidentTypeMaintain: "IncidentTypeMaintain",
    IncidentTypeOther: "IncidentTypeOther",
    IncidentTypeReceiveFromWorkshopHint: "IncidentTypeReceiveFromWorkshopHint",
    IncidentTypeReceiveFromWorkshopShortHint: "IncidentTypeReceiveFromWorkshopShortHint",
    IncidentTypeReservationHint: "IncidentTypeReservationHint",
    IncidentTypeReservationShortHint: "IncidentTypeReservationShortHint",
    IncidentTypeReturn: "IncidentTypeReturn",
    IncidentTypeTheft: "IncidentTypeTheft",
    IncidentTypeTheftHint: "IncidentTypeTheftHint",
    IncidentTypeTheftShortHint: "IncidentTypeTheftShortHint",
    IncidentTypeTownTransfer: "IncidentTypeTownTransfer",
    IncidentTypeWorkshop: "IncidentTypeWorkshop",
    IncidentTypeWorkshopHint: "IncidentTypeWorkshopHint",
    IncidentTypeWorkshopShortHint: "IncidentTypeWorkshopShortHint",
    IncludeAllRecords: "IncludeAllRecords",
    IncludeDeposits: "IncludeDeposits",
    IncludeInLegalizationMailingList: "IncludeInLegalizationMailingList",
    IncludedInPromotionDayOff: "IncludedInPromotionDayOff",
    IncludedInReport: "IncludedInReport",
    IncludesDocument: "IncludesDocument",
    Income: "Income",
    IncomingCashFlowReportReminder: "IncomingCashFlowReportReminder",
    IncompleteForm: "IncompleteForm",
    Increase: "Increase",
    Indefinitely: "Indefinitely",
    Index: "Index",
    Individual: "Individual",
    InformationAboutSelectedDrivers: "InformationAboutSelectedDrivers",
    InformationHrTagShortDescription: "InformationHrTagShortDescription",
    InformationTags: "InformationTags",
    InformationTagsShortDescription: "InformationTagsShortDescription",
    IngCard: "IngCard",
    IngCardNumber: "IngCardNumber",
    InitialCashBalance: "InitialCashBalance",
    InitiallyEstimatedCampaignCost: "InitiallyEstimatedCampaignCost",
    InitiallyEstimatedCampaignCostAlert: "InitiallyEstimatedCampaignCostAlert",
    InstallmentDelete: "InstallmentDelete",
    InstallmentDeleteMessage: "InstallmentDeleteMessage",
    InstallmentSchema: "InstallmentSchema",
    InstallmentSchemaCancelAlert: "InstallmentSchemaCancelAlert",
    InstallmentSchemaCreate: "InstallmentSchemaCreate",
    InstallmentSchemaDescription: "InstallmentSchemaDescription",
    InstallmentSchemaEdit: "InstallmentSchemaEdit",
    InstallmentTypeDescription: "InstallmentTypeDescription",
    InstallmentValueType: "InstallmentValueType",
    InstallmentValueTypeAlert: "InstallmentValueTypeAlert",
    Installments: "Installments",
    InstallmentsAreAlreadySuspended: "InstallmentsAreAlreadySuspended",
    InstallmentsCountCannotBeLowerThanPaid: "InstallmentsCountCannotBeLowerThanPaid",
    InstallmentsCountDescription: "InstallmentsCountDescription",
    InstallmentsSchemaNotFound: "InstallmentsSchemaNotFound",
    Insurance: "Insurance",
    InsuranceDetails: "InsuranceDetails",
    InsuranceFromContract: "InsuranceFromContract",
    InsuranceFromDuty: "InsuranceFromDuty",
    InsuranceFromOtherOrder: "InsuranceFromOtherOrder",
    InsuranceFromWork: "InsuranceFromWork",
    InsuranceSource: "InsuranceSource",
    InsuredByOtherPayer: "InsuredByOtherPayer",
    InsuredByOtherPayerTagDescription: "InsuredByOtherPayerTagDescription",
    InsuredFromContract: "InsuredFromContract",
    InsuredFromDifferentSource: "InsuredFromDifferentSource",
    InsuredFromDuty: "InsuredFromDuty",
    InsuredFromOtherOrder: "InsuredFromOtherOrder",
    InsuredFromWork: "InsuredFromWork",
    Interior: "Interior",
    InteriorCondition: "InteriorCondition",
    Interval: "Interval",
    IntervalDescription: "IntervalDescription",
    IntoBonus: "IntoBonus",
    InvalidCancelReason: "InvalidCancelReason",
    InvalidDateRange: "InvalidDateRange",
    InvalidDocumentType: "InvalidDocumentType",
    InvalidImageFormatAllowedIs0: "InvalidImageFormatAllowedIs0",
    InvalidNipFormat: "InvalidNipFormat",
    InvalidOperation: "InvalidOperation",
    InvalidPhoneNumberFormat: "InvalidPhoneNumberFormat",
    InviteCode: "InviteCode",
    InviteProgramCannotEditPublished: "InviteProgramCannotEditPublished",
    InviteProgramConditionRentedVehicle: "InviteProgramConditionRentedVehicle",
    InviteProgramConditionWorkedDays: "InviteProgramConditionWorkedDays",
    InviteProgramDatesOverlap: "InviteProgramDatesOverlap",
    InviteProgramGroupMustHaveAtLeastOneCondition: "InviteProgramGroupMustHaveAtLeastOneCondition",
    InviteProgramGroupPriorityMustBeUnique: "InviteProgramGroupPriorityMustBeUnique",
    InviteProgramGroups: "InviteProgramGroups",
    InviteProgramGroupsHelper: "InviteProgramGroupsHelper",
    InviteProgramMustHaveAtLeastOneGroup: "InviteProgramMustHaveAtLeastOneGroup",
    InviteProgramNotFound: "InviteProgramNotFound",
    InviteProgramPriorityTooltip: "InviteProgramPriorityTooltip",
    InvitePrograms: "InvitePrograms",
    InvoiceIndexAlert: "InvoiceIndexAlert",
    InvoiceNotFound0: "InvoiceNotFound0",
    InvoiceNumber: "InvoiceNumber",
    InvoiceRecipient: "InvoiceRecipient",
    InvoiceServiceName: "InvoiceServiceName",
    InvoiceType: "InvoiceType",
    Invoices: "Invoices",
    InvoicingMethod: "InvoicingMethod",
    IsActive: "IsActive",
    IsActiveApplicationAccountsQuantity: "IsActiveApplicationAccountsQuantity",
    IsAddByVehicleLog: "IsAddByVehicleLog",
    IsAdvance: "IsAdvance",
    IsAlreadyAssignedToVehicle: "IsAlreadyAssignedToVehicle",
    IsAmountToBeUsedOnlyToPayOffRent: "IsAmountToBeUsedOnlyToPayOffRent",
    IsAssigned: "IsAssigned",
    IsAttentionRequired: "IsAttentionRequired",
    IsAuthorizedToRepresentTheCompany: "IsAuthorizedToRepresentTheCompany",
    IsAuthorizedToRepresentTheCompanyConfirmation: "IsAuthorizedToRepresentTheCompanyConfirmation",
    IsAuthorizedToSelfInvoicing: "IsAuthorizedToSelfInvoicing",
    IsAuthorizedToSelfInvoicingSince: "IsAuthorizedToSelfInvoicingSince",
    IsBanned: "IsBanned",
    IsBannedPermanentny: "IsBannedPermanentny",
    IsBezproblemTransportCommission: "IsBezproblemTransportCommission",
    IsCanceled: "IsCanceled",
    IsCashbackEnabled: "IsCashbackEnabled",
    IsChangingPartner: "IsChangingPartner",
    IsCommissionEqualDistributed: "IsCommissionEqualDistributed",
    IsCommissionForDailySettlement: "IsCommissionForDailySettlement",
    IsCompanyActive: "IsCompanyActive",
    IsCompanyActiveConfirmation: "IsCompanyActiveConfirmation",
    IsContactedForDebt: "IsContactedForDebt",
    IsCorrection: "IsCorrection",
    IsCreatedByDriver: "IsCreatedByDriver",
    IsCreatedByMissingSelfInvoicingPermission: "IsCreatedByMissingSelfInvoicingPermission",
    IsDeleted: "IsDeleted",
    IsDiscountedVehicleRent: "IsDiscountedVehicleRent",
    IsDocumentCorrect: "IsDocumentCorrect",
    IsDraft: "IsDraft",
    IsDriverGoingToWork: "IsDriverGoingToWork",
    IsDriverInOffice: "IsDriverInOffice",
    IsDrivingLicenseVerification: "IsDrivingLicenseVerification",
    IsEmailSentToDriver: "IsEmailSentToDriver",
    IsExcludedFromAutomaticSettlementReminder: "IsExcludedFromAutomaticSettlementReminder",
    IsExcludedFromB2BVerificationReminder: "IsExcludedFromB2BVerificationReminder",
    IsExcludedFromCommissions: "IsExcludedFromCommissions",
    IsExcludedFromDebtorsListReminder: "IsExcludedFromDebtorsListReminder",
    IsExcludedFromDriverDayOffReminderMailingList: "IsExcludedFromDriverDayOffReminderMailingList",
    IsExcludedFromDriversBirthdaysReminder: "IsExcludedFromDriversBirthdaysReminder",
    IsExcludedFromDuplicatedDriverReminder: "IsExcludedFromDuplicatedDriverReminder",
    IsExcludedFromHrMissingDataReminder: "IsExcludedFromHrMissingDataReminder",
    IsExcludedFromMissingVehicleRentDigitalDocumentsMailReminder: "IsExcludedFromMissingVehicleRentDigitalDocumentsMailReminder",
    IsExcludedFromMissingVehicleRentDigitalDocumentsMessageNotification: "IsExcludedFromMissingVehicleRentDigitalDocumentsMessageNotification",
    IsExcludedFromVehicleCommissionsReminder: "IsExcludedFromVehicleCommissionsReminder",
    IsIncludedInPromotionDayOff: "IsIncludedInPromotionDayOff",
    IsIncludedInTaxOfficeMultipleResultForDriverEmail: "IsIncludedInTaxOfficeMultipleResultForDriverEmail",
    IsInsured: "IsInsured",
    IsItAnEmergencyReceive: "IsItAnEmergencyReceive",
    IsMailOrderedToBeSent: "IsMailOrderedToBeSent",
    IsManualEdit: "IsManualEdit",
    IsNotDuplicate: "IsNotDuplicate",
    IsOwnedByDriver: "IsOwnedByDriver",
    IsPaid: "IsPaid",
    IsPaidByCash: "IsPaidByCash",
    IsPaidByDriver: "IsPaidByDriver",
    IsRavapiTransportCommission: "IsRavapiTransportCommission",
    IsRefund: "IsRefund",
    IsRefundDescription: "IsRefundDescription",
    IsRefundPayoffDescription: "IsRefundPayoffDescription",
    IsSent: "IsSent",
    IsSentToFlovi: "IsSentToFlovi",
    IsSigned: "IsSigned",
    IsSilenced: "IsSilenced",
    IsSilencedGlobalLabel: "IsSilencedGlobalLabel",
    IsStudent: "IsStudent",
    IsTakenCashShouldBeSubtractFromSettlement: "IsTakenCashShouldBeSubtractFromSettlement",
    IsThePaymentToBeUserToPayOffRent: "IsThePaymentToBeUserToPayOffRent",
    IsThisAccountCommission: "IsThisAccountCommission",
    IsThisBezproblemCommission: "IsThisBezproblemCommission",
    IsThisDeposit: "IsThisDeposit",
    IsThisPaymentForFuturePayoffs: "IsThisPaymentForFuturePayoffs",
    IsThisRavapiCommission: "IsThisRavapiCommission",
    IsVatPayer: "IsVatPayer",
    IsVatPayerConfirmation: "IsVatPayerConfirmation",
    IsVehicleBusy: "IsVehicleBusy",
    IsVehicleShared: "IsVehicleShared",
    IsWithdrawBlocked: "IsWithdrawBlocked",
    Issued: "Issued",
    IssuingInvoiceType: "IssuingInvoiceType",
    ItIncludes: "ItIncludes",
    KSeFConfirmedAt: "KSeFConfirmedAt",
    KSeFErrorLabel: "KSeFErrorLabel",
    KSeFInvoiceAlreadySentOrConfirmed: "KSeFInvoiceAlreadySentOrConfirmed",
    KSeFInvoiceCannotBeOverwritten: "KSeFInvoiceCannotBeOverwritten",
    KSeFInvoiceMode: "KSeFInvoiceMode",
    KSeFInvoiceNotFound: "KSeFInvoiceNotFound",
    KSeFInvoiceNotMarked: "KSeFInvoiceNotMarked",
    KSeFIsOffline: "KSeFIsOffline",
    KSeFMissingBuyerAddress: "KSeFMissingBuyerAddress",
    KSeFMissingSellerAddress: "KSeFMissingSellerAddress",
    KSeFMissingSubjectData: "KSeFMissingSubjectData",
    KSeFNumber: "KSeFNumber",
    KSeFRetryCountLabel: "KSeFRetryCountLabel",
    KSeFSendConfirmMultiple: "KSeFSendConfirmMultiple",
    KSeFSendConfirmSingle: "KSeFSendConfirmSingle",
    KSeFSendConfirmTitle: "KSeFSendConfirmTitle",
    KSeFSendResultsTitle: "KSeFSendResultsTitle",
    KSeFSentAt: "KSeFSentAt",
    KSeFStatus: "KSeFStatus",
    KSeFStatusConfirmed: "KSeFStatusConfirmed",
    KSeFStatusFailedUnavailable: "KSeFStatusFailedUnavailable",
    KSeFStatusLabel: "KSeFStatusLabel",
    KSeFStatusProcessing: "KSeFStatusProcessing",
    KSeFStatusQueued: "KSeFStatusQueued",
    KSeFStatusRejected: "KSeFStatusRejected",
    KSeFStatusSent: "KSeFStatusSent",
    KSeFStatusUnknown: "KSeFStatusUnknown",
    KSeFTrackingNotFound: "KSeFTrackingNotFound",
    KSeFXmlValidationError: "KSeFXmlValidationError",
    KSefDisabled: "KSefDisabled",
    KeyShortcut: "KeyShortcut",
    Keys: "Keys",
    Keywords: "Keywords",
    KeywordsHint: "KeywordsHint",
    KnowledgeLearningCard: "KnowledgeLearningCard",
    KnowledgeLearningEnabled: "KnowledgeLearningEnabled",
    KnowledgeLearningIntervalDays: "KnowledgeLearningIntervalDays",
    KnowledgeLearningLastRunAt: "KnowledgeLearningLastRunAt",
    KnowledgeLearningObservationExpiryDays: "KnowledgeLearningObservationExpiryDays",
    KnowledgeLearningPausedAlert: "KnowledgeLearningPausedAlert",
    KnowledgeLearningProposalThreshold: "KnowledgeLearningProposalThreshold",
    KnowledgeLearningTicketLimit: "KnowledgeLearningTicketLimit",
    Krs: "Krs",
    KsefMode: "KsefMode",
    KujawskoPomorskie: "KujawskoPomorskie",
    LPGAdapter: "LPGAdapter",
    Lacks: "Lacks",
    Language: "Language",
    LargeScreenAdvertising: "LargeScreenAdvertising",
    LastActivity: "LastActivity",
    LastModificationDate: "LastModificationDate",
    LastName: "LastName",
    LastTicketAt: "LastTicketAt",
    LatestIncidentDate: "LatestIncidentDate",
    LeaseAgreement: "LeaseAgreement",
    Leasing: "Leasing",
    LeftSide: "LeftSide",
    LeftSidePanel: "LeftSidePanel",
    LegalizationHistory: "LegalizationHistory",
    LegalizationHistoryCreate: "LegalizationHistoryCreate",
    LegalizationHistoryEdit: "LegalizationHistoryEdit",
    LegalizationHistoryEntryDelete: "LegalizationHistoryEntryDelete",
    LegalizationHistoryEntryDeleteMessage: "LegalizationHistoryEntryDeleteMessage",
    LegalizationHistoryType: "LegalizationHistoryType",
    LegalizationMailing: "LegalizationMailing",
    LegalizationOfStay: "LegalizationOfStay",
    LegalizationOfStayNotes: "LegalizationOfStayNotes",
    LegalizationProgramNewPerson: "LegalizationProgramNewPerson",
    LegalizationServices: "LegalizationServices",
    Legend: "Legend",
    Lessee: "Lessee",
    LessorPhoneNumber: "LessorPhoneNumber",
    LiabilityInsurance: "LiabilityInsurance",
    Licencing: "Licencing",
    LicenseNumber: "LicenseNumber",
    Lights: "Lights",
    LinkWasUsedOrIsStillValid: "LinkWasUsedOrIsStillValid",
    List: "List",
    ListOfDebtors: "ListOfDebtors",
    ListOfDriversWithReminderChangeRentalRate: "ListOfDriversWithReminderChangeRentalRate",
    ListSettlementListDescription: "ListSettlementListDescription",
    LoadDraft: "LoadDraft",
    LoadFromGallery: "LoadFromGallery",
    LoadMore: "LoadMore",
    Loading: "Loading",
    LoanAgreement: "LoanAgreement",
    Location: "Location",
    LockerNumberForClientId: "LockerNumberForClientId",
    Locks: "Locks",
    LocksMessage: "LocksMessage",
    Lodged: "Lodged",
    Lodzkie: "Lodzkie",
    Login: "Login",
    LoginSuccess: "LoginSuccess",
    Logout: "Logout",
    Logs: "Logs",
    LostAssets: "LostAssets",
    LostAssetsTable: "LostAssetsTable",
    LostAssetsTableStandardDiscountedDataTypeTooltip: "LostAssetsTableStandardDiscountedDataTypeTooltip",
    LostAssetsTheft: "LostAssetsTheft",
    LostAssetsWorkshop: "LostAssetsWorkshop",
    LostCommissionBezproblem: "LostCommissionBezproblem",
    LostCommissionRavapi: "LostCommissionRavapi",
    LostRentedVehicle: "LostRentedVehicle",
    LowPriority: "LowPriority",
    LowerThan: "LowerThan",
    Lubelskie: "Lubelskie",
    Lubuskie: "Lubuskie",
    MailAwaiting: "MailAwaiting",
    MailLogs: "MailLogs",
    MailPreview: "MailPreview",
    MailRules: "MailRules",
    MailSubject: "MailSubject",
    Malopolskie: "Malopolskie",
    ManageIcons: "ManageIcons",
    Manual: "Manual",
    ManualEditCommissions: "ManualEditCommissions",
    MarkAllAsReaded: "MarkAllAsReaded",
    MarkAs: "MarkAs",
    MarkAsFinished: "MarkAsFinished",
    MarkIncludedInReport: "MarkIncludedInReport",
    MarketingConsent: "MarketingConsent",
    MassAddSiiPayoffsChargedHeader: "MassAddSiiPayoffsChargedHeader",
    MassAddSiiPayoffsQuotaHeader: "MassAddSiiPayoffsQuotaHeader",
    MassAddSiiPayoffsSelectedCount: "MassAddSiiPayoffsSelectedCount",
    MassAddSiiPayoffsSkipReasonDriverNotEligible: "MassAddSiiPayoffsSkipReasonDriverNotEligible",
    MassAddSiiPayoffsSkipReasonLimitReached: "MassAddSiiPayoffsSkipReasonLimitReached",
    MassAddSiiPayoffsSkipReasonNothingToCharge: "MassAddSiiPayoffsSkipReasonNothingToCharge",
    MassAddSiiPayoffsSkippedHeader: "MassAddSiiPayoffsSkippedHeader",
    MassAddSiiPayoffsSummary: "MassAddSiiPayoffsSummary",
    MassCampaigns: "MassCampaigns",
    MassCancelSiiPayoffsQuestion: "MassCancelSiiPayoffsQuestion",
    MassChangeIncludedInPromotionDayOffDialogConfirmation: "MassChangeIncludedInPromotionDayOffDialogConfirmation",
    MassClearSettlementServiceFeeConfirm: "MassClearSettlementServiceFeeConfirm",
    MassDeleteConfirmation: "MassDeleteConfirmation",
    MassDeleteSettlements: "MassDeleteSettlements",
    MassDeleteSettlementsMessage: "MassDeleteSettlementsMessage",
    MassDeleteSupportTickets: "MassDeleteSupportTickets",
    MassDeleteSupportTicketsConfirmContent: "MassDeleteSupportTicketsConfirmContent",
    MassDeleteSupportTicketsConfirmTitle: "MassDeleteSupportTicketsConfirmTitle",
    MassDisableCashback: "MassDisableCashback",
    MassDisableCashbackConfirmation: "MassDisableCashbackConfirmation",
    MassEnableCashback: "MassEnableCashback",
    MassForceRavapiPaymentsTitleQuestion: "MassForceRavapiPaymentsTitleQuestion",
    MassMoveSettlementBackToWaitingQuestion: "MassMoveSettlementBackToWaitingQuestion",
    MassOperations: "MassOperations",
    MassOperationsSectionExport: "MassOperationsSectionExport",
    MassOperationsSectionGeneral: "MassOperationsSectionGeneral",
    MassOperationsSectionGenerate: "MassOperationsSectionGenerate",
    MassOperationsSectionSII: "MassOperationsSectionSII",
    MassRemoveForcedRavapiPaymentsTitleQuestion: "MassRemoveForcedRavapiPaymentsTitleQuestion",
    MassRemoveFromSII: "MassRemoveFromSII",
    MassRemoveFromSIICommonDate: "MassRemoveFromSIICommonDate",
    MassRemoveFromSIIConfirmButton: "MassRemoveFromSIIConfirmButton",
    MassRemoveFromSIIEligibleHeader: "MassRemoveFromSIIEligibleHeader",
    MassRemoveFromSIIKeepExisting: "MassRemoveFromSIIKeepExisting",
    MassRemoveFromSIIOverrideExisting: "MassRemoveFromSIIOverrideExisting",
    MassRemoveFromSIIOverrideExistingHint: "MassRemoveFromSIIOverrideExistingHint",
    MassRemoveFromSIISkipReasonMissingDate: "MassRemoveFromSIISkipReasonMissingDate",
    MassRemoveFromSIISkipReasonMissingTag: "MassRemoveFromSIISkipReasonMissingTag",
    MassRemoveFromSIISkippedHeader: "MassRemoveFromSIISkippedHeader",
    MassRemoveFromSIISummary: "MassRemoveFromSIISummary",
    MassReportToSII: "MassReportToSII",
    MassReportToSIICommonDate: "MassReportToSIICommonDate",
    MassReportToSIIConfirmButton: "MassReportToSIIConfirmButton",
    MassReportToSIIEligibleHeader: "MassReportToSIIEligibleHeader",
    MassReportToSIIKeepExisting: "MassReportToSIIKeepExisting",
    MassReportToSIIOverrideExisting: "MassReportToSIIOverrideExisting",
    MassReportToSIIOverrideExistingHint: "MassReportToSIIOverrideExistingHint",
    MassReportToSIISkipReasonMissingDate: "MassReportToSIISkipReasonMissingDate",
    MassReportToSIISkipReasonMissingTag: "MassReportToSIISkipReasonMissingTag",
    MassReportToSIISkippedHeader: "MassReportToSIISkippedHeader",
    MassReportToSIISummary: "MassReportToSIISummary",
    MassSendEmailMessage: "MassSendEmailMessage",
    MassSettlementPaymentStatusChange: "MassSettlementPaymentStatusChange",
    MassSettlementPaymentStatusChangeMessage: "MassSettlementPaymentStatusChangeMessage",
    MassUpdateCashback: "MassUpdateCashback",
    MassUpdateSettlementServiceFeeConfirm: "MassUpdateSettlementServiceFeeConfirm",
    MasterOrganisation: "MasterOrganisation",
    MaxBatchSizeExceeded: "MaxBatchSizeExceeded",
    MaxClarificationAttempts: "MaxClarificationAttempts",
    MaxCorrectionNumberReached: "MaxCorrectionNumberReached",
    MaxDateRangeOneWeek: "MaxDateRangeOneWeek",
    MaxInstallments: "MaxInstallments",
    MaxOutputTokens: "MaxOutputTokens",
    MaxRewardAmount: "MaxRewardAmount",
    MaxSiiQuotaInMonth: "MaxSiiQuotaInMonth",
    MaxTextLength: "MaxTextLength",
    MaximumAttemptsExceededTryAgainLater: "MaximumAttemptsExceededTryAgainLater",
    MaximumDriversCountSelected: "MaximumDriversCountSelected",
    MaximumDriversOnSelectedVehicleReached: "MaximumDriversOnSelectedVehicleReached",
    MaximumFilesCountExceeded: "MaximumFilesCountExceeded",
    Mazowieckie: "Mazowieckie",
    MeaningThatDayHasAlreadyPaymentTypeSet: "MeaningThatDayHasAlreadyPaymentTypeSet",
    MedicalExamination: "MedicalExamination",
    Message: "Message",
    MessageContent: "MessageContent",
    MessageIsTooLong: "MessageIsTooLong",
    MiddleAndPassengerSeat: "MiddleAndPassengerSeat",
    MiddleAndPassengerSeatHint: "MiddleAndPassengerSeatHint",
    Mileage: "Mileage",
    MileageCannotBeLowerThan: "MileageCannotBeLowerThan",
    MileageMustBeAnInteger: "MileageMustBeAnInteger",
    Min8Signs: "Min8Signs",
    MinQuotaForDailyPayout: "MinQuotaForDailyPayout",
    MinQuotaForWeeklyPayout: "MinQuotaForWeeklyPayout",
    MinTextLength: "MinTextLength",
    Minus: "Minus",
    Mirrors: "Mirrors",
    Missing: "Missing",
    MissingActivity: "MissingActivity",
    MissingAddressDataToContinue0: "MissingAddressDataToContinue0",
    MissingAnnuitantCard: "MissingAnnuitantCard",
    MissingAnnuitantCardTagDescription: "MissingAnnuitantCardTagDescription",
    MissingCurrentInsurance: "MissingCurrentInsurance",
    MissingCurrentInsuranceTagDescription: "MissingCurrentInsuranceTagDescription",
    MissingData: "MissingData",
    MissingDataCategory: "MissingDataCategory",
    MissingDataNotApplicable: "MissingDataNotApplicable",
    MissingDataTagDescription: "MissingDataTagDescription",
    MissingDisabilityCertificate: "MissingDisabilityCertificate",
    MissingDisabilityCertificateTagDescription: "MissingDisabilityCertificateTagDescription",
    MissingDocumentsToSign: "MissingDocumentsToSign",
    MissingDriversDocuments: "MissingDriversDocuments",
    MissingDrivingLicenseNumber: "MissingDrivingLicenseNumber",
    MissingDutyInsuranceTagDescription: "MissingDutyInsuranceTagDescription",
    MissingInsuranceFromDuty: "MissingInsuranceFromDuty",
    MissingPensionerCard: "MissingPensionerCard",
    MissingPensionerCardTagDescription: "MissingPensionerCardTagDescription",
    MissingPesel: "MissingPesel",
    MissingPeselTagDescription: "MissingPeselTagDescription",
    MissingRequiredFilesAfterRegistration: "MissingRequiredFilesAfterRegistration",
    MissingTags: "MissingTags",
    MissingTagsShortDescription: "MissingTagsShortDescription",
    MissingTaxOffice: "MissingTaxOffice",
    MissingTaxOfficeTagDescription: "MissingTaxOfficeTagDescription",
    MissingText: "MissingText",
    MissingTransferProtocol: "MissingTransferProtocol",
    MobileAppVisibility: "MobileAppVisibility",
    MobileApplicationAccountDisabled: "MobileApplicationAccountDisabled",
    MobileVersionUpdateRequired: "MobileVersionUpdateRequired",
    Model: "Model",
    ModelSerialNumber: "ModelSerialNumber",
    Modification: "Modification",
    ModificationDate: "ModificationDate",
    ModificationHistory: "ModificationHistory",
    ModifiedBy: "ModifiedBy",
    Monday: "Monday",
    MoneyChange: "MoneyChange",
    MoneyChangeToReturn: "MoneyChangeToReturn",
    Month: "Month",
    MonthlyBudget: "MonthlyBudget",
    More: "More",
    MotorBackHint: "MotorBackHint",
    MotorBikeSeatHint: "MotorBikeSeatHint",
    MotorCoolantLevelHint: "MotorCoolantLevelHint",
    MotorCover: "MotorCover",
    MotorDashboardCloseupHint: "MotorDashboardCloseupHint",
    MotorDashboardHint: "MotorDashboardHint",
    MotorFrontHint: "MotorFrontHint",
    MotorLeftSideHint: "MotorLeftSideHint",
    MotorRightSideHint: "MotorRightSideHint",
    MotorScooter: "MotorScooter",
    MotorsInMaintain: "MotorsInMaintain",
    MotorsInUse: "MotorsInUse",
    MotorsInWorkshop: "MotorsInWorkshop",
    MotorsNotUsed: "MotorsNotUsed",
    MotorsRented: "MotorsRented",
    MotorsReturned: "MotorsReturned",
    MotorsScooters: "MotorsScooters",
    MotorsWorking: "MotorsWorking",
    MouseOverToShowAdditionalHints: "MouseOverToShowAdditionalHints",
    MoveToRecord: "MoveToRecord",
    MovedFromTo: "MovedFromTo",
    MustAddAtLeastOneProduct: "MustAddAtLeastOneProduct",
    MustBeFullHour: "MustBeFullHour",
    MustBeGreaterThanOrEqualNextFullHour: "MustBeGreaterThanOrEqualNextFullHour",
    MustHaveCorrectBankAccountNumberFormat: "MustHaveCorrectBankAccountNumberFormat",
    MustHaveCorrectFormat: "MustHaveCorrectFormat",
    MustHaveCorrectPeselFormat: "MustHaveCorrectPeselFormat",
    MustHaveCorrectPostalCodeFormat: "MustHaveCorrectPostalCodeFormat",
    MustHaveFormat: "MustHaveFormat",
    MyDriverList: "MyDriverList",
    MyDriverListDescription: "MyDriverListDescription",
    NFZ: "NFZ",
    Name: "Name",
    NameIsAlreadyTaken: "NameIsAlreadyTaken",
    Nationality: "Nationality",
    NeededSiiDecision: "NeededSiiDecision",
    NetAmount: "NetAmount",
    New: "New",
    NewActiveDrivers: "NewActiveDrivers",
    NewArticle: "NewArticle",
    NewDefects: "NewDefects",
    NewDriversContact: "NewDriversContact",
    NewDriversNotContact: "NewDriversNotContact",
    NewHistoryEntry: "NewHistoryEntry",
    NewPassword: "NewPassword",
    NewPasswordSentToUserEmail: "NewPasswordSentToUserEmail",
    NewPayoff: "NewPayoff",
    NewSchema: "NewSchema",
    NewSince0: "NewSince0",
    NewStatusDescription: "NewStatusDescription",
    NewTabLayout: "NewTabLayout",
    NewTabLayoutTutorial: "NewTabLayoutTutorial",
    NewUser: "NewUser",
    Next: "Next",
    NextDay: "NextDay",
    NextDayFilterReportListDescription: "NextDayFilterReportListDescription",
    NextMonth: "NextMonth",
    NextMonthFilterReportListDescription: "NextMonthFilterReportListDescription",
    NextWeek: "NextWeek",
    NextWeekFilterReportListDescription: "NextWeekFilterReportListDescription",
    NfzOrganization: "NfzOrganization",
    Nip: "Nip",
    No: "No",
    NoAccess: "NoAccess",
    NoApplicationAccountsAvailable: "NoApplicationAccountsAvailable",
    NoApplicationsData: "NoApplicationsData",
    NoCampaigns: "NoCampaigns",
    NoConditions: "NoConditions",
    NoCreditDescription: "NoCreditDescription",
    NoData: "NoData",
    NoDataToImportSkipping: "NoDataToImportSkipping",
    NoDefects: "NoDefects",
    NoDocumentsToSign: "NoDocumentsToSign",
    NoDriverHistoryAssignedToApplicationAccount: "NoDriverHistoryAssignedToApplicationAccount",
    NoDriversHistory: "NoDriversHistory",
    NoDriversSelected: "NoDriversSelected",
    NoEarningApplicationSettlementCalculationMethod: "NoEarningApplicationSettlementCalculationMethod",
    NoFiles: "NoFiles",
    NoHistory: "NoHistory",
    NoIncidents: "NoIncidents",
    NoIncidentsToRemove: "NoIncidentsToRemove",
    NoInvoicesProvided: "NoInvoicesProvided",
    NoLogs: "NoLogs",
    NoMatchingTaxOfficeFound: "NoMatchingTaxOfficeFound",
    NoNameToShow: "NoNameToShow",
    NoNotifications: "NoNotifications",
    NoOrganisationForDriverSkipping: "NoOrganisationForDriverSkipping",
    NoOrganisations: "NoOrganisations",
    NoPaymentSettings: "NoPaymentSettings",
    NoPermissionToRemoveOnlinePayment: "NoPermissionToRemoveOnlinePayment",
    NoPhoneNumberSkipping: "NoPhoneNumberSkipping",
    NoRecordsToExport: "NoRecordsToExport",
    NoRegistrationNumberSkipping: "NoRegistrationNumberSkipping",
    NoReportSchemas: "NoReportSchemas",
    NoRewardPackages: "NoRewardPackages",
    NoSettlementHistoryToShow: "NoSettlementHistoryToShow",
    NoSettlementNumber: "NoSettlementNumber",
    NoSettlementsInLast2Weeks: "NoSettlementsInLast2Weeks",
    NoSettlementsToCreateStopProcess: "NoSettlementsToCreateStopProcess",
    NoSettlementsToExport: "NoSettlementsToExport",
    NoSettlementsWithin2WeeksDescription: "NoSettlementsWithin2WeeksDescription",
    NoTransferProtocol: "NoTransferProtocol",
    NoUnpaidPayoffsFoundForSelectedDriver: "NoUnpaidPayoffsFoundForSelectedDriver",
    NoVehicleForRegistrationNumberSkipping: "NoVehicleForRegistrationNumberSkipping",
    None: "None",
    NormalPriority: "NormalPriority",
    NotAllRecordsMatchConditionToCreatePayment: "NotAllRecordsMatchConditionToCreatePayment",
    NotCreated: "NotCreated",
    NotFoundAnySettlementsToUpdate: "NotFoundAnySettlementsToUpdate",
    NotIdentifyTaxOfficeDrivers: "NotIdentifyTaxOfficeDrivers",
    NotIncludeCompanyBikeCommission: "NotIncludeCompanyBikeCommission",
    NotIncludedInExport: "NotIncludedInExport",
    NotIncludedInReport: "NotIncludedInReport",
    NotLodged: "NotLodged",
    NotPaid: "NotPaid",
    NotRented: "NotRented",
    NotRentedByMoreThanHalf: "NotRentedByMoreThanHalf",
    NotRentedByMoreThanOneDay: "NotRentedByMoreThanOneDay",
    NotRentedReadyToWork: "NotRentedReadyToWork",
    NotSend: "NotSend",
    NotSended: "NotSended",
    Notes: "Notes",
    NothingToSave: "NothingToSave",
    NoticePeriod: "NoticePeriod",
    NotificationCategoryRent: "NotificationCategoryRent",
    NotificationCategoryReservations: "NotificationCategoryReservations",
    NotificationCategorySupport: "NotificationCategorySupport",
    NotificationGroupToday: "NotificationGroupToday",
    NotificationReservationCancelled: "NotificationReservationCancelled",
    NotificationReservationCreated: "NotificationReservationCreated",
    NotificationSoundOff: "NotificationSoundOff",
    NotificationSoundOn: "NotificationSoundOn",
    NotificationSupportTicketClosedByDriver: "NotificationSupportTicketClosedByDriver",
    NotificationSupportTicketCreated: "NotificationSupportTicketCreated",
    NotificationSupportTicketDriverMessage: "NotificationSupportTicketDriverMessage",
    Notifications: "Notifications",
    NumberOfAccountActivationsFromReferralLink: "NumberOfAccountActivationsFromReferralLink",
    NumberOfAccountRegisteredFromTheReferralLink: "NumberOfAccountRegisteredFromTheReferralLink",
    NumberOfActivatedAccounts: "NumberOfActivatedAccounts",
    NumberOfActivationsOfDriverAccounts: "NumberOfActivationsOfDriverAccounts",
    NumberOfCallsForPayment: "NumberOfCallsForPayment",
    NumberOfDaysUntilCodeExpires: "NumberOfDaysUntilCodeExpires",
    NumberOfRegistrations: "NumberOfRegistrations",
    NumberOfRegistrationsFromReferrals: "NumberOfRegistrationsFromReferrals",
    NumberOfRentalDays: "NumberOfRentalDays",
    NumberOfRentalDaysFromReferralLink: "NumberOfRentalDaysFromReferralLink",
    Of: "Of",
    OfficeAnswer: "OfficeAnswer",
    OfficeDecision: "OfficeDecision",
    OfficeVisitRequired: "OfficeVisitRequired",
    Ok: "Ok",
    Old: "Old",
    OldPassword: "OldPassword",
    OnDemand: "OnDemand",
    OnDemandPayoutsAccess: "OnDemandPayoutsAccess",
    OnDemandPayoutsNotAvailableForOrganisation: "OnDemandPayoutsNotAvailableForOrganisation",
    OnHandActions: "OnHandActions",
    OneEighthTimeJob: "OneEighthTimeJob",
    OneFromFieldsMustBeSelected: "OneFromFieldsMustBeSelected",
    OneInstallmentValue: "OneInstallmentValue",
    OneInstallmentValueDescription: "OneInstallmentValueDescription",
    OneOfNVehicles: "OneOfNVehicles",
    OnlinePaymentDashboardAlert: "OnlinePaymentDashboardAlert",
    OnlinePaymentDeleteAlert: "OnlinePaymentDeleteAlert",
    OnlinePaymentIdentifier: "OnlinePaymentIdentifier",
    OnlinePaymentInvoiceServiceName: "OnlinePaymentInvoiceServiceName",
    OnlinePaymentInvoiceVatAmount: "OnlinePaymentInvoiceVatAmount",
    OnlinePaymentInvoices: "OnlinePaymentInvoices",
    OnlinePaymentInvoicingMethod: "OnlinePaymentInvoicingMethod",
    OnlinePaymentNotFound: "OnlinePaymentNotFound",
    OnlinePayments: "OnlinePayments",
    OnlyAdministratorIsAbleToChangeSettlementPaymentStatusWithPromotionDayOff: "OnlyAdministratorIsAbleToChangeSettlementPaymentStatusWithPromotionDayOff",
    OnlyCarsAreAbleToChangeMultipleDrivers: "OnlyCarsAreAbleToChangeMultipleDrivers",
    OnlyDaily: "OnlyDaily",
    OnlyDriver: "OnlyDriver",
    OnlyFieldIsEditableWhenPayoffReasonIs: "OnlyFieldIsEditableWhenPayoffReasonIs",
    OnlyOneRateShouldBeSelected: "OnlyOneRateShouldBeSelected",
    OnlyPayoffWithReason0IsAbleToBlockDriverWithdraw: "OnlyPayoffWithReason0IsAbleToBlockDriverWithdraw",
    OnlyReservationHasFutureDate: "OnlyReservationHasFutureDate",
    OnlyUnsentRecords: "OnlyUnsentRecords",
    OnlyVehicle: "OnlyVehicle",
    OpenInNewWindow: "OpenInNewWindow",
    OpenSupportTicket: "OpenSupportTicket",
    Opened: "Opened",
    OperationAvailableForSettlementsWithStatus: "OperationAvailableForSettlementsWithStatus",
    OperationCompletedCheckLogs: "OperationCompletedCheckLogs",
    Operator: "Operator",
    Opolskie: "Opolskie",
    OptimaExport: "OptimaExport",
    OptimaExportDriverDescription: "OptimaExportDriverDescription",
    OptimaExportPreviewAllComplete: "OptimaExportPreviewAllComplete",
    OptimaExportPreviewLevelMissing: "OptimaExportPreviewLevelMissing",
    OptimaExportPreviewLevelWarning: "OptimaExportPreviewLevelWarning",
    OptimaExportPreviewReasonBankAccountTooShort: "OptimaExportPreviewReasonBankAccountTooShort",
    OptimaExportPreviewReasonBothPensionRights: "OptimaExportPreviewReasonBothPensionRights",
    OptimaExportPreviewReasonCitizenshipNotInDictionary: "OptimaExportPreviewReasonCitizenshipNotInDictionary",
    OptimaExportPreviewReasonCommuneCodeMissing: "OptimaExportPreviewReasonCommuneCodeMissing",
    OptimaExportPreviewReasonDisabilityLevelMissing: "OptimaExportPreviewReasonDisabilityLevelMissing",
    OptimaExportPreviewReasonDuplicateCode: "OptimaExportPreviewReasonDuplicateCode",
    OptimaExportPreviewReasonFlatNumberEmpty: "OptimaExportPreviewReasonFlatNumberEmpty",
    OptimaExportPreviewReasonMissing: "OptimaExportPreviewReasonMissing",
    OptimaExportPreviewReasonNoActiveContractOfMandate: "OptimaExportPreviewReasonNoActiveContractOfMandate",
    OptimaExportPreviewReasonNotApplicableB2B: "OptimaExportPreviewReasonNotApplicableB2B",
    OptimaExportPreviewReasonNotApplicableInsuredByOtherPayer: "OptimaExportPreviewReasonNotApplicableInsuredByOtherPayer",
    OptimaExportPreviewReasonNotApplicableRentOnly: "OptimaExportPreviewReasonNotApplicableRentOnly",
    OptimaExportPreviewReasonNotApplicableSiiResignation: "OptimaExportPreviewReasonNotApplicableSiiResignation",
    OptimaExportPreviewReasonNotApplicableStudent: "OptimaExportPreviewReasonNotApplicableStudent",
    OptimaExportPreviewReasonPeselMissingOrInvalid: "OptimaExportPreviewReasonPeselMissingOrInvalid",
    OptimaExportPreviewReasonTaxOfficeNotInDictionary: "OptimaExportPreviewReasonTaxOfficeNotInDictionary",
    OptimaExportPreviewRefresh: "OptimaExportPreviewRefresh",
    OptimaExportPreviewSummary: "OptimaExportPreviewSummary",
    OptimaExportPreviewTitle: "OptimaExportPreviewTitle",
    OptionWasNotSelected: "OptionWasNotSelected",
    Optional: "Optional",
    Options: "Options",
    Or: "Or",
    Organisation: "Organisation",
    OrganisationCreate: "OrganisationCreate",
    OrganisationDayOffDisableConfirmation: "OrganisationDayOffDisableConfirmation",
    OrganisationDelete: "OrganisationDelete",
    OrganisationDeleteMessage: "OrganisationDeleteMessage",
    OrganisationEdit: "OrganisationEdit",
    OrganisationFilterReportListDescription: "OrganisationFilterReportListDescription",
    OrganisationHasNoCompletedAddress: "OrganisationHasNoCompletedAddress",
    OrganisationIsNotIncludedInDayOffPromotion: "OrganisationIsNotIncludedInDayOffPromotion",
    OrganisationNotFound: "OrganisationNotFound",
    OrganisationOneToOneAlert: "OrganisationOneToOneAlert",
    OrganisationReport: "OrganisationReport",
    Organisational: "Organisational",
    Organisations: "Organisations",
    OrganisationsAccess: "OrganisationsAccess",
    Other: "Other",
    OtherAdvertising: "OtherAdvertising",
    OtherCosts: "OtherCosts",
    OtherInconsistences: "OtherInconsistences",
    OtherProblem: "OtherProblem",
    OtherProblemTagDescription: "OtherProblemTagDescription",
    OtherTypeCheckbox: "OtherTypeCheckbox",
    OutdatedData: "OutdatedData",
    OverduePaidAmount: "OverduePaidAmount",
    Owner: "Owner",
    Ownership: "Ownership",
    PESEL: "PESEL",
    PIT11Email: "PIT11Email",
    PageWillBeRefreshedChangesLost: "PageWillBeRefreshedChangesLost",
    Paid: "Paid",
    PaidAmount: "PaidAmount",
    PaidAmountSum: "PaidAmountSum",
    PaidByDrivers: "PaidByDrivers",
    PaidByOrganisation: "PaidByOrganisation",
    PaidQuota: "PaidQuota",
    PaperContract: "PaperContract",
    ParentsNames: "ParentsNames",
    ParseError: "ParseError",
    PartTimeJob: "PartTimeJob",
    PartnerCommissions: "PartnerCommissions",
    Password: "Password",
    PasswordChangedSuccessfully: "PasswordChangedSuccessfully",
    PasswordDoesNotMeetScurityRequirements: "PasswordDoesNotMeetScurityRequirements",
    PasswordHaveToMeetRequirements: "PasswordHaveToMeetRequirements",
    PasswordReset: "PasswordReset",
    PasswordsAreNotTheSame: "PasswordsAreNotTheSame",
    PayOffSimulation: "PayOffSimulation",
    Payment: "Payment",
    PaymentCreationDate: "PaymentCreationDate",
    PaymentDate: "PaymentDate",
    PaymentHasBonusAndUserHasNoPermissionToRemove: "PaymentHasBonusAndUserHasNoPermissionToRemove",
    PaymentMethods: "PaymentMethods",
    PaymentPurpose: "PaymentPurpose",
    PaymentQuota: "PaymentQuota",
    PaymentSettings: "PaymentSettings",
    PaymentSettingsSavedSuccessfully: "PaymentSettingsSavedSuccessfully",
    PaymentSettlementFormDescription: "PaymentSettlementFormDescription",
    PaymentStatus: "PaymentStatus",
    PaymentStatusChangedSuccessfully: "PaymentStatusChangedSuccessfully",
    PaymentStatusSettlementFormDescription: "PaymentStatusSettlementFormDescription",
    PaymentSuspension: "PaymentSuspension",
    PaymentSuspensionAutomatic: "PaymentSuspensionAutomatic",
    PaymentSuspensionManual: "PaymentSuspensionManual",
    PaymentSuspensionManualHint: "PaymentSuspensionManualHint",
    PaymentSuspensionOrigin: "PaymentSuspensionOrigin",
    PaymentType: "PaymentType",
    PaymentTypeFilterSettlementListDescription: "PaymentTypeFilterSettlementListDescription",
    PaymentTypeHistory: "PaymentTypeHistory",
    PaymentTypePlanning: "PaymentTypePlanning",
    Payments: "Payments",
    PaymentsAccountNumber: "PaymentsAccountNumber",
    PaymentsSchedule: "PaymentsSchedule",
    PaymentsScheduleDescription: "PaymentsScheduleDescription",
    Payoff: "Payoff",
    PayoffCreate: "PayoffCreate",
    PayoffCreatedSuccessfully: "PayoffCreatedSuccessfully",
    PayoffDateDescription: "PayoffDateDescription",
    PayoffDelete: "PayoffDelete",
    PayoffDeleteMessage: "PayoffDeleteMessage",
    PayoffEdit: "PayoffEdit",
    PayoffFormDescription: "PayoffFormDescription",
    PayoffImportMessage: "PayoffImportMessage",
    PayoffLink: "PayoffLink",
    PayoffMiniCardDescription: "PayoffMiniCardDescription",
    PayoffNotFound: "PayoffNotFound",
    PayoffOptions: "PayoffOptions",
    PayoffOptionsDescription: "PayoffOptionsDescription",
    PayoffPaymentType: "PayoffPaymentType",
    PayoffPaymentTypeCanBeCompletedOnAdvancePayment: "PayoffPaymentTypeCanBeCompletedOnAdvancePayment",
    PayoffPredefinedReasonsQuota: "PayoffPredefinedReasonsQuota",
    PayoffReason: "PayoffReason",
    PayoffReasonsAreAccessibleByTypingQuota: "PayoffReasonsAreAccessibleByTypingQuota",
    PayoffRelatedWithOnlinePaymentRemoveAlert: "PayoffRelatedWithOnlinePaymentRemoveAlert",
    PayoffSettlementFormDescription: "PayoffSettlementFormDescription",
    PayoffSumIsHigherThanBaseQuota: "PayoffSumIsHigherThanBaseQuota",
    PayoffType: "PayoffType",
    PayoffTypeDescription: "PayoffTypeDescription",
    PayoffValueTypeAlert: "PayoffValueTypeAlert",
    PayoffWithReasonCannotBeCreatedFromPayoffForm: "PayoffWithReasonCannotBeCreatedFromPayoffForm",
    Payoffs: "Payoffs",
    PayoffsAndPayments: "PayoffsAndPayments",
    PayoffsQuotaDifferenceSpotted: "PayoffsQuotaDifferenceSpotted",
    PayoffsSum: "PayoffsSum",
    PayoffsWithoutFuturePayoffs: "PayoffsWithoutFuturePayoffs",
    Payout: "Payout",
    PayoutRequestAlreadyPending: "PayoutRequestAlreadyPending",
    PayoutRequestNothingToPay: "PayoutRequestNothingToPay",
    PayoutRequestRequiresPositiveBalance: "PayoutRequestRequiresPositiveBalance",
    PayoutStatementForTaxSettlement: "PayoutStatementForTaxSettlement",
    PayoutTooSmall: "PayoutTooSmall",
    Pdf11SuccessAlert: "Pdf11SuccessAlert",
    PdfExport: "PdfExport",
    PdfExportDriverDescription: "PdfExportDriverDescription",
    PdfExportSettlementFormDescription: "PdfExportSettlementFormDescription",
    Pending: "Pending",
    Pensioner: "Pensioner",
    PensionerCard: "PensionerCard",
    PerWeek: "PerWeek",
    Percent: "Percent",
    PercentCommissionSplit: "PercentCommissionSplit",
    PercentFromTownResult: "PercentFromTownResult",
    PercentageOfRentPaid: "PercentageOfRentPaid",
    Period: "Period",
    PeriodPaymentType: "PeriodPaymentType",
    PeriodicVehicleInspection: "PeriodicVehicleInspection",
    PermanentResidentCard: "PermanentResidentCard",
    Personal: "Personal",
    PersonalVerification: "PersonalVerification",
    PersonalVerificationRequired: "PersonalVerificationRequired",
    PeselHasWrongFormat: "PeselHasWrongFormat",
    PeselStructurallyInvalid: "PeselStructurallyInvalid",
    Petrol: "Petrol",
    PetrolGross: "PetrolGross",
    PetrolGrossShort: "PetrolGrossShort",
    PetrolImportInProgressTryAgainLater: "PetrolImportInProgressTryAgainLater",
    PetrolRefund: "PetrolRefund",
    PetrolVATMessage: "PetrolVATMessage",
    PetrolVatRate: "PetrolVatRate",
    PhoneHolder: "PhoneHolder",
    PhoneHolderWithShifters: "PhoneHolderWithShifters",
    PhoneNumber: "PhoneNumber",
    PhoneNumberAndApplicationIdIsAlreadyTaken: "PhoneNumberAndApplicationIdIsAlreadyTaken",
    PhoneNumberAndApplicationIdIsAlreadyTakenButIsRemoved: "PhoneNumberAndApplicationIdIsAlreadyTakenButIsRemoved",
    PhoneNumberMustHaveFormat: "PhoneNumberMustHaveFormat",
    PhotoList: "PhotoList",
    PieChartApplicationAccounts: "PieChartApplicationAccounts",
    Pit11: "Pit11",
    Pit11Logs: "Pit11Logs",
    Place: "Place",
    PleaseContactAdministrator: "PleaseContactAdministrator",
    PleaseProvideCompanyBankAccountNumber: "PleaseProvideCompanyBankAccountNumber",
    Podkarpackie: "Podkarpackie",
    Podlaskie: "Podlaskie",
    Poland: "Poland",
    PoleCard: "PoleCard",
    Polish: "Polish",
    PolishDrivingLicense: "PolishDrivingLicense",
    Pomorskie: "Pomorskie",
    PossibleAssets: "PossibleAssets",
    PostOffice: "PostOffice",
    PostOfficeBookCreateAlert: "PostOfficeBookCreateAlert",
    PostalCode: "PostalCode",
    PostalCodeMayNotMatchNewCity: "PostalCodeMayNotMatchNewCity",
    Posters: "Posters",
    PostponedCharges: "PostponedCharges",
    PostponedQuota: "PostponedQuota",
    PostponedQuotaForTransport: "PostponedQuotaForTransport",
    PotalCodeHasWrongFormat: "PotalCodeHasWrongFormat",
    PredefinedValues: "PredefinedValues",
    PreferredPaymentMethod: "PreferredPaymentMethod",
    PreferredPaymentMethodDetails: "PreferredPaymentMethodDetails",
    PreferredVehicleModel: "PreferredVehicleModel",
    PreferredVehicleType: "PreferredVehicleType",
    PrepareAgain: "PrepareAgain",
    PrepareCampaignBasedOnCopy: "PrepareCampaignBasedOnCopy",
    PreparedSettlementsToCreate0: "PreparedSettlementsToCreate0",
    Preview: "Preview",
    PreviewArticle: "PreviewArticle",
    PreviewChangesNotAvailable: "PreviewChangesNotAvailable",
    PreviewInvoice: "PreviewInvoice",
    PreviousChanges: "PreviousChanges",
    PreviousDay: "PreviousDay",
    PreviousDayFilterReportListDescription: "PreviousDayFilterReportListDescription",
    PreviousDriverVehiclesDialogAlert: "PreviousDriverVehiclesDialogAlert",
    PreviousMonth: "PreviousMonth",
    PreviousMonthFilterReportListDescription: "PreviousMonthFilterReportListDescription",
    PreviousPaymentStatus: "PreviousPaymentStatus",
    PreviousPaymentStatusDate: "PreviousPaymentStatusDate",
    PreviousVehiclesOfNewDrivers: "PreviousVehiclesOfNewDrivers",
    PreviousWeek: "PreviousWeek",
    PreviousWeekFilterReportListDescription: "PreviousWeekFilterReportListDescription",
    Price: "Price",
    Priority: "Priority",
    Problem: "Problem",
    ProblemCategory: "ProblemCategory",
    ProblemDescription: "ProblemDescription",
    ProblemWithBailiff: "ProblemWithBailiff",
    ProcentShouldHaveValueFromZeroToOneHundred: "ProcentShouldHaveValueFromZeroToOneHundred",
    ProductName: "ProductName",
    ProductionDate: "ProductionDate",
    ProfilePhoto: "ProfilePhoto",
    Progress: "Progress",
    PromissoryNote: "PromissoryNote",
    PromissoryNotePayoutDate: "PromissoryNotePayoutDate",
    Promotion: "Promotion",
    Promotional: "Promotional",
    ProofOfIncome: "ProofOfIncome",
    PropertyValueMustBeLessThanOrEqualTo: "PropertyValueMustBeLessThanOrEqualTo",
    ProposalFromAnalysis: "ProposalFromAnalysis",
    ProtocolsChangesDetectedAlert: "ProtocolsChangesDetectedAlert",
    ProvideCustomPartType: "ProvideCustomPartType",
    ProvideCustomReason: "ProvideCustomReason",
    ProvideCustomStickers: "ProvideCustomStickers",
    ProvideData: "ProvideData",
    ProvideDataToLogin: "ProvideDataToLogin",
    PsychologicalExamination: "PsychologicalExamination",
    Publish: "Publish",
    PurchaserName: "PurchaserName",
    PushNotification: "PushNotification",
    Quantity: "Quantity",
    QuarterTimeJob: "QuarterTimeJob",
    QuaterTimeJob: "QuaterTimeJob",
    QuickActions: "QuickActions",
    QuickEdit: "QuickEdit",
    QuickInstallments: "QuickInstallments",
    QuickInstallmentsDescription: "QuickInstallmentsDescription",
    QuickPaymentActionsDescription: "QuickPaymentActionsDescription",
    QuickPayoff: "QuickPayoff",
    QuickPayoffDescription: "QuickPayoffDescription",
    QuickSearch: "QuickSearch",
    QuickSettlement: "QuickSettlement",
    QuickSettlementDescription: "QuickSettlementDescription",
    Quota: "Quota",
    QuotaIsHigherThanRestToPay: "QuotaIsHigherThanRestToPay",
    RAVAPI: "RAVAPI",
    RavapiCommission: "RavapiCommission",
    RavapiCommissionShort: "RavapiCommissionShort",
    RavapiDiscountedCommission: "RavapiDiscountedCommission",
    RavapiSharedCommission: "RavapiSharedCommission",
    RavapiTransportCommission: "RavapiTransportCommission",
    RavapiTransportCommissionShort: "RavapiTransportCommissionShort",
    Readed: "Readed",
    ReadyToWork: "ReadyToWork",
    Rear: "Rear",
    RearBumper: "RearBumper",
    RearFender: "RearFender",
    RearLeftDoor: "RearLeftDoor",
    RearLeftFender: "RearLeftFender",
    RearLeftWheel: "RearLeftWheel",
    RearRightDoor: "RearRightDoor",
    RearRightFender: "RearRightFender",
    RearRightWheel: "RearRightWheel",
    RearTire: "RearTire",
    RearTireWithChain: "RearTireWithChain",
    RearWheel: "RearWheel",
    RearWindshield: "RearWindshield",
    Reason: "Reason",
    ReasonDescription: "ReasonDescription",
    ReasonNotAllowedForThisStatusTag: "ReasonNotAllowedForThisStatusTag",
    ReasonNotExistSkipping: "ReasonNotExistSkipping",
    ReasonPayoffDescription: "ReasonPayoffDescription",
    RecalculateCommissionsDefaultMethod: "RecalculateCommissionsDefaultMethod",
    ReceiveAdjective: "ReceiveAdjective",
    ReceiveFromWorkshop: "ReceiveFromWorkshop",
    ReceiveFromWorkshopSampleCell: "ReceiveFromWorkshopSampleCell",
    ReceiveFromWorkshopWithShortName: "ReceiveFromWorkshopWithShortName",
    ReceiveRemindersToTakeActionInSII: "ReceiveRemindersToTakeActionInSII",
    ReceivingFromWorkshop: "ReceivingFromWorkshop",
    ReceivingProtocol: "ReceivingProtocol",
    RecentIncidents: "RecentIncidents",
    Recipient: "Recipient",
    RecipientClickedOnLink: "RecipientClickedOnLink",
    RecipientListFromPreviousCampaign: "RecipientListFromPreviousCampaign",
    Recipients: "Recipients",
    Recommended: "Recommended",
    RecommendedAstekCommission: "RecommendedAstekCommission",
    RecommendedCommissionCalculationType: "RecommendedCommissionCalculationType",
    RecommendedCommissionsAreDifferentThanExpectedAlert: "RecommendedCommissionsAreDifferentThanExpectedAlert",
    RecommendedRavapiCommission: "RecommendedRavapiCommission",
    RecordDeletedSuccessfully: "RecordDeletedSuccessfully",
    RecordDoesNotExistsOrContactHasBeenMade: "RecordDoesNotExistsOrContactHasBeenMade",
    RecordRecovered: "RecordRecovered",
    RecordsGroupedByPhoneNumber: "RecordsGroupedByPhoneNumber",
    RecordsPerPage: "RecordsPerPage",
    RecordsToProcess: "RecordsToProcess",
    Recover: "Recover",
    Recovery: "Recovery",
    ReferralLink: "ReferralLink",
    ReferralNotFound: "ReferralNotFound",
    ReferralReward: "ReferralReward",
    ReferralWithTheSameCodeAlreadyExists: "ReferralWithTheSameCodeAlreadyExists",
    Referrals: "Referrals",
    Refresh: "Refresh",
    RefreshView: "RefreshView",
    Refusal: "Refusal",
    RegisterDateExport: "RegisterDateExport",
    RegisteredDriversSince0: "RegisteredDriversSince0",
    RegistrationCode: "RegistrationCode",
    RegistrationDate: "RegistrationDate",
    RegistrationMail: "RegistrationMail",
    RegistrationNumber: "RegistrationNumber",
    Regon: "Regon",
    RegulationsAccepted: "RegulationsAccepted",
    Reject: "Reject",
    RejectProposal: "RejectProposal",
    Rejected: "Rejected",
    RejectionCustomReason: "RejectionCustomReason",
    RejectionReason: "RejectionReason",
    RelatedIncidentDeleteMessage: "RelatedIncidentDeleteMessage",
    RemainCorrections: "RemainCorrections",
    Remaining: "Remaining",
    RemainingQuotaToPay: "RemainingQuotaToPay",
    RemainingTax: "RemainingTax",
    RemarksComments: "RemarksComments",
    RemarksCommentsInstallmentDescription: "RemarksCommentsInstallmentDescription",
    RemarksCommentsPayoffDescription: "RemarksCommentsPayoffDescription",
    RemarksCommentsReportFormDescription: "RemarksCommentsReportFormDescription",
    RemarksCommentsSettlementFormDescription: "RemarksCommentsSettlementFormDescription",
    RememberToApproveSettlementsTo: "RememberToApproveSettlementsTo",
    ReminderActionRequiredSII: "ReminderActionRequiredSII",
    ReminderAdditionalInfoForInsuranceNeeded: "ReminderAdditionalInfoForInsuranceNeeded",
    ReminderB2BDriversVerification: "ReminderB2BDriversVerification",
    ReminderDayOffPromotion: "ReminderDayOffPromotion",
    ReminderDriversBirthdays: "ReminderDriversBirthdays",
    ReminderDriversMissingData: "ReminderDriversMissingData",
    ReminderDuplicateDriverAccounts: "ReminderDuplicateDriverAccounts",
    ReminderMissingDocumentsToSign: "ReminderMissingDocumentsToSign",
    ReminderNoBankAccountNumber: "ReminderNoBankAccountNumber",
    ReminderOutdatedStudentId: "ReminderOutdatedStudentId",
    ReminderRentEndAtPromotionalPrice: "ReminderRentEndAtPromotionalPrice",
    ReminderRentEndAtPromotionalPriceMailTypeInfo: "ReminderRentEndAtPromotionalPriceMailTypeInfo",
    ReminderRentStartAtStandardPrice: "ReminderRentStartAtStandardPrice",
    ReminderRepaymentOfOutstandingDebts: "ReminderRepaymentOfOutstandingDebts",
    ReminderScheduledWorkshop: "ReminderScheduledWorkshop",
    Reminders: "Reminders",
    RemoveDriverFromVehicle: "RemoveDriverFromVehicle",
    RemoveDriverFromVehicleAlert: "RemoveDriverFromVehicleAlert",
    RemoveForcedRavapiPaymentsTitle: "RemoveForcedRavapiPaymentsTitle",
    RemoveFromMyDriverList: "RemoveFromMyDriverList",
    RemoveServiceFee: "RemoveServiceFee",
    RemovedFromSII: "RemovedFromSII",
    RemovedFromUserDriverListSuccessfully: "RemovedFromUserDriverListSuccessfully",
    RemovedOneDriverFromUserDriverListSuccessfully: "RemovedOneDriverFromUserDriverListSuccessfully",
    RemovingContact: "RemovingContact",
    RemovingContactConfirm: "RemovingContactConfirm",
    Rent: "Rent",
    RentData: "RentData",
    RentDateAndHour: "RentDateAndHour",
    RentDays: "RentDays",
    RentOnly: "RentOnly",
    RentOnlyDriverSettlementQuestion: "RentOnlyDriverSettlementQuestion",
    RentOnlyDriverSettlementTitle: "RentOnlyDriverSettlementTitle",
    RentVehicle: "RentVehicle",
    RentalExtension: "RentalExtension",
    RentalExtensionDaysAmount: "RentalExtensionDaysAmount",
    RentalOnlyCharge: "RentalOnlyCharge",
    Rented: "Rented",
    RentedAndPaid: "RentedAndPaid",
    RentedByMoreThanHalf: "RentedByMoreThanHalf",
    RentedByMoreThanOneDay: "RentedByMoreThanOneDay",
    RepairKit: "RepairKit",
    RepairModel: "RepairModel",
    RepaymentDepositMethod: "RepaymentDepositMethod",
    RepaymentDialogEnoughBalanceBoth: "RepaymentDialogEnoughBalanceBoth",
    RepaymentDialogNotEnoughBalanceBoth: "RepaymentDialogNotEnoughBalanceBoth",
    RepaymentDialogNotEnoughBalanceInBank: "RepaymentDialogNotEnoughBalanceInBank",
    RepaymentDialogNotEnoughBalanceInCash: "RepaymentDialogNotEnoughBalanceInCash",
    RepaymentOfRentArrearsDueToSalary: "RepaymentOfRentArrearsDueToSalary",
    RepaymentType: "RepaymentType",
    Repeal: "Repeal",
    RepeatPassword: "RepeatPassword",
    ReplaceNote: "ReplaceNote",
    Reply: "Reply",
    Report: "Report",
    ReportDate: "ReportDate",
    ReportForDateRange: "ReportForDateRange",
    ReportIncidents: "ReportIncidents",
    ReportList: "ReportList",
    ReportListDescripiton: "ReportListDescripiton",
    ReportNotFound: "ReportNotFound",
    ReportOverdueAlert: "ReportOverdueAlert",
    ReportOverdueAlertSucceed: "ReportOverdueAlertSucceed",
    ReportResult: "ReportResult",
    ReportSaveAlertDescription: "ReportSaveAlertDescription",
    ReportSaveWarningAlert: "ReportSaveWarningAlert",
    ReportSchema: "ReportSchema",
    ReportSchemaDoesNotExists: "ReportSchemaDoesNotExists",
    ReportSchemas: "ReportSchemas",
    ReportSendConfimationContent: "ReportSendConfimationContent",
    ReportSendConfirmationTitle: "ReportSendConfirmationTitle",
    ReportSettings: "ReportSettings",
    ReportToUser: "ReportToUser",
    ReportToUsers: "ReportToUsers",
    ReportTown: "ReportTown",
    ReportType: "ReportType",
    ReportUser: "ReportUser",
    ReportedDifferent: "ReportedDifferent",
    ReportedInSII: "ReportedInSII",
    ReportedInSIIAndActiveAndHadPayout: "ReportedInSIIAndActiveAndHadPayout",
    ReportedInSIIAndActiveAndWithoutPayout: "ReportedInSIIAndActiveAndWithoutPayout",
    Reports: "Reports",
    RequestForPayment: "RequestForPayment",
    RequestForPaymentCanBeSendOnlyForPayoffsLessThanZero: "RequestForPaymentCanBeSendOnlyForPayoffsLessThanZero",
    RequestForPaymentConfirmation: "RequestForPaymentConfirmation",
    RequestForPaymentDialogAlert: "RequestForPaymentDialogAlert",
    RequiredDays: "RequiredDays",
    RequiredDriversCount: "RequiredDriversCount",
    ResendMailCopy: "ResendMailCopy",
    ResendMailCopyMessage: "ResendMailCopyMessage",
    ResendMails: "ResendMails",
    ResendMailsMessage: "ResendMailsMessage",
    Reservation: "Reservation",
    ReservationApproveAlert: "ReservationApproveAlert",
    ReservationCancelAlert: "ReservationCancelAlert",
    ReservationDate: "ReservationDate",
    ReservationIsAlreadyApproved: "ReservationIsAlreadyApproved",
    ReservationIsAlreadyCancelled: "ReservationIsAlreadyCancelled",
    ReservationSampleCell: "ReservationSampleCell",
    Reservations: "Reservations",
    Reserved: "Reserved",
    ReservedOn: "ReservedOn",
    ResidentCard: "ResidentCard",
    ResidentCardBasedOnJob: "ResidentCardBasedOnJob",
    ResidentCardCommissions: "ResidentCardCommissions",
    ResidentCardForStudent: "ResidentCardForStudent",
    ResidentCardToStayWithFamily: "ResidentCardToStayWithFamily",
    ResidentCardType: "ResidentCardType",
    Resignation: "Resignation",
    ResignationFromSII: "ResignationFromSII",
    ResourceConsumption: "ResourceConsumption",
    ResourceConsumptionTable: "ResourceConsumptionTable",
    ResourceItem: "ResourceItem",
    ResourceNotFound: "ResourceNotFound",
    ResourcePayoffDescription: "ResourcePayoffDescription",
    ResourcePayoffSum: "ResourcePayoffSum",
    ResourceSettings: "ResourceSettings",
    Resources: "Resources",
    ResourcesPaidByOrganisation: "ResourcesPaidByOrganisation",
    Rest: "Rest",
    RestBonusQuota: "RestBonusQuota",
    RestChargeQuota: "RestChargeQuota",
    RestartTutorial: "RestartTutorial",
    RestartTutorialDescription: "RestartTutorialDescription",
    RestoreTicket: "RestoreTicket",
    RestoreTicketConfirmContent: "RestoreTicketConfirmContent",
    RestoreTicketConfirmTitle: "RestoreTicketConfirmTitle",
    RestrictedPaymentType: "RestrictedPaymentType",
    Result: "Result",
    Retry: "Retry",
    Return: "Return",
    ReturnDateEndShouldntBeFromPast: "ReturnDateEndShouldntBeFromPast",
    ReturnDriverDescription: "ReturnDriverDescription",
    ReturnEndDate: "ReturnEndDate",
    ReturnEquipmentRequest: "ReturnEquipmentRequest",
    ReturnPetrolVatMessage: "ReturnPetrolVatMessage",
    ReturnRequest: "ReturnRequest",
    ReturnStartDate: "ReturnStartDate",
    ReturnToFleet: "ReturnToFleet",
    Review: "Review",
    Revolut: "Revolut",
    RevolutNickname: "RevolutNickname",
    RewardAmount: "RewardAmount",
    RewardForEachInvited: "RewardForEachInvited",
    RewardPackageOrdinal: "RewardPackageOrdinal",
    RewardUpTo: "RewardUpTo",
    RewardVariant: "RewardVariant",
    RightSide: "RightSide",
    RightSidePanel: "RightSidePanel",
    Role: "Role",
    Roof: "Roof",
    Russian: "Russian",
    SII: "SII",
    SIITagsShortDescription: "SIITagsShortDescription",
    SalaryHigherThanMinimal: "SalaryHigherThanMinimal",
    SalaryIsLowerThanMinimal: "SalaryIsLowerThanMinimal",
    Saturday: "Saturday",
    Save: "Save",
    SaveAndApproveProposal: "SaveAndApproveProposal",
    SaveAndSend: "SaveAndSend",
    SaveAndSendReportFormDescription: "SaveAndSendReportFormDescription",
    SaveDescription: "SaveDescription",
    SaveFormToApplyChanges: "SaveFormToApplyChanges",
    SaveInstallmentDescription: "SaveInstallmentDescription",
    SaveReportFormDescription: "SaveReportFormDescription",
    SaveSummaryToDriverFiles: "SaveSummaryToDriverFiles",
    Saved: "Saved",
    ScheduledExecutionDate: "ScheduledExecutionDate",
    ScheduledWorkshop: "ScheduledWorkshop",
    SchemaName: "SchemaName",
    SchoolName: "SchoolName",
    SchoolProfile: "SchoolProfile",
    SchoolTown: "SchoolTown",
    SchoolType: "SchoolType",
    Scooter: "Scooter",
    Scratch: "Scratch",
    ScreenWithMileageTurnedOn: "ScreenWithMileageTurnedOn",
    Search: "Search",
    SearchFilters: "SearchFilters",
    SearchFiltersSettlementListDescription: "SearchFiltersSettlementListDescription",
    SearchPhrase: "SearchPhrase",
    Seat: "Seat",
    SeatAndStorageSpaceUnderTheSeat: "SeatAndStorageSpaceUnderTheSeat",
    SecondName: "SecondName",
    SecondPhoneNumber: "SecondPhoneNumber",
    SectionNotForMobileAccessible: "SectionNotForMobileAccessible",
    Select: "Select",
    Select0: "Select0",
    SelectApplication: "SelectApplication",
    SelectArea: "SelectArea",
    SelectColumnToShowThemOnList: "SelectColumnToShowThemOnList",
    SelectCorrectDriver: "SelectCorrectDriver",
    SelectDate: "SelectDate",
    SelectDateFilterReportListDescription: "SelectDateFilterReportListDescription",
    SelectDriverPreferences: "SelectDriverPreferences",
    SelectDriversExportOptionToCsv: "SelectDriversExportOptionToCsv",
    SelectExportToRun: "SelectExportToRun",
    SelectFilter: "SelectFilter",
    SelectFromRange: "SelectFromRange",
    SelectOne: "SelectOne",
    SelectOrganisationsToExport: "SelectOrganisationsToExport",
    SelectPartTypeFromList: "SelectPartTypeFromList",
    SelectPayoffsOrDefineOrganisationsForExport: "SelectPayoffsOrDefineOrganisationsForExport",
    SelectReasonFromList: "SelectReasonFromList",
    SelectResource: "SelectResource",
    SelectStatisticCardsToCreateSchema: "SelectStatisticCardsToCreateSchema",
    SelectStickerFromList: "SelectStickerFromList",
    SelectTaxOffice: "SelectTaxOffice",
    SelectTaxOfficeFromDictionary: "SelectTaxOfficeFromDictionary",
    Selected0: "Selected0",
    SelectedApplications: "SelectedApplications",
    SelectedDefects: "SelectedDefects",
    SelectedDocumentDoesNotExists: "SelectedDocumentDoesNotExists",
    SelectedDocumentIsSignedOrCurrentlyProcessed: "SelectedDocumentIsSignedOrCurrentlyProcessed",
    SelectedDocumentIsSignedOrCurrentlyProcessedForThisVehicleRent: "SelectedDocumentIsSignedOrCurrentlyProcessedForThisVehicleRent",
    SelectedDriverOrganisationHaveNoAccessToOnlinePayment: "SelectedDriverOrganisationHaveNoAccessToOnlinePayment",
    SelectedDrivers0: "SelectedDrivers0",
    SelectedDriversExport: "SelectedDriversExport",
    SelectedFilesCount: "SelectedFilesCount",
    SelectedLegalizationServices: "SelectedLegalizationServices",
    SelectedPayoffs0WillBeExported: "SelectedPayoffs0WillBeExported",
    SelectedSectionIsForAdditionalFilteringSortingExistingFields: "SelectedSectionIsForAdditionalFilteringSortingExistingFields",
    SelectedVehicle: "SelectedVehicle",
    SelectedVehicleDay: "SelectedVehicleDay",
    SelectedVehicleHasStolenIncident: "SelectedVehicleHasStolenIncident",
    SelectedVehicles0WillBeExported: "SelectedVehicles0WillBeExported",
    SendDriverDataToFlovi: "SendDriverDataToFlovi",
    SendDriverDataToFloviAlertText0: "SendDriverDataToFloviAlertText0",
    SendDriverDataToFloviAlertTitle: "SendDriverDataToFloviAlertTitle",
    SendEmailToDriver: "SendEmailToDriver",
    SendEmailToDriverSettlementFormDescription: "SendEmailToDriverSettlementFormDescription",
    SendEmailToDrivers: "SendEmailToDrivers",
    SendFileOnDriverMail: "SendFileOnDriverMail",
    SendForcedIndividualInvoiceOnDriverEmail: "SendForcedIndividualInvoiceOnDriverEmail",
    SendInvoiceToDriverMail: "SendInvoiceToDriverMail",
    SendOnDate: "SendOnDate",
    SendOnDevice: "SendOnDevice",
    SendPit11OnDriverEmail: "SendPit11OnDriverEmail",
    SendRemaindersAboutBankAccountNumber: "SendRemaindersAboutBankAccountNumber",
    SendSelectedToKSeF: "SendSelectedToKSeF",
    SendSummaryToDriverEmail: "SendSummaryToDriverEmail",
    SendToKSeF: "SendToKSeF",
    SendUploadFileTokenLink: "SendUploadFileTokenLink",
    SendWorkshopReminder: "SendWorkshopReminder",
    Sended: "Sended",
    SendingDocumentsToDigitalSignature: "SendingDocumentsToDigitalSignature",
    Sent: "Sent",
    SentDate: "SentDate",
    SentToWorkshop: "SentToWorkshop",
    ServerIsTemporaryUnavailable: "ServerIsTemporaryUnavailable",
    Service: "Service",
    ServiceFee: "ServiceFee",
    SetCommission: "SetCommission",
    SetIsIncludedInPromotionDayOff: "SetIsIncludedInPromotionDayOff",
    SetManualEdit: "SetManualEdit",
    Settings: "Settings",
    SettleCashDialogDriverSelect: "SettleCashDialogDriverSelect",
    SettleCashWithDriver: "SettleCashWithDriver",
    SettleCashWithDriverGeneralDescription: "SettleCashWithDriverGeneralDescription",
    SettleCashWithDriverYesOptionAlert: "SettleCashWithDriverYesOptionAlert",
    SettleDailyPayoutsOnceWeek: "SettleDailyPayoutsOnceWeek",
    SettleDailyPayoutsOnceWeekAlert: "SettleDailyPayoutsOnceWeekAlert",
    SettleDriverByOnlinePayment: "SettleDriverByOnlinePayment",
    Settlement: "Settlement",
    SettlementAlreadyContainsDataFromThisRecordSkipping: "SettlementAlreadyContainsDataFromThisRecordSkipping",
    SettlementApplication: "SettlementApplication",
    SettlementApprove: "SettlementApprove",
    SettlementApproveMessage: "SettlementApproveMessage",
    SettlementChangePaymentStatusInProgressWaitUntilComplete: "SettlementChangePaymentStatusInProgressWaitUntilComplete",
    SettlementCollidesWithAnotherSettlement: "SettlementCollidesWithAnotherSettlement",
    SettlementContainsMultipleOrganisations: "SettlementContainsMultipleOrganisations",
    SettlementCorrection: "SettlementCorrection",
    SettlementCorrectionMessage: "SettlementCorrectionMessage",
    SettlementCreate: "SettlementCreate",
    SettlementDateEnd: "SettlementDateEnd",
    SettlementDateStart: "SettlementDateStart",
    SettlementDelete: "SettlementDelete",
    SettlementDeleteMessage: "SettlementDeleteMessage",
    SettlementEdit: "SettlementEdit",
    SettlementExportFileName: "SettlementExportFileName",
    SettlementForThisRecordAlreadyExistisSkipping: "SettlementForThisRecordAlreadyExistisSkipping",
    SettlementFormCorrectionAlert: "SettlementFormCorrectionAlert",
    SettlementFormDescription: "SettlementFormDescription",
    SettlementFormWeeklyBoltFoodTipsAlert: "SettlementFormWeeklyBoltFoodTipsAlert",
    SettlementManualEdit: "SettlementManualEdit",
    SettlementManualEditMessage: "SettlementManualEditMessage",
    SettlementNotFound: "SettlementNotFound",
    SettlementNumber: "SettlementNumber",
    SettlementPayoff: "SettlementPayoff",
    SettlementStatus: "SettlementStatus",
    SettlementType: "SettlementType",
    SettlementWithManualEdit: "SettlementWithManualEdit",
    SettlementWithoutNumber: "SettlementWithoutNumber",
    Settlements: "Settlements",
    SettlementsDateRange: "SettlementsDateRange",
    SettlementsDoesNotMeetExportRequirements: "SettlementsDoesNotMeetExportRequirements",
    SettlementsList: "SettlementsList",
    SettlementsListPayoffDescription: "SettlementsListPayoffDescription",
    SettlementsSettings: "SettlementsSettings",
    SettlingB2B: "SettlingB2B",
    Shared: "Shared",
    SharedVehicleAssignedDriversDataChangeAlert: "SharedVehicleAssignedDriversDataChangeAlert",
    SharedVehicleUnlinkDriversAlert: "SharedVehicleUnlinkDriversAlert",
    ShortcutDriverTagsKeysDialog: "ShortcutDriverTagsKeysDialog",
    ShortcutKeysDialog: "ShortcutKeysDialog",
    ShouldSystemChargeCurrentDriverTodayForVehicleRent: "ShouldSystemChargeCurrentDriverTodayForVehicleRent",
    ShowDeleted: "ShowDeleted",
    ShowDetails: "ShowDetails",
    ShowDuplicate: "ShowDuplicate",
    ShowHierarchy: "ShowHierarchy",
    ShowInMobileApp: "ShowInMobileApp",
    ShowInactive: "ShowInactive",
    ShowLogs: "ShowLogs",
    ShowPaid: "ShowPaid",
    ShowReaded: "ShowReaded",
    SignAgain: "SignAgain",
    SignDocuments: "SignDocuments",
    Signature: "Signature",
    Signatures: "Signatures",
    SignaturesNotFound: "SignaturesNotFound",
    SignaturesSubmittedByClient: "SignaturesSubmittedByClient",
    SignaturesSubmittedByEmployee: "SignaturesSubmittedByEmployee",
    Signed: "Signed",
    SignedDocumentPreview: "SignedDocumentPreview",
    SignedDocuments: "SignedDocuments",
    SignerData: "SignerData",
    SiiCalculationMethod: "SiiCalculationMethod",
    SiiEmploymentType: "SiiEmploymentType",
    SiiEmploymentTypeChangeDate: "SiiEmploymentTypeChangeDate",
    SiiFlow: "SiiFlow",
    SiiMakingDecision: "SiiMakingDecision",
    SiiPaymentsSummary: "SiiPaymentsSummary",
    SiiQuota: "SiiQuota",
    SiiRate: "SiiRate",
    SiiRequest: "SiiRequest",
    SiiResign: "SiiResign",
    SiiResignationRequest: "SiiResignationRequest",
    SiiTags: "SiiTags",
    SiiTagsAttention: "SiiTagsAttention",
    Silence: "Silence",
    Silenced: "Silenced",
    SimCardDown: "SimCardDown",
    SinceForever: "SinceForever",
    SingleMessageCost: "SingleMessageCost",
    SingularPluralDriverSelect: "SingularPluralDriverSelect",
    Skip: "Skip",
    SkipMissingVehicleRentDigitalDocumentsPopupReminder: "SkipMissingVehicleRentDigitalDocumentsPopupReminder",
    Slaskie: "Slaskie",
    SmsCampaigns: "SmsCampaigns",
    SocialInsurance: "SocialInsurance",
    SocialInsuranceScopes: "SocialInsuranceScopes",
    SocialInsuranceScopesHint: "SocialInsuranceScopesHint",
    SomeFilesAreBroken: "SomeFilesAreBroken",
    SomePayoffsOfProvidedListDoesNotExists: "SomePayoffsOfProvidedListDoesNotExists",
    SomeSettlementsCouldNotBeFound: "SomeSettlementsCouldNotBeFound",
    SomethingWentWrong: "SomethingWentWrong",
    SomethingWentWrongDuringCreatingLogAttachment: "SomethingWentWrongDuringCreatingLogAttachment",
    SomethingWentWrongDuringCreatingPayUPayment: "SomethingWentWrongDuringCreatingPayUPayment",
    SomethingWentWrongDuringEmailCreation: "SomethingWentWrongDuringEmailCreation",
    SortBy: "SortBy",
    SortingBySelectedOrder: "SortingBySelectedOrder",
    SourceBalance: "SourceBalance",
    SourceBalanceMustBeDifferentThanTargetBalance: "SourceBalanceMustBeDifferentThanTargetBalance",
    SpamComplaint: "SpamComplaint",
    Specialist: "Specialist",
    SpendChange: "SpendChange",
    SpendChangeToClient: "SpendChangeToClient",
    SpottedApplicationAccountAndDriverWithSamePhoneNumberSkipping: "SpottedApplicationAccountAndDriverWithSamePhoneNumberSkipping",
    Standard: "Standard",
    StandardWired: "StandardWired",
    Start: "Start",
    StartDateMustLessThanEndDate: "StartDateMustLessThanEndDate",
    Statistics: "Statistics",
    StatisticsBundle: "StatisticsBundle",
    StatisticsSchemaNotFound: "StatisticsSchemaNotFound",
    StatisticsSettings: "StatisticsSettings",
    Status: "Status",
    StatusDateCallForPayment: "StatusDateCallForPayment",
    StatusDateCallForPaymentBlue: "StatusDateCallForPaymentBlue",
    StatusDateCallForPaymentGreen: "StatusDateCallForPaymentGreen",
    StatusDateCallForPaymentGrey: "StatusDateCallForPaymentGrey",
    StatusDateCallForPaymentOrange: "StatusDateCallForPaymentOrange",
    StatusDateCallForPaymentRed: "StatusDateCallForPaymentRed",
    StatusTagReasonFieldLabel: "StatusTagReasonFieldLabel",
    StatusTagReasonHint: "StatusTagReasonHint",
    StatusUpdatedSuccessfully: "StatusUpdatedSuccessfully",
    SteeringWheel: "SteeringWheel",
    Stickers: "Stickers",
    Stolen: "Stolen",
    StopSendingEmailsAboutNoTaxOfficeInfo: "StopSendingEmailsAboutNoTaxOfficeInfo",
    Street: "Street",
    StreetLooksLikeBuildingNumber: "StreetLooksLikeBuildingNumber",
    StreetNotFoundFallbackLabel: "StreetNotFoundFallbackLabel",
    Student: "Student",
    Student26: "Student26",
    StudentCard: "StudentCard",
    StudentCardExpiryDate: "StudentCardExpiryDate",
    StudentCardExpiryDateCanBeSetOnlyForStudents: "StudentCardExpiryDateCanBeSetOnlyForStudents",
    StudentCardExpiryDateIsWrong: "StudentCardExpiryDateIsWrong",
    StudentCardNeeded: "StudentCardNeeded",
    StudentCardUploaded: "StudentCardUploaded",
    StudentPathNotAvailableForAge: "StudentPathNotAvailableForAge",
    StudentReported: "StudentReported",
    StudentStartDate: "StudentStartDate",
    StudentStatusConfirmation: "StudentStatusConfirmation",
    SubjectAddress: "SubjectAddress",
    SubjectByNipNotFound: "SubjectByNipNotFound",
    SubjectInformationB2B: "SubjectInformationB2B",
    SubjectIsNotActive: "SubjectIsNotActive",
    SubjectName: "SubjectName",
    SubjectNotFound: "SubjectNotFound",
    SubjectToOrganisation: "SubjectToOrganisation",
    SubtractPetrolFromPayout: "SubtractPetrolFromPayout",
    SuccessfullyMassSetVehiclesCommission: "SuccessfullyMassSetVehiclesCommission",
    SuccessfullySettlementsCreated0: "SuccessfullySettlementsCreated0",
    SuccessfullyUpdatedPaymentType: "SuccessfullyUpdatedPaymentType",
    SuccessfullyUpdatedVehiclesDriver: "SuccessfullyUpdatedVehiclesDriver",
    SuggestedPhotoPlaces: "SuggestedPhotoPlaces",
    Sum: "Sum",
    SummaryRentalStatistics: "SummaryRentalStatistics",
    Sunday: "Sunday",
    SupportAiMessageClarification: "SupportAiMessageClarification",
    SupportAiMessageDialogLimit: "SupportAiMessageDialogLimit",
    SupportAiMessageFallback: "SupportAiMessageFallback",
    SupportAiMessageNoAnswerHandoff: "SupportAiMessageNoAnswerHandoff",
    SupportAiMessageRateLimit: "SupportAiMessageRateLimit",
    SupportAssignmentFilterAll: "SupportAssignmentFilterAll",
    SupportAssignmentFilterMe: "SupportAssignmentFilterMe",
    SupportAssignmentFilterUnassigned: "SupportAssignmentFilterUnassigned",
    SupportChatHeadClose: "SupportChatHeadClose",
    SupportChatHeadNoActiveTickets: "SupportChatHeadNoActiveTickets",
    SupportChatHeadOpenFullView: "SupportChatHeadOpenFullView",
    SupportChatHeadUnreadMessages: "SupportChatHeadUnreadMessages",
    SupportChatHeadsHide: "SupportChatHeadsHide",
    SupportChatHeadsShow: "SupportChatHeadsShow",
    SupportCloseDuplicate: "SupportCloseDuplicate",
    SupportCloseInvalidRequest: "SupportCloseInvalidRequest",
    SupportCloseNoResponse: "SupportCloseNoResponse",
    SupportCloseResolvedByDriver: "SupportCloseResolvedByDriver",
    SupportCloseResolvedByEmployee: "SupportCloseResolvedByEmployee",
    SupportFileAddToDriverFiles: "SupportFileAddToDriverFiles",
    SupportFileAddToDriverFilesTitle: "SupportFileAddToDriverFilesTitle",
    SupportFileInDriverFiles: "SupportFileInDriverFiles",
    SupportFileNameByType: "SupportFileNameByType",
    SupportFileOriginalName: "SupportFileOriginalName",
    SupportFileRemovedFromConversation: "SupportFileRemovedFromConversation",
    SupportHours: "SupportHours",
    SupportHoursAtLeastOneDay: "SupportHoursAtLeastOneDay",
    SupportHoursFromBeforeTo: "SupportHoursFromBeforeTo",
    SupportHoursInvalidTime: "SupportHoursInvalidTime",
    SupportStatusClosed: "SupportStatusClosed",
    SupportStatusInProgress: "SupportStatusInProgress",
    SupportStatusOpen: "SupportStatusOpen",
    SupportSystemMessageActivityCheck: "SupportSystemMessageActivityCheck",
    SupportSystemMessageAutoClosed: "SupportSystemMessageAutoClosed",
    SupportSystemMessageDriverClosed: "SupportSystemMessageDriverClosed",
    SupportSystemMessageEmployeeClaimed: "SupportSystemMessageEmployeeClaimed",
    SupportSystemMessageEmployeeClosed: "SupportSystemMessageEmployeeClosed",
    SupportSystemMessageEmployeeRestored: "SupportSystemMessageEmployeeRestored",
    SupportSystemMessageEmployeeTakenOver: "SupportSystemMessageEmployeeTakenOver",
    SupportSystemMessageFileSavedToDriverFiles: "SupportSystemMessageFileSavedToDriverFiles",
    SupportSystemMessageUploadPermissionDriverFinished: "SupportSystemMessageUploadPermissionDriverFinished",
    SupportSystemMessageUploadPermissionEmployeeEnded: "SupportSystemMessageUploadPermissionEmployeeEnded",
    SupportSystemMessageUploadPermissionGranted: "SupportSystemMessageUploadPermissionGranted",
    SupportSystemMessageUploadPermissionLimitReached: "SupportSystemMessageUploadPermissionLimitReached",
    SupportTicket: "SupportTicket",
    SupportTicketActiveAlreadyExists: "SupportTicketActiveAlreadyExists",
    SupportTicketAiChatHistory: "SupportTicketAiChatHistory",
    SupportTicketAiSummary: "SupportTicketAiSummary",
    SupportTicketAlreadyClaimed: "SupportTicketAlreadyClaimed",
    SupportTicketAlreadyClosed: "SupportTicketAlreadyClosed",
    SupportTicketAssignedTo: "SupportTicketAssignedTo",
    SupportTicketCantTakeOver: "SupportTicketCantTakeOver",
    SupportTicketCloseComment: "SupportTicketCloseComment",
    SupportTicketCloseReason: "SupportTicketCloseReason",
    SupportTicketClosedAt: "SupportTicketClosedAt",
    SupportTicketClosedBanner: "SupportTicketClosedBanner",
    SupportTicketClosedCannotSendMessage: "SupportTicketClosedCannotSendMessage",
    SupportTicketConversation: "SupportTicketConversation",
    SupportTicketCreatedAt: "SupportTicketCreatedAt",
    SupportTicketDateRange: "SupportTicketDateRange",
    SupportTicketDeletedByEmployeeSystemMessage: "SupportTicketDeletedByEmployeeSystemMessage",
    SupportTicketDetails: "SupportTicketDetails",
    SupportTicketDriver: "SupportTicketDriver",
    SupportTicketDriverLanguage: "SupportTicketDriverLanguage",
    SupportTicketFileAlreadyInDriverFiles: "SupportTicketFileAlreadyInDriverFiles",
    SupportTicketFileFormatNotAllowed: "SupportTicketFileFormatNotAllowed",
    SupportTicketFilePreview: "SupportTicketFilePreview",
    SupportTicketId: "SupportTicketId",
    SupportTicketLastModified: "SupportTicketLastModified",
    SupportTicketMessageHint: "SupportTicketMessageHint",
    SupportTicketMustClaimFirst: "SupportTicketMustClaimFirst",
    SupportTicketNotAssignedToYou: "SupportTicketNotAssignedToYou",
    SupportTicketNotFound: "SupportTicketNotFound",
    SupportTicketSendMessage: "SupportTicketSendMessage",
    SupportTicketStatus: "SupportTicketStatus",
    SupportTicketTakenOverBy: "SupportTicketTakenOverBy",
    SupportTicketTitle: "SupportTicketTitle",
    SupportTicketTypingLabel: "SupportTicketTypingLabel",
    SupportTicketUnassignedBadge: "SupportTicketUnassignedBadge",
    SupportTicketUploadPermissionAlreadyActive: "SupportTicketUploadPermissionAlreadyActive",
    SupportTicketUploadPermissionNotActive: "SupportTicketUploadPermissionNotActive",
    SupportTicketWasHelpful: "SupportTicketWasHelpful",
    SupportTicketWorkCountry: "SupportTicketWorkCountry",
    SupportTickets: "SupportTickets",
    SupportTicketsColumn: "SupportTicketsColumn",
    SupportTicketsList: "SupportTicketsList",
    SupportUploadPermissionEnd: "SupportUploadPermissionEnd",
    SupportUploadPermissionGrant: "SupportUploadPermissionGrant",
    SupportUploadPermissionProgress: "SupportUploadPermissionProgress",
    SupportUploadPermissionTitle: "SupportUploadPermissionTitle",
    SupportWorkingDays: "SupportWorkingDays",
    Swietokrzyskie: "Swietokrzyskie",
    System: "System",
    SystemAdministrator: "SystemAdministrator",
    Tag: "Tag",
    TagsBlockingSettlementPayments: "TagsBlockingSettlementPayments",
    TagsForDuplicates: "TagsForDuplicates",
    TagsImpossibleToUnfastenDescription: "TagsImpossibleToUnfastenDescription",
    TagsImpossibleToUnfastenDifferentDescription: "TagsImpossibleToUnfastenDifferentDescription",
    TagsToUnfastenDescription: "TagsToUnfastenDescription",
    TakeOverConfirmContent: "TakeOverConfirmContent",
    TakeOverConfirmTitle: "TakeOverConfirmTitle",
    TakeOverTicket: "TakeOverTicket",
    TakePicture: "TakePicture",
    TakenCash: "TakenCash",
    TakenFromSettlement: "TakenFromSettlement",
    TakesPartInLegalizationProcess: "TakesPartInLegalizationProcess",
    TakesPartInLegalizationProcessDescription: "TakesPartInLegalizationProcessDescription",
    TargetBalance: "TargetBalance",
    TargetHasNotBeenAccomplished: "TargetHasNotBeenAccomplished",
    Tax: "Tax",
    TaxOffice: "TaxOffice",
    TaxOfficeDictionarySearch: "TaxOfficeDictionarySearch",
    TaxOfficeDictionarySuggestions: "TaxOfficeDictionarySuggestions",
    TaxOfficeDictionaryTitle: "TaxOfficeDictionaryTitle",
    TaxOfficeInputHint: "TaxOfficeInputHint",
    TaxOfficeLookupRetryDate: "TaxOfficeLookupRetryDate",
    TaxOfficeNotFromCandidateList: "TaxOfficeNotFromCandidateList",
    TaxOfficeNotInDictionary: "TaxOfficeNotInDictionary",
    TaxOfficesFound: "TaxOfficesFound",
    TaxQualificationCannotBeChangedNow: "TaxQualificationCannotBeChangedNow",
    TaxQualificationNotApplicable: "TaxQualificationNotApplicable",
    TaxQualificationPathNotSelectable: "TaxQualificationPathNotSelectable",
    TaxSituation: "TaxSituation",
    TaxValue: "TaxValue",
    Taxi: "Taxi",
    TaxiExcerpt: "TaxiExcerpt",
    TaxiExcerptLodgedDate: "TaxiExcerptLodgedDate",
    TaxiIdentifier: "TaxiIdentifier",
    TaxiImport: "TaxiImport",
    TaxiImportInProgress: "TaxiImportInProgress",
    TaxiImportWorkLogMessage: "TaxiImportWorkLogMessage",
    TaxiLamp: "TaxiLamp",
    TaxiLicense: "TaxiLicense",
    TaxiStickers: "TaxiStickers",
    TelegramNickname: "TelegramNickname",
    TelegramValidation: "TelegramValidation",
    TerytServiceUnavailable: "TerytServiceUnavailable",
    TheCommissionsWillBeSplitEqually: "TheCommissionsWillBeSplitEqually",
    TheFileInRelatedWithInvoiceList: "TheFileInRelatedWithInvoiceList",
    TheSelectedIconDoesNotExist: "TheSelectedIconDoesNotExist",
    ThereIsNoNeedToVerifyContractOfMandate: "ThereIsNoNeedToVerifyContractOfMandate",
    ThermalBag: "ThermalBag",
    ThisEventTypeIsShouldBeNextToSentToService: "ThisEventTypeIsShouldBeNextToSentToService",
    ThisFieldIsRequired: "ThisFieldIsRequired",
    ThisMonth: "ThisMonth",
    ThisReasonIsNotAvailableForAdditionalQuota: "ThisReasonIsNotAvailableForAdditionalQuota",
    ThisReasonIsNotAvailableForNegativeQuota: "ThisReasonIsNotAvailableForNegativeQuota",
    ThisSettlementIsNotIncludedInExport: "ThisSettlementIsNotIncludedInExport",
    ThisWeek: "ThisWeek",
    Thursday: "Thursday",
    TillNow: "TillNow",
    TillWhenIsBanned: "TillWhenIsBanned",
    TimeLimitExceeded: "TimeLimitExceeded",
    TimeToApproveIsExpired: "TimeToApproveIsExpired",
    Tips: "Tips",
    Title: "Title",
    To: "To",
    ToBePaid: "ToBePaid",
    ToBePaidDescription: "ToBePaidDescription",
    ToBePaidPayoffDescription: "ToBePaidPayoffDescription",
    ToBeRemovedFromSII: "ToBeRemovedFromSII",
    ToBeRemovedFromSiiDays: "ToBeRemovedFromSiiDays",
    ToBeReportedInSII: "ToBeReportedInSII",
    ToBeSend: "ToBeSend",
    ToBeVerifiedInCepik: "ToBeVerifiedInCepik",
    ToContinueFillDriverMissingFields: "ToContinueFillDriverMissingFields",
    ToEditThisFieldContactAdminstrator: "ToEditThisFieldContactAdminstrator",
    ToUnlockItClick: "ToUnlockItClick",
    ToUseThisPermissionYouMustSelectInSection: "ToUseThisPermissionYouMustSelectInSection",
    ToWithdraw: "ToWithdraw",
    ToWithdrawFilterSettlementListDescription: "ToWithdrawFilterSettlementListDescription",
    ToWithdrawSum: "ToWithdrawSum",
    Today: "Today",
    TokenIsNotValid: "TokenIsNotValid",
    TooManyLoginAttempts: "TooManyLoginAttempts",
    TooManyRequests: "TooManyRequests",
    TotalBalance: "TotalBalance",
    TotalEarnings: "TotalEarnings",
    TotalValue: "TotalValue",
    TotalValueDescription: "TotalValueDescription",
    Town: "Town",
    TownToRide: "TownToRide",
    Transfer: "Transfer",
    TransferAdjective: "TransferAdjective",
    TransferCash: "TransferCash",
    TransferNumber: "TransferNumber",
    TransferProtocol: "TransferProtocol",
    Transfers: "Transfers",
    TransportDamage: "TransportDamage",
    TransportInvoiceServiceType: "TransportInvoiceServiceType",
    TransportRent: "TransportRent",
    Trunk: "Trunk",
    Tuesday: "Tuesday",
    TwoFieldsCannotBeSelectedAtTheSameTime: "TwoFieldsCannotBeSelectedAtTheSameTime",
    TwoSettlementFoundToModifyDataSkipping: "TwoSettlementFoundToModifyDataSkipping",
    Type: "Type",
    TypeOfDefect: "TypeOfDefect",
    TypeOfPayoff: "TypeOfPayoff",
    Uber: "Uber",
    UberEats: "UberEats",
    Ukrainian: "Ukrainian",
    UnableToAddCampaign: "UnableToAddCampaign",
    UnableToAddCampaignWithDoubleAmount: "UnableToAddCampaignWithDoubleAmount",
    UnableToAddComment: "UnableToAddComment",
    UnableToAddCommentOnOccupiedField: "UnableToAddCommentOnOccupiedField",
    UnableToAddConfiguration: "UnableToAddConfiguration",
    UnableToAddEvent: "UnableToAddEvent",
    UnableToAddIcon: "UnableToAddIcon",
    UnableToAddIncidentOnSelectedVehicle: "UnableToAddIncidentOnSelectedVehicle",
    UnableToAddInviteProgram: "UnableToAddInviteProgram",
    UnableToAddReferral: "UnableToAddReferral",
    UnableToAddReportSchema: "UnableToAddReportSchema",
    UnableToAddReservationDueToTooManyPendingReservations: "UnableToAddReservationDueToTooManyPendingReservations",
    UnableToAddReservationWIthoutDriver: "UnableToAddReservationWIthoutDriver",
    UnableToAddToUserDriverList: "UnableToAddToUserDriverList",
    UnableToAdjustCommissions: "UnableToAdjustCommissions",
    UnableToAssignDriverWhenChangingSharedMode: "UnableToAssignDriverWhenChangingSharedMode",
    UnableToCancelPayUOrder: "UnableToCancelPayUOrder",
    UnableToChangeComissionPercentSplitWhenPayoffsAreCreated: "UnableToChangeComissionPercentSplitWhenPayoffsAreCreated",
    UnableToChangeCommissionPercentSplitOnOwnerByCarrierOwnership: "UnableToChangeCommissionPercentSplitOnOwnerByCarrierOwnership",
    UnableToChangeCommissionsPercentSplitInStandardRent: "UnableToChangeCommissionsPercentSplitInStandardRent",
    UnableToChangeDriverOnSelectedVehicle: "UnableToChangeDriverOnSelectedVehicle",
    UnableToChangeDriversOwnershipInStandardRent: "UnableToChangeDriversOwnershipInStandardRent",
    UnableToChangeExistingVehicleIncidentType: "UnableToChangeExistingVehicleIncidentType",
    UnableToChangeIncidentTypeWhenItsRelatedWithVehicleLog: "UnableToChangeIncidentTypeWhenItsRelatedWithVehicleLog",
    UnableToChangePassword: "UnableToChangePassword",
    UnableToChangePaymentType: "UnableToChangePaymentType",
    UnableToChangePayoffReasonFrom: "UnableToChangePayoffReasonFrom",
    UnableToChangePayoffReasonTo: "UnableToChangePayoffReasonTo",
    UnableToChangeSharedVehicleDriverFromDashboard: "UnableToChangeSharedVehicleDriverFromDashboard",
    UnableToChangeStatus: "UnableToChangeStatus",
    UnableToChangeVehicleOwnershipWhenVehicleIsShared: "UnableToChangeVehicleOwnershipWhenVehicleIsShared",
    UnableToChangeVehicleTypeUntilIsShared: "UnableToChangeVehicleTypeUntilIsShared",
    UnableToChangeWorkshopDateIfReceiveFromWorkshopWasOnTheSameDay: "UnableToChangeWorkshopDateIfReceiveFromWorkshopWasOnTheSameDay",
    UnableToCheckOverdueReports: "UnableToCheckOverdueReports",
    UnableToCompareProtocols: "UnableToCompareProtocols",
    UnableToCreateDocument: "UnableToCreateDocument",
    UnableToCreateHrTag: "UnableToCreateHrTag",
    UnableToCreateOrganisationReport: "UnableToCreateOrganisationReport",
    UnableToCreatePayUOrder: "UnableToCreatePayUOrder",
    UnableToCreatePayoffsRollbacking: "UnableToCreatePayoffsRollbacking",
    UnableToCreateProofOfIncome: "UnableToCreateProofOfIncome",
    UnableToCreateResource: "UnableToCreateResource",
    UnableToCreateSettlementCashSettle: "UnableToCreateSettlementCashSettle",
    UnableToCreateSettlementsRollbacking: "UnableToCreateSettlementsRollbacking",
    UnableToCreateStatisticsSchema: "UnableToCreateStatisticsSchema",
    UnableToCreateUrlAddressForPayment: "UnableToCreateUrlAddressForPayment",
    UnableToCreateVehicleDocument: "UnableToCreateVehicleDocument",
    UnableToDeleteApplicationAccount: "UnableToDeleteApplicationAccount",
    UnableToDeleteCampaign: "UnableToDeleteCampaign",
    UnableToDeleteCashFlow: "UnableToDeleteCashFlow",
    UnableToDeleteConditionGroup: "UnableToDeleteConditionGroup",
    UnableToDeleteDocument: "UnableToDeleteDocument",
    UnableToDeleteDriver: "UnableToDeleteDriver",
    UnableToDeleteEvent: "UnableToDeleteEvent",
    UnableToDeleteHrTag: "UnableToDeleteHrTag",
    UnableToDeleteIcon: "UnableToDeleteIcon",
    UnableToDeleteIconSchema: "UnableToDeleteIconSchema",
    UnableToDeleteIncident: "UnableToDeleteIncident",
    UnableToDeleteInstallmentsSchema: "UnableToDeleteInstallmentsSchema",
    UnableToDeleteInviteProgram: "UnableToDeleteInviteProgram",
    UnableToDeleteOrganisation: "UnableToDeleteOrganisation",
    UnableToDeletePayoff: "UnableToDeletePayoff",
    UnableToDeleteReferral: "UnableToDeleteReferral",
    UnableToDeleteReportSchema: "UnableToDeleteReportSchema",
    UnableToDeleteResource: "UnableToDeleteResource",
    UnableToDeleteSettlement: "UnableToDeleteSettlement",
    UnableToDeleteSettlements: "UnableToDeleteSettlements",
    UnableToDeleteVehicle: "UnableToDeleteVehicle",
    UnableToDeleteVehicleDocument: "UnableToDeleteVehicleDocument",
    UnableToDownloadCurrentDocumentToSign: "UnableToDownloadCurrentDocumentToSign",
    UnableToDownloadFile: "UnableToDownloadFile",
    UnableToEdit: "UnableToEdit",
    UnableToEditFieldsUntilVehicleIsShared: "UnableToEditFieldsUntilVehicleIsShared",
    UnableToExportEquipmentReturnRequest: "UnableToExportEquipmentReturnRequest",
    UnableToExportSettlements: "UnableToExportSettlements",
    UnableToExportToPdfRequestForPaymentCommand: "UnableToExportToPdfRequestForPaymentCommand",
    UnableToFetchArticleGroupsDetails: "UnableToFetchArticleGroupsDetails",
    UnableToFetchBonusTaxRates: "UnableToFetchBonusTaxRates",
    UnableToFetchCampaigns: "UnableToFetchCampaigns",
    UnableToFetchCashFlowData: "UnableToFetchCashFlowData",
    UnableToFetchCashFlowList: "UnableToFetchCashFlowList",
    UnableToFetchDriverData: "UnableToFetchDriverData",
    UnableToFetchExportHistory: "UnableToFetchExportHistory",
    UnableToFetchInstallmentsSchemaData: "UnableToFetchInstallmentsSchemaData",
    UnableToFetchInstallmentsSchemaList: "UnableToFetchInstallmentsSchemaList",
    UnableToFetchOrganisationBalance: "UnableToFetchOrganisationBalance",
    UnableToFetchOrganisationsList: "UnableToFetchOrganisationsList",
    UnableToFetchPaymentSettings: "UnableToFetchPaymentSettings",
    UnableToFetchPayments: "UnableToFetchPayments",
    UnableToFetchPayoffs: "UnableToFetchPayoffs",
    UnableToFetchSettlementData: "UnableToFetchSettlementData",
    UnableToFetchSettlements: "UnableToFetchSettlements",
    UnableToFetchStatisticBundles: "UnableToFetchStatisticBundles",
    UnableToFetchStatistics: "UnableToFetchStatistics",
    UnableToFetchUserDetails: "UnableToFetchUserDetails",
    UnableToFetchVehicleLog: "UnableToFetchVehicleLog",
    UnableToFetchVehicleLogDetails: "UnableToFetchVehicleLogDetails",
    UnableToFetchWorkLogs: "UnableToFetchWorkLogs",
    UnableToFindDriversWithSelectedHrStatus: "UnableToFindDriversWithSelectedHrStatus",
    UnableToFindMailReceivers: "UnableToFindMailReceivers",
    UnableToFinishImportSettlementCreateProblem0: "UnableToFinishImportSettlementCreateProblem0",
    UnableToGenerateAboFile: "UnableToGenerateAboFile",
    UnableToGenerateInvoiceNumber: "UnableToGenerateInvoiceNumber",
    UnableToGenerateNewPassword: "UnableToGenerateNewPassword",
    UnableToGeneratePostOfficeBook: "UnableToGeneratePostOfficeBook",
    UnableToGenerateSettlementNumber: "UnableToGenerateSettlementNumber",
    UnableToGenerateSettlementNumberMissingOrganisationOrDriver: "UnableToGenerateSettlementNumberMissingOrganisationOrDriver",
    UnableToGenerateSmsCodeTryAgainLater: "UnableToGenerateSmsCodeTryAgainLater",
    UnableToGetApplicationAccounts: "UnableToGetApplicationAccounts",
    UnableToGetCashFlowsForSelectedReport: "UnableToGetCashFlowsForSelectedReport",
    UnableToGetCountries: "UnableToGetCountries",
    UnableToGetDocumentList: "UnableToGetDocumentList",
    UnableToGetDriverContactFormList: "UnableToGetDriverContactFormList",
    UnableToGetDrivers: "UnableToGetDrivers",
    UnableToGetFormNumber: "UnableToGetFormNumber",
    UnableToGetGusDataUntilIsManualEdit: "UnableToGetGusDataUntilIsManualEdit",
    UnableToGetGusServiceTryAgainLater: "UnableToGetGusServiceTryAgainLater",
    UnableToGetHrTagList: "UnableToGetHrTagList",
    UnableToGetIconSchemaList: "UnableToGetIconSchemaList",
    UnableToGetIncidentList: "UnableToGetIncidentList",
    UnableToGetMailList: "UnableToGetMailList",
    UnableToGetPaymentTypeHistory: "UnableToGetPaymentTypeHistory",
    UnableToGetReportBasicInfo: "UnableToGetReportBasicInfo",
    UnableToGetReportDetails: "UnableToGetReportDetails",
    UnableToGetReportList: "UnableToGetReportList",
    UnableToGetReportOverdueStatus: "UnableToGetReportOverdueStatus",
    UnableToGetReportSchemaList: "UnableToGetReportSchemaList",
    UnableToGetResourceList: "UnableToGetResourceList",
    UnableToGetSearchResults: "UnableToGetSearchResults",
    UnableToGetShortStatistics: "UnableToGetShortStatistics",
    UnableToGetVehicleDocumentList: "UnableToGetVehicleDocumentList",
    UnableToLoadPreview: "UnableToLoadPreview",
    UnableToMassRemoveDriversFromSII: "UnableToMassRemoveDriversFromSII",
    UnableToMassReportDriversToSII: "UnableToMassReportDriversToSII",
    UnableToMassSetVehiclesCommission: "UnableToMassSetVehiclesCommission",
    UnableToModifyRelatedIncidentType: "UnableToModifyRelatedIncidentType",
    UnableToReadProtocolsData: "UnableToReadProtocolsData",
    UnableToRecoverPayoff: "UnableToRecoverPayoff",
    UnableToRecoverSettlement: "UnableToRecoverSettlement",
    UnableToRemoveContact: "UnableToRemoveContact",
    UnableToRemoveDriverFromEmptyVehicle: "UnableToRemoveDriverFromEmptyVehicle",
    UnableToRemoveFromUserDriverList: "UnableToRemoveFromUserDriverList",
    UnableToRemoveOnlinePaymentBecauseBonusIsAlreadyPaidPartiallyOrTotal: "UnableToRemoveOnlinePaymentBecauseBonusIsAlreadyPaidPartiallyOrTotal",
    UnableToRemovePaymentBecauseUserHaveNoPermissionToRemovePayUPayoffs: "UnableToRemovePaymentBecauseUserHaveNoPermissionToRemovePayUPayoffs",
    UnableToRemoveStatisticCard: "UnableToRemoveStatisticCard",
    UnableToRestoreDocumentIsAlreadyExistsInQueueToSign: "UnableToRestoreDocumentIsAlreadyExistsInQueueToSign",
    UnableToRestoreOnlinePaymentPayoff: "UnableToRestoreOnlinePaymentPayoff",
    UnableToRestoreReferralPayoff: "UnableToRestoreReferralPayoff",
    UnableToRestoreReportSchema: "UnableToRestoreReportSchema",
    UnableToRestoreResource: "UnableToRestoreResource",
    UnableToSaveApplicationAccount: "UnableToSaveApplicationAccount",
    UnableToSaveCashFlow: "UnableToSaveCashFlow",
    UnableToSaveComment: "UnableToSaveComment",
    UnableToSaveDriver: "UnableToSaveDriver",
    UnableToSaveFile: "UnableToSaveFile",
    UnableToSaveIconSchema: "UnableToSaveIconSchema",
    UnableToSaveInstallmentSchema: "UnableToSaveInstallmentSchema",
    UnableToSaveOrganisation: "UnableToSaveOrganisation",
    UnableToSavePayment: "UnableToSavePayment",
    UnableToSavePaymentSettings: "UnableToSavePaymentSettings",
    UnableToSavePayoff: "UnableToSavePayoff",
    UnableToSavePayoffWithSelectedReasonAndCheckboxSelected: "UnableToSavePayoffWithSelectedReasonAndCheckboxSelected",
    UnableToSavePit11: "UnableToSavePit11",
    UnableToSaveSchema: "UnableToSaveSchema",
    UnableToSaveSettlement: "UnableToSaveSettlement",
    UnableToSaveUser: "UnableToSaveUser",
    UnableToSaveVehicle: "UnableToSaveVehicle",
    UnableToSendAttachmentToDriver: "UnableToSendAttachmentToDriver",
    UnableToSendEmail: "UnableToSendEmail",
    UnableToSendEmails: "UnableToSendEmails",
    UnableToSendReport: "UnableToSendReport",
    UnableToSent: "UnableToSent",
    UnableToSetManualEdit: "UnableToSetManualEdit",
    UnableToUpdateActiveStatus: "UnableToUpdateActiveStatus",
    UnableToUpdateApplicationAccountActivityRollbacking: "UnableToUpdateApplicationAccountActivityRollbacking",
    UnableToUpdateBonusVatRates: "UnableToUpdateBonusVatRates",
    UnableToUpdateDocument: "UnableToUpdateDocument",
    UnableToUpdateDriverStatus: "UnableToUpdateDriverStatus",
    UnableToUpdateHrTag: "UnableToUpdateHrTag",
    UnableToUpdateInviteProgram: "UnableToUpdateInviteProgram",
    UnableToUpdateMailRule: "UnableToUpdateMailRule",
    UnableToUpdatePaymentType: "UnableToUpdatePaymentType",
    UnableToUpdateReferral: "UnableToUpdateReferral",
    UnableToUpdateReport: "UnableToUpdateReport",
    UnableToUpdateReportMissingReceiver: "UnableToUpdateReportMissingReceiver",
    UnableToUpdateReportSchema: "UnableToUpdateReportSchema",
    UnableToUpdateResource: "UnableToUpdateResource",
    UnableToUpdateSettlementPaymentStatus: "UnableToUpdateSettlementPaymentStatus",
    UnableToUpdateSettlementsRollbacking: "UnableToUpdateSettlementsRollbacking",
    UnableToUpdateSharedCommissionForVehicleTypeDifferentThanCar: "UnableToUpdateSharedCommissionForVehicleTypeDifferentThanCar",
    UnableToUpdateStatisticsSchema: "UnableToUpdateStatisticsSchema",
    UnableToUpdateVehicleDocument: "UnableToUpdateVehicleDocument",
    UnableToUpdateVehicleHistory: "UnableToUpdateVehicleHistory",
    UnableToUpdateVehicleLogComment: "UnableToUpdateVehicleLogComment",
    UnableToUseSmsApi: "UnableToUseSmsApi",
    UnableToVerifyFile: "UnableToVerifyFile",
    Unavailable: "Unavailable",
    Unbranded: "Unbranded",
    Undefined: "Undefined",
    UndefinedSettlementAssignedAutomatically: "UndefinedSettlementAssignedAutomatically",
    UndefinedSettlementListDescription: "UndefinedSettlementListDescription",
    UndefinedSettlementsMatchingMultipleDrivers: "UndefinedSettlementsMatchingMultipleDrivers",
    UnderOrEqualTwentySixYears: "UnderOrEqualTwentySixYears",
    UnexpectedErrorRollbacking: "UnexpectedErrorRollbacking",
    UnfinishedVehicleRentPaperWorkAlert: "UnfinishedVehicleRentPaperWorkAlert",
    UnknownLocation: "UnknownLocation",
    UnknownValue: "UnknownValue",
    UnlinkedDriversFromCurrentVehicle: "UnlinkedDriversFromCurrentVehicle",
    Unlock: "Unlock",
    Unread: "Unread",
    UnsavedChanges: "UnsavedChanges",
    UnsavedChangesMessage: "UnsavedChangesMessage",
    UnsupportedDailyImportForSelectedApplication: "UnsupportedDailyImportForSelectedApplication",
    UntilWhenIsBanned: "UntilWhenIsBanned",
    UnvalidatedContractOfMandate: "UnvalidatedContractOfMandate",
    UnvalidatedStudentStatus: "UnvalidatedStudentStatus",
    Upcome: "Upcome",
    UpdateDataFromGUS: "UpdateDataFromGUS",
    UpdatedBy: "UpdatedBy",
    UpdatedDate: "UpdatedDate",
    UpdatedSettlements: "UpdatedSettlements",
    UpdatingDriverSubjectFromGus: "UpdatingDriverSubjectFromGus",
    UpdatingDriverSubjectFromGusConfirm: "UpdatingDriverSubjectFromGusConfirm",
    UploadCsvFile: "UploadCsvFile",
    UploadPermissionMaxFiles: "UploadPermissionMaxFiles",
    UploadStudentCard: "UploadStudentCard",
    UsageAssistant: "UsageAssistant",
    UsageHistory: "UsageHistory",
    UsageReserveFrom: "UsageReserveFrom",
    UsageReserveUsed: "UsageReserveUsed",
    UsageTotal: "UsageTotal",
    UseCompanyApplicationAccount: "UseCompanyApplicationAccount",
    UseCompanyApplicationAccountDescription: "UseCompanyApplicationAccountDescription",
    UseCompanyVehicle: "UseCompanyVehicle",
    UseCompanyVehicleDescription: "UseCompanyVehicleDescription",
    Used: "Used",
    User: "User",
    UserChoice: "UserChoice",
    UserCreate: "UserCreate",
    UserDelete: "UserDelete",
    UserDeleteMessage: "UserDeleteMessage",
    UserEdit: "UserEdit",
    UserGaveVehicleToDriver: "UserGaveVehicleToDriver",
    UserGaveVehicleToDrivers: "UserGaveVehicleToDrivers",
    UserNotFound: "UserNotFound",
    UserReceivedVahicleFromDriver: "UserReceivedVahicleFromDriver",
    UserReceivedVehicleFromDrivers: "UserReceivedVehicleFromDrivers",
    Users: "Users",
    VIN: "VIN",
    ValidFrom: "ValidFrom",
    ValidTo: "ValidTo",
    ValidatedContractOfMandate: "ValidatedContractOfMandate",
    ValidatedStudentStatus: "ValidatedStudentStatus",
    ValidationErrorCheckCorrectnessOfYourFields: "ValidationErrorCheckCorrectnessOfYourFields",
    Value: "Value",
    ValueCannotBeLowerThan: "ValueCannotBeLowerThan",
    ValueMustBeAnInteger: "ValueMustBeAnInteger",
    ValueMustBeGreaterThan: "ValueMustBeGreaterThan",
    Vat23: "Vat23",
    Vat8: "Vat8",
    VatAmount: "VatAmount",
    VatInvoice: "VatInvoice",
    VatStatement: "VatStatement",
    VatValueInPercent: "VatValueInPercent",
    VehicalRentalEnd: "VehicalRentalEnd",
    VehicalRentalStart: "VehicalRentalStart",
    VehicalRentalStartMailTypeInfo: "VehicalRentalStartMailTypeInfo",
    Vehicle: "Vehicle",
    VehicleBodyItem: "VehicleBodyItem",
    VehicleBusyMessage: "VehicleBusyMessage",
    VehicleCharger: "VehicleCharger",
    VehicleConditionOnStartRenting: "VehicleConditionOnStartRenting",
    VehicleCreate: "VehicleCreate",
    VehicleDashboard: "VehicleDashboard",
    VehicleDefects: "VehicleDefects",
    VehicleDelete: "VehicleDelete",
    VehicleDeleteMessage: "VehicleDeleteMessage",
    VehicleDocumentDoesNotExist: "VehicleDocumentDoesNotExist",
    VehicleDocuments: "VehicleDocuments",
    VehicleDriverCommissionSumMustBeEqual0Percent: "VehicleDriverCommissionSumMustBeEqual0Percent",
    VehicleEdit: "VehicleEdit",
    VehicleFounder: "VehicleFounder",
    VehicleFromSettlement: "VehicleFromSettlement",
    VehicleFromSettlementRentingDays: "VehicleFromSettlementRentingDays",
    VehicleHasAlreadySelectedDriver: "VehicleHasAlreadySelectedDriver",
    VehicleHasNoCashbackConfiguredCannotPartiallyUpdate: "VehicleHasNoCashbackConfiguredCannotPartiallyUpdate",
    VehicleHistory: "VehicleHistory",
    VehicleIncidentOrderDescription: "VehicleIncidentOrderDescription",
    VehicleIncidentOrderIntro: "VehicleIncidentOrderIntro",
    VehicleIncidentOrderShortDescription: "VehicleIncidentOrderShortDescription",
    VehicleIncidentOrderTitle: "VehicleIncidentOrderTitle",
    VehicleIncidentType: "VehicleIncidentType",
    VehicleIncidentTypeTitle: "VehicleIncidentTypeTitle",
    VehicleLogAdditionalFilterDateTutorial: "VehicleLogAdditionalFilterDateTutorial",
    VehicleLogAdditionalFilterTypeTutorial: "VehicleLogAdditionalFilterTypeTutorial",
    VehicleLogAdditionalFiltersSortingTutorial: "VehicleLogAdditionalFiltersSortingTutorial",
    VehicleLogEvent: "VehicleLogEvent",
    VehicleLogHierarchyHint: "VehicleLogHierarchyHint",
    VehicleLogHierarchyShortHint: "VehicleLogHierarchyShortHint",
    VehicleLogHierarchyTitle: "VehicleLogHierarchyTitle",
    VehicleLogIcidentHint: "VehicleLogIcidentHint",
    VehicleLogIconHint: "VehicleLogIconHint",
    VehicleLogIconShortHint: "VehicleLogIconShortHint",
    VehicleLogIncidentHint: "VehicleLogIncidentHint",
    VehicleLogIncidentShortHint: "VehicleLogIncidentShortHint",
    VehicleLogIncidentTypeIntro: "VehicleLogIncidentTypeIntro",
    VehicleLogIncidentTypeReceiveFromWorkshopDescription: "VehicleLogIncidentTypeReceiveFromWorkshopDescription",
    VehicleLogIncidentTypeReceiveFromWorkshopShortDescription: "VehicleLogIncidentTypeReceiveFromWorkshopShortDescription",
    VehicleLogIncidentTypeReservationDescription: "VehicleLogIncidentTypeReservationDescription",
    VehicleLogIncidentTypeReservationShortDescription: "VehicleLogIncidentTypeReservationShortDescription",
    VehicleLogIncidentTypeTheftDescription: "VehicleLogIncidentTypeTheftDescription",
    VehicleLogIncidentTypeTheftShortDescription: "VehicleLogIncidentTypeTheftShortDescription",
    VehicleLogIncidentTypeWorkshopDescription: "VehicleLogIncidentTypeWorkshopDescription",
    VehicleLogIncidentTypeWorkshopShortDescription: "VehicleLogIncidentTypeWorkshopShortDescription",
    VehicleLogNotFound: "VehicleLogNotFound",
    VehicleLogSettings: "VehicleLogSettings",
    VehicleMode: "VehicleMode",
    VehicleName: "VehicleName",
    VehicleNotFound: "VehicleNotFound",
    VehicleOrDriverNotFound: "VehicleOrDriverNotFound",
    VehicleOrEquipmentDamage: "VehicleOrEquipmentDamage",
    VehicleOrganisation: "VehicleOrganisation",
    VehicleOtherHint: "VehicleOtherHint",
    VehicleOwnership: "VehicleOwnership",
    VehicleOwnershipMustBeSetInSharedMode: "VehicleOwnershipMustBeSetInSharedMode",
    VehicleReadyToCollect: "VehicleReadyToCollect",
    VehicleReadyToCollectAlert: "VehicleReadyToCollectAlert",
    VehicleRegistrationDate: "VehicleRegistrationDate",
    VehicleRent: "VehicleRent",
    VehicleRentInformation: "VehicleRentInformation",
    VehicleRentMailTitle: "VehicleRentMailTitle",
    VehicleRental: "VehicleRental",
    VehicleReservation: "VehicleReservation",
    VehicleReservations: "VehicleReservations",
    VehicleReturn: "VehicleReturn",
    VehicleShareMode: "VehicleShareMode",
    VehicleShareModeChangeAlert: "VehicleShareModeChangeAlert",
    VehicleShared: "VehicleShared",
    VehicleSharingModeInfoAlert: "VehicleSharingModeInfoAlert",
    VehicleState: "VehicleState",
    VehicleType: "VehicleType",
    VehicleTypeIncludedInDrivingLicenseVerification: "VehicleTypeIncludedInDrivingLicenseVerification",
    VehicleUnavailable: "VehicleUnavailable",
    Vehicles: "Vehicles",
    VehiclesCommissionsCount: "VehiclesCommissionsCount",
    VehiclesCommissionsPerOrganisation: "VehiclesCommissionsPerOrganisation",
    VehiclesIncidents: "VehiclesIncidents",
    VehiclesLog: "VehiclesLog",
    VehiclesPayment: "VehiclesPayment",
    VehiclesRentState: "VehiclesRentState",
    VendorAddress: "VendorAddress",
    VendorKrs: "VendorKrs",
    VendorName: "VendorName",
    VendorNip: "VendorNip",
    VendorRegon: "VendorRegon",
    VerificationRejectedInCepik: "VerificationRejectedInCepik",
    VerificationStatus: "VerificationStatus",
    Verified: "Verified",
    VerifiedInCepik: "VerifiedInCepik",
    VerifyYourPhotoBeforeAdd: "VerifyYourPhotoBeforeAdd",
    View: "View",
    VinMustHaveCorrectFormat: "VinMustHaveCorrectFormat",
    VisInspectionDate: "VisInspectionDate",
    Voivodeship: "Voivodeship",
    Waiting: "Waiting",
    WaitingDocumentsForSignature: "WaitingDocumentsForSignature",
    WaitingForAccountsActivation: "WaitingForAccountsActivation",
    WaitingForSignature: "WaitingForSignature",
    WaitingReportListDescription: "WaitingReportListDescription",
    WaitingReportsReportListDescription: "WaitingReportsReportListDescription",
    WaitingSettlementListDescription: "WaitingSettlementListDescription",
    WantToRentFromCarrier: "WantToRentFromCarrier",
    WantToWorkOnFleetCar: "WantToWorkOnFleetCar",
    WarminskoMazurskie: "WarminskoMazurskie",
    Warning: "Warning",
    WarningStatusDescription: "WarningStatusDescription",
    WarningTriangle: "WarningTriangle",
    WaterProofPhoneBag: "WaterProofPhoneBag",
    Wear: "Wear",
    Wednesday: "Wednesday",
    WeekName: "WeekName",
    Weekly: "Weekly",
    WeeklySettlementsQuantity: "WeeklySettlementsQuantity",
    Weeks: "Weeks",
    Welcome: "Welcome",
    WhatPromissoryNoteInclude: "WhatPromissoryNoteInclude",
    WhenApplicationNoneIsSelectedYouCannotSelectOthers: "WhenApplicationNoneIsSelectedYouCannotSelectOthers",
    WhenPayoffIsDailyFeeOneOfCommissonMustBeSelected: "WhenPayoffIsDailyFeeOneOfCommissonMustBeSelected",
    WhetherToChargeHimForTheDay: "WhetherToChargeHimForTheDay",
    WhetherToChargeTheyForTheDay: "WhetherToChargeTheyForTheDay",
    WhichRecordsIncludeInCampaign: "WhichRecordsIncludeInCampaign",
    WhistleBlowerStatement: "WhistleBlowerStatement",
    Wielkopolskie: "Wielkopolskie",
    WillIssueAnInvoice: "WillIssueAnInvoice",
    WirelessWithRemoteControl: "WirelessWithRemoteControl",
    Withdraw: "Withdraw",
    WithdrawBlockReason: "WithdrawBlockReason",
    WithdrawBlockReasonBailiff: "WithdrawBlockReasonBailiff",
    WithdrawBlockReasonExpiredStudentCard: "WithdrawBlockReasonExpiredStudentCard",
    WithdrawBlockReasonInactive: "WithdrawBlockReasonInactive",
    WithdrawBlockReasonMissingFilesAfterRegistration: "WithdrawBlockReasonMissingFilesAfterRegistration",
    WithdrawBlockReasonMissingSelfInvoicingPermission: "WithdrawBlockReasonMissingSelfInvoicingPermission",
    WithdrawBlockReasonMissingTaxQualification: "WithdrawBlockReasonMissingTaxQualification",
    WithdrawBlockReasonOfficeDecision: "WithdrawBlockReasonOfficeDecision",
    WithdrawType: "WithdrawType",
    WithoutDaily: "WithoutDaily",
    WithoutPayout: "WithoutPayout",
    WithoutPayoutTagDescription: "WithoutPayoutTagDescription",
    WorkCountry: "WorkCountry",
    WorkLegalizationProcess: "WorkLegalizationProcess",
    WorkLog: "WorkLog",
    WorkPermit: "WorkPermit",
    WorkPermitRequired: "WorkPermitRequired",
    Working: "Working",
    WorkingByMoreThanHalf: "WorkingByMoreThanHalf",
    WorkingByMoreThanOneDay: "WorkingByMoreThanOneDay",
    WorkingOnFleetCar: "WorkingOnFleetCar",
    WorkingPeriodFilters: "WorkingPeriodFilters",
    WorkingPeriodFiltersDescription: "WorkingPeriodFiltersDescription",
    WorkingTimeType: "WorkingTimeType",
    Workshop: "Workshop",
    WorkshopName: "WorkshopName",
    WorkshopSampleCell: "WorkshopSampleCell",
    WorkshopShortName: "WorkshopShortName",
    WorkshopWithShortName: "WorkshopWithShortName",
    Workshops: "Workshops",
    WrongEmailOrPassword: "WrongEmailOrPassword",
    WrongLoginOrPassword: "WrongLoginOrPassword",
    Year: "Year",
    Yes: "Yes",
    YouCannotHaveMoreThanOneOpenedWorkshop: "YouCannotHaveMoreThanOneOpenedWorkshop",
    YouCannotIssueInvoiceForDebtors: "YouCannotIssueInvoiceForDebtors",
    YouCannotUpdateDiscountedCommissionsForSharedVehicle: "YouCannotUpdateDiscountedCommissionsForSharedVehicle",
    YouCantAssignDriverOnTheftOrWorkshopVehicle: "YouCantAssignDriverOnTheftOrWorkshopVehicle",
    YouCantResendReport: "YouCantResendReport",
    YouDontHavePermissionToUnlockIt: "YouDontHavePermissionToUnlockIt",
    YouDontHavePermissionsToSaveResourceCashFlowWIthPositiveValue: "YouDontHavePermissionsToSaveResourceCashFlowWIthPositiveValue",
    YouHaveOverdueReportsToCompleteRememberToDoThisToday: "YouHaveOverdueReportsToCompleteRememberToDoThisToday",
    YouHaveRestOfCashGivenByDriver: "YouHaveRestOfCashGivenByDriver",
    YouHaveSimilarRequestForSelectedDate: "YouHaveSimilarRequestForSelectedDate",
    YouHaveWaitingSettlementsAndTheNearestBankSessionIsOn: "YouHaveWaitingSettlementsAndTheNearestBankSessionIsOn",
    YouHaveWaitingSettlementsFromYesterdayCompleteItAsFastAsPossible: "YouHaveWaitingSettlementsFromYesterdayCompleteItAsFastAsPossible",
    YouMustCloseTheOpenWorkshopBeforeAddingCurrentIncident: "YouMustCloseTheOpenWorkshopBeforeAddingCurrentIncident",
    YouMustProvideAtLeastPlMessageLanguageVariant: "YouMustProvideAtLeastPlMessageLanguageVariant",
    YouMustSelectAdvancePaymentType: "YouMustSelectAdvancePaymentType",
    YouMustSelectResourceWhenPayoffReasonIsResourceConsumption: "YouMustSelectResourceWhenPayoffReasonIsResourceConsumption",
    YouMustSelectedPaymentType: "YouMustSelectedPaymentType",
    YouMustSpecifyMinimumTwoDriversInShareMode: "YouMustSpecifyMinimumTwoDriversInShareMode",
    YouMustSpecifyVehicleOwnershipOnChangingVehicleSharedMode: "YouMustSpecifyVehicleOwnershipOnChangingVehicleSharedMode",
    YourNotifications: "YourNotifications",
    YourSetup: "YourSetup",
    Zachodniopomorskie: "Zachodniopomorskie",
    f: "f"
}